//
// THIS FILE IS GENERATED DO NOT EDIT!
// DO NOT MODIFY BY HAND!
// @eapcj THANKS YOU!
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type EntireFieldWrapper<T> = T;
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bigint: any;
  citext: any;
  date: any;
  float8: any;
  numeric: any;
  timestamp: any;
  timestamptz: string;
  timetz: any;
  uuid: string;
}


/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export interface StudentOrParentBooleanComparisonExp {
  _eq?: Maybe<Scalars['Boolean']>;
  _gt?: Maybe<Scalars['Boolean']>;
  _gte?: Maybe<Scalars['Boolean']>;
  _in?: Maybe<Array<Scalars['Boolean']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Boolean']>;
  _lte?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<Scalars['Boolean']>;
  _nin?: Maybe<Array<Scalars['Boolean']>>;
}

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export interface StudentOrParentIntComparisonExp {
  _eq?: Maybe<Scalars['Int']>;
  _gt?: Maybe<Scalars['Int']>;
  _gte?: Maybe<Scalars['Int']>;
  _in?: Maybe<Array<Scalars['Int']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['Int']>;
  _lte?: Maybe<Scalars['Int']>;
  _neq?: Maybe<Scalars['Int']>;
  _nin?: Maybe<Array<Scalars['Int']>>;
}

export interface StudentOrParentInviteParentInput {
  class_id?: Maybe<Scalars['String']>;
}

export interface StudentOrParentInviteStudentClassInsertInput {
  class_id: Scalars['String'];
  parent_id?: Maybe<Scalars['String']>;
}

export interface StudentOrParentMessageResponse {
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

export interface StudentOrParentSession {
  directus_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_expires_in?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  jwt_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  message?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export interface StudentOrParentStringComparisonExp {
  _eq?: Maybe<Scalars['String']>;
  _gt?: Maybe<Scalars['String']>;
  _gte?: Maybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['String']>;
  _in?: Maybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['String']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['String']>;
  _lt?: Maybe<Scalars['String']>;
  _lte?: Maybe<Scalars['String']>;
  _neq?: Maybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['String']>;
  _nin?: Maybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['String']>;
}

export interface StudentOrParentUserData {
  assignments?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  birthday_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  chat?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  email: EntireFieldWrapper<Scalars['String']>;
  first_name: EntireFieldWrapper<Scalars['String']>;
  grading?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  is_verified?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  live_class?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  mobile?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street_address?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

export interface StudentOrParentUserInsertInput {
  avatar_url?: Maybe<Scalars['String']>;
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  title?: Maybe<Scalars['String']>;
}

/** columns and relationships of "assignment_attendee_type" */
export interface StudentOrParentAssignmentAttendeeType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrParentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrParentAssignmentsAggregate>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  value: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface StudentOrParentAssignmentAttendeeTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


/** columns and relationships of "assignment_attendee_type" */
export interface StudentOrParentAssignmentAttendeeTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_attendee_type". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAssignmentAttendeeTypeBoolExp {
  _and?: Maybe<Array<StudentOrParentAssignmentAttendeeTypeBoolExp>>;
  _not?: Maybe<StudentOrParentAssignmentAttendeeTypeBoolExp>;
  _or?: Maybe<Array<StudentOrParentAssignmentAttendeeTypeBoolExp>>;
  assignments?: Maybe<StudentOrParentAssignmentsBoolExp>;
  comment?: Maybe<StudentOrParentStringComparisonExp>;
  value?: Maybe<StudentOrParentStringComparisonExp>;
}

export const enum StudentOrParentAssignmentAttendeeTypeEnum {
  CLASS = 'CLASS',
  USER = 'USER'
};

/** Boolean expression to compare columns of type "assignment_attendee_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrParentAssignmentAttendeeTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrParentAssignmentAttendeeTypeEnum>;
  _in?: Maybe<Array<StudentOrParentAssignmentAttendeeTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrParentAssignmentAttendeeTypeEnum>;
  _nin?: Maybe<Array<StudentOrParentAssignmentAttendeeTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_attendee_type". */
export interface StudentOrParentAssignmentAttendeeTypeOrderBy {
  assignments_aggregate?: Maybe<StudentOrParentAssignmentsAggregateOrderBy>;
  comment?: Maybe<StudentOrParentOrderBy>;
  value?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "assignment_attendee_type" */
export const enum StudentOrParentAssignmentAttendeeTypeSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "assignment_book_chapter" */
export interface StudentOrParentAssignmentBookChapter {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrParentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<StudentOrParentBookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "assignment_book_chapter" */
export interface StudentOrParentAssignmentBookChapterAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentAssignmentBookChapterMaxOrderBy>;
  min?: Maybe<StudentOrParentAssignmentBookChapterMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_book_chapter". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAssignmentBookChapterBoolExp {
  _and?: Maybe<Array<StudentOrParentAssignmentBookChapterBoolExp>>;
  _not?: Maybe<StudentOrParentAssignmentBookChapterBoolExp>;
  _or?: Maybe<Array<StudentOrParentAssignmentBookChapterBoolExp>>;
  assignment?: Maybe<StudentOrParentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrParentUuidComparisonExp>;
  book_chapter?: Maybe<StudentOrParentBookChaptersBoolExp>;
  book_chapter_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "assignment_book_chapter" */
export interface StudentOrParentAssignmentBookChapterMaxOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  book_chapter_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "assignment_book_chapter" */
export interface StudentOrParentAssignmentBookChapterMinOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  book_chapter_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "assignment_book_chapter". */
export interface StudentOrParentAssignmentBookChapterOrderBy {
  assignment?: Maybe<StudentOrParentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  book_chapter?: Maybe<StudentOrParentBookChaptersOrderBy>;
  book_chapter_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "assignment_book_chapter" */
export const enum StudentOrParentAssignmentBookChapterSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Possible values for assisgment grade weights.
 *
 *
 * columns and relationships of "assignment_grade_weights"
 */
export interface StudentOrParentAssignmentGradeWeights {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  value: EntireFieldWrapper<Scalars['numeric']>;
}

/** aggregated selection of "assignment_grade_weights" */
export interface StudentOrParentAssignmentGradeWeightsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentAssignmentGradeWeights>>;
}

/** aggregate fields of "assignment_grade_weights" */
export interface StudentOrParentAssignmentGradeWeightsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeightsVarianceFields>>;
}


/** aggregate fields of "assignment_grade_weights" */
export interface StudentOrParentAssignmentGradeWeightsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentAssignmentGradeWeightsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** aggregate avg on columns */
export interface StudentOrParentAssignmentGradeWeightsAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** Boolean expression to filter rows from the table "assignment_grade_weights". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAssignmentGradeWeightsBoolExp {
  _and?: Maybe<Array<StudentOrParentAssignmentGradeWeightsBoolExp>>;
  _not?: Maybe<StudentOrParentAssignmentGradeWeightsBoolExp>;
  _or?: Maybe<Array<StudentOrParentAssignmentGradeWeightsBoolExp>>;
  comment?: Maybe<StudentOrParentStringComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  value?: Maybe<StudentOrParentNumericComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrParentAssignmentGradeWeightsMaxFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate min on columns */
export interface StudentOrParentAssignmentGradeWeightsMinFields {
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** Ordering options when selecting data from "assignment_grade_weights". */
export interface StudentOrParentAssignmentGradeWeightsOrderBy {
  comment?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  value?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "assignment_grade_weights" */
export const enum StudentOrParentAssignmentGradeWeightsSelectColumn {
  /** column name */
  COMMENT = 'comment',
  /** column name */
  ID = 'id',
  /** column name */
  VALUE = 'value'
};

/** aggregate stddev on columns */
export interface StudentOrParentAssignmentGradeWeightsStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrParentAssignmentGradeWeightsStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrParentAssignmentGradeWeightsStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate sum on columns */
export interface StudentOrParentAssignmentGradeWeightsSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
}

/** aggregate var_pop on columns */
export interface StudentOrParentAssignmentGradeWeightsVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate var_samp on columns */
export interface StudentOrParentAssignmentGradeWeightsVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** aggregate variance on columns */
export interface StudentOrParentAssignmentGradeWeightsVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface StudentOrParentAssignmentSubmits {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrParentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  completed_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  content?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamp']>;
  file?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrParentFiles>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_submited: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/**
 * Used to track assignment submits.
 *
 *
 * columns and relationships of "assignment_submits"
 */
export interface StudentOrParentAssignmentSubmitsFilesArgs {
  distinct_on?: Maybe<Array<StudentOrParentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentFilesOrderBy>>;
  where?: Maybe<StudentOrParentFilesBoolExp>;
}

/** order by aggregate values of table "assignment_submits" */
export interface StudentOrParentAssignmentSubmitsAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentAssignmentSubmitsMaxOrderBy>;
  min?: Maybe<StudentOrParentAssignmentSubmitsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_submits". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAssignmentSubmitsBoolExp {
  _and?: Maybe<Array<StudentOrParentAssignmentSubmitsBoolExp>>;
  _not?: Maybe<StudentOrParentAssignmentSubmitsBoolExp>;
  _or?: Maybe<Array<StudentOrParentAssignmentSubmitsBoolExp>>;
  assignment?: Maybe<StudentOrParentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrParentUuidComparisonExp>;
  completed_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  content?: Maybe<StudentOrParentStringComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestampComparisonExp>;
  file?: Maybe<StudentOrParentStringComparisonExp>;
  files?: Maybe<StudentOrParentFilesBoolExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_submited?: Maybe<StudentOrParentBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** order by max() on columns of table "assignment_submits" */
export interface StudentOrParentAssignmentSubmitsMaxOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  completed_at?: Maybe<StudentOrParentOrderBy>;
  content?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  file?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "assignment_submits" */
export interface StudentOrParentAssignmentSubmitsMinOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  completed_at?: Maybe<StudentOrParentOrderBy>;
  content?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  file?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "assignment_submits". */
export interface StudentOrParentAssignmentSubmitsOrderBy {
  assignment?: Maybe<StudentOrParentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  completed_at?: Maybe<StudentOrParentOrderBy>;
  content?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  file?: Maybe<StudentOrParentOrderBy>;
  files_aggregate?: Maybe<StudentOrParentFilesAggregateOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_submited?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "assignment_submits" */
export const enum StudentOrParentAssignmentSubmitsSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMPLETED_AT = 'completed_at',
  /** column name */
  CONTENT = 'content',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE = 'file',
  /** column name */
  ID = 'id',
  /** column name */
  IS_SUBMITED = 'is_submited',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignment_type" */
export interface StudentOrParentAssignmentType {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrParentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrParentAssignmentsAggregate>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "assignment_type" */
export interface StudentOrParentAssignmentTypeAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


/** columns and relationships of "assignment_type" */
export interface StudentOrParentAssignmentTypeAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}

/** Boolean expression to filter rows from the table "assignment_type". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAssignmentTypeBoolExp {
  _and?: Maybe<Array<StudentOrParentAssignmentTypeBoolExp>>;
  _not?: Maybe<StudentOrParentAssignmentTypeBoolExp>;
  _or?: Maybe<Array<StudentOrParentAssignmentTypeBoolExp>>;
  assignments?: Maybe<StudentOrParentAssignmentsBoolExp>;
  icon?: Maybe<StudentOrParentStringComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
}

export const enum StudentOrParentAssignmentTypeEnum {
  HAUSAUFGABE = 'HAUSAUFGABE',
  KLASSENARBEIT = 'KLASSENARBEIT',
  MATERIAL = 'MATERIAL',
  ONLINE = 'ONLINE',
  PRUFUNG = 'PRUFUNG',
  QUIZ = 'QUIZ',
  STUDY = 'STUDY',
  TASK = 'TASK'
};

/** Boolean expression to compare columns of type "assignment_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrParentAssignmentTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrParentAssignmentTypeEnum>;
  _in?: Maybe<Array<StudentOrParentAssignmentTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrParentAssignmentTypeEnum>;
  _nin?: Maybe<Array<StudentOrParentAssignmentTypeEnum>>;
}

/** Ordering options when selecting data from "assignment_type". */
export interface StudentOrParentAssignmentTypeOrderBy {
  assignments_aggregate?: Maybe<StudentOrParentAssignmentsAggregateOrderBy>;
  icon?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "assignment_type" */
export const enum StudentOrParentAssignmentTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/**
 * All users that assignment is assigned to and the table that teachers insert grades for each of them
 *
 *
 * columns and relationships of "assignment_user"
 */
export interface StudentOrParentAssignmentUser {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrParentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<StudentOrParentMarks>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "assignment_user" */
export interface StudentOrParentAssignmentUserAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentAssignmentUserMaxOrderBy>;
  min?: Maybe<StudentOrParentAssignmentUserMinOrderBy>;
}

/** Boolean expression to filter rows from the table "assignment_user". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAssignmentUserBoolExp {
  _and?: Maybe<Array<StudentOrParentAssignmentUserBoolExp>>;
  _not?: Maybe<StudentOrParentAssignmentUserBoolExp>;
  _or?: Maybe<Array<StudentOrParentAssignmentUserBoolExp>>;
  assignment?: Maybe<StudentOrParentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  mark?: Maybe<StudentOrParentMarksBoolExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** order by max() on columns of table "assignment_user" */
export interface StudentOrParentAssignmentUserMaxOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "assignment_user" */
export interface StudentOrParentAssignmentUserMinOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "assignment_user". */
export interface StudentOrParentAssignmentUserOrderBy {
  assignment?: Maybe<StudentOrParentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  mark?: Maybe<StudentOrParentMarksOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "assignment_user" */
export const enum StudentOrParentAssignmentUserSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "assignments" */
export interface StudentOrParentAssignments {
  /** An object relationship */
  assignmentAttendeeType?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentAttendeeType>>;
  assignment_attendee_type?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentAttendeeTypeEnum>>;
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<StudentOrParentAssignmentBookChapter>>;
  /** An object relationship */
  assignment_grade_weight?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeights>>;
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<StudentOrParentAssignmentSubmits>>;
  /** An object relationship */
  assignment_type: EntireFieldWrapper<StudentOrParentAssignmentType>;
  /** An array relationship */
  assignment_users: EntireFieldWrapper<Array<StudentOrParentAssignmentUser>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<StudentOrParentChats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrParentViewAssignmentClass>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** A computed field, executes function "assignment_due_at_filter" */
  due_at_filter?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrParentFiles>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrParentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrParentGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "assignment_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_gradeable: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  lesson?: EntireFieldWrapper<Maybe<StudentOrParentLessons>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentOrParentAssignmentTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "assignments" */
export interface StudentOrParentAssignmentsAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentBookChapterBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrParentAssignmentsAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentSubmitsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentSubmitsBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrParentAssignmentsAssignmentUsersArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentUserOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentUserBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrParentAssignmentsClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewAssignmentClassOrderBy>>;
  where?: Maybe<StudentOrParentViewAssignmentClassBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrParentAssignmentsFilesArgs {
  distinct_on?: Maybe<Array<StudentOrParentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentFilesOrderBy>>;
  where?: Maybe<StudentOrParentFilesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrParentAssignmentsGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}


/** columns and relationships of "assignments" */
export interface StudentOrParentAssignmentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}

/** aggregated selection of "assignments" */
export interface StudentOrParentAssignmentsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentAssignments>>;
}

/** aggregate fields of "assignments" */
export interface StudentOrParentAssignmentsAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentsVarianceFields>>;
}


/** aggregate fields of "assignments" */
export interface StudentOrParentAssignmentsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "assignments" */
export interface StudentOrParentAssignmentsAggregateOrderBy {
  avg?: Maybe<StudentOrParentAssignmentsAvgOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentAssignmentsMaxOrderBy>;
  min?: Maybe<StudentOrParentAssignmentsMinOrderBy>;
  stddev?: Maybe<StudentOrParentAssignmentsStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrParentAssignmentsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrParentAssignmentsStddevSampOrderBy>;
  sum?: Maybe<StudentOrParentAssignmentsSumOrderBy>;
  var_pop?: Maybe<StudentOrParentAssignmentsVarPopOrderBy>;
  var_samp?: Maybe<StudentOrParentAssignmentsVarSampOrderBy>;
  variance?: Maybe<StudentOrParentAssignmentsVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentOrParentAssignmentsAvgFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "assignments" */
export interface StudentOrParentAssignmentsAvgOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** Boolean expression to filter rows from the table "assignments". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAssignmentsBoolExp {
  _and?: Maybe<Array<StudentOrParentAssignmentsBoolExp>>;
  _not?: Maybe<StudentOrParentAssignmentsBoolExp>;
  _or?: Maybe<Array<StudentOrParentAssignmentsBoolExp>>;
  assignmentAttendeeType?: Maybe<StudentOrParentAssignmentAttendeeTypeBoolExp>;
  assignment_attendee_type?: Maybe<StudentOrParentAssignmentAttendeeTypeEnumComparisonExp>;
  assignment_book_chapters?: Maybe<StudentOrParentAssignmentBookChapterBoolExp>;
  assignment_grade_weight?: Maybe<StudentOrParentAssignmentGradeWeightsBoolExp>;
  assignment_grade_weight_id?: Maybe<StudentOrParentUuidComparisonExp>;
  assignment_submits?: Maybe<StudentOrParentAssignmentSubmitsBoolExp>;
  assignment_type?: Maybe<StudentOrParentAssignmentTypeBoolExp>;
  assignment_users?: Maybe<StudentOrParentAssignmentUserBoolExp>;
  chat?: Maybe<StudentOrParentChatsBoolExp>;
  chat_id?: Maybe<StudentOrParentUuidComparisonExp>;
  classes?: Maybe<StudentOrParentViewAssignmentClassBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  description?: Maybe<StudentOrParentStringComparisonExp>;
  due_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  due_at_filter?: Maybe<StudentOrParentStringComparisonExp>;
  duration?: Maybe<StudentOrParentIntComparisonExp>;
  files?: Maybe<StudentOrParentFilesBoolExp>;
  grades?: Maybe<StudentOrParentGradesBoolExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_completed?: Maybe<StudentOrParentBooleanComparisonExp>;
  is_everybody?: Maybe<StudentOrParentBooleanComparisonExp>;
  is_gradeable?: Maybe<StudentOrParentBooleanComparisonExp>;
  lesson?: Maybe<StudentOrParentLessonsBoolExp>;
  lesson_id?: Maybe<StudentOrParentUuidComparisonExp>;
  subject_id?: Maybe<StudentOrParentUuidComparisonExp>;
  teaching_structure?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<StudentOrParentUuidComparisonExp>;
  title?: Maybe<StudentOrParentStringComparisonExp>;
  type?: Maybe<StudentOrParentAssignmentTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrParentAssignmentsMaxFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "assignments" */
export interface StudentOrParentAssignmentsMaxOrderBy {
  assignment_grade_weight_id?: Maybe<StudentOrParentOrderBy>;
  chat_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  due_at?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  lesson_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  teaching_structure_id?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentAssignmentsMinFields {
  assignment_grade_weight_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  due_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "assignments" */
export interface StudentOrParentAssignmentsMinOrderBy {
  assignment_grade_weight_id?: Maybe<StudentOrParentOrderBy>;
  chat_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  due_at?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  lesson_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  teaching_structure_id?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "assignments". */
export interface StudentOrParentAssignmentsOrderBy {
  assignmentAttendeeType?: Maybe<StudentOrParentAssignmentAttendeeTypeOrderBy>;
  assignment_attendee_type?: Maybe<StudentOrParentOrderBy>;
  assignment_book_chapters_aggregate?: Maybe<StudentOrParentAssignmentBookChapterAggregateOrderBy>;
  assignment_grade_weight?: Maybe<StudentOrParentAssignmentGradeWeightsOrderBy>;
  assignment_grade_weight_id?: Maybe<StudentOrParentOrderBy>;
  assignment_submits_aggregate?: Maybe<StudentOrParentAssignmentSubmitsAggregateOrderBy>;
  assignment_type?: Maybe<StudentOrParentAssignmentTypeOrderBy>;
  assignment_users_aggregate?: Maybe<StudentOrParentAssignmentUserAggregateOrderBy>;
  chat?: Maybe<StudentOrParentChatsOrderBy>;
  chat_id?: Maybe<StudentOrParentOrderBy>;
  classes_aggregate?: Maybe<StudentOrParentViewAssignmentClassAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  due_at?: Maybe<StudentOrParentOrderBy>;
  due_at_filter?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  files_aggregate?: Maybe<StudentOrParentFilesAggregateOrderBy>;
  grades_aggregate?: Maybe<StudentOrParentGradesAggregateOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_completed?: Maybe<StudentOrParentOrderBy>;
  is_everybody?: Maybe<StudentOrParentOrderBy>;
  is_gradeable?: Maybe<StudentOrParentOrderBy>;
  lesson?: Maybe<StudentOrParentLessonsOrderBy>;
  lesson_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  teaching_structure?: Maybe<StudentOrParentTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "assignments" */
export const enum StudentOrParentAssignmentsSelectColumn {
  /** column name */
  ASSIGNMENT_ATTENDEE_TYPE = 'assignment_attendee_type',
  /** column name */
  ASSIGNMENT_GRADE_WEIGHT_ID = 'assignment_grade_weight_id',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_GRADEABLE = 'is_gradeable',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** aggregate stddev on columns */
export interface StudentOrParentAssignmentsStddevFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "assignments" */
export interface StudentOrParentAssignmentsStddevOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrParentAssignmentsStddevPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "assignments" */
export interface StudentOrParentAssignmentsStddevPopOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrParentAssignmentsStddevSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "assignments" */
export interface StudentOrParentAssignmentsStddevSampOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate sum on columns */
export interface StudentOrParentAssignmentsSumFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "assignments" */
export interface StudentOrParentAssignmentsSumOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentOrParentAssignmentsVarPopFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "assignments" */
export interface StudentOrParentAssignmentsVarPopOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentOrParentAssignmentsVarSampFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "assignments" */
export interface StudentOrParentAssignmentsVarSampOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate variance on columns */
export interface StudentOrParentAssignmentsVarianceFields {
  duration?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "assignments" */
export interface StudentOrParentAssignmentsVarianceOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** columns and relationships of "auth.account_providers" */
export interface StudentOrParentAuthAccountProviders {
  /** An object relationship */
  account: EntireFieldWrapper<StudentOrParentAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  auth_provider: EntireFieldWrapper<Scalars['String']>;
  auth_provider_unique_id: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  provider: EntireFieldWrapper<StudentOrParentAuthProviders>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentAuthAccountProviders>>;
}

/** aggregate fields of "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProvidersMinFields>>;
}


/** aggregate fields of "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentAuthAccountProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentAuthAccountProvidersMaxOrderBy>;
  min?: Maybe<StudentOrParentAuthAccountProvidersMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersArrRelInsertInput {
  data: Array<StudentOrParentAuthAccountProvidersInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentAuthAccountProvidersOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_providers". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAuthAccountProvidersBoolExp {
  _and?: Maybe<Array<StudentOrParentAuthAccountProvidersBoolExp>>;
  _not?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
  _or?: Maybe<Array<StudentOrParentAuthAccountProvidersBoolExp>>;
  account?: Maybe<StudentOrParentAuthAccountsBoolExp>;
  account_id?: Maybe<StudentOrParentUuidComparisonExp>;
  auth_provider?: Maybe<StudentOrParentStringComparisonExp>;
  auth_provider_unique_id?: Maybe<StudentOrParentStringComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  provider?: Maybe<StudentOrParentAuthProvidersBoolExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "auth.account_providers" */
export const enum StudentOrParentAuthAccountProvidersConstraint {
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_ACCOUNT_ID_AUTH_PROVIDER_KEY = 'account_providers_account_id_auth_provider_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_AUTH_PROVIDER_AUTH_PROVIDER_UNIQUE_ID_KEY = 'account_providers_auth_provider_auth_provider_unique_id_key',
  /** unique or primary key constraint */
  ACCOUNT_PROVIDERS_PKEY = 'account_providers_pkey'
};

/** input type for inserting data into table "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersInsertInput {
  account?: Maybe<StudentOrParentAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  provider?: Maybe<StudentOrParentAuthProvidersObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentOrParentAuthAccountProvidersMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersMaxOrderBy {
  account_id?: Maybe<StudentOrParentOrderBy>;
  auth_provider?: Maybe<StudentOrParentOrderBy>;
  auth_provider_unique_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentAuthAccountProvidersMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  auth_provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  auth_provider_unique_id?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersMinOrderBy {
  account_id?: Maybe<StudentOrParentOrderBy>;
  auth_provider?: Maybe<StudentOrParentOrderBy>;
  auth_provider_unique_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentAuthAccountProviders>>;
}

/** on conflict condition type for table "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersOnConflict {
  constraint: StudentOrParentAuthAccountProvidersConstraint;
  update_columns?: Array<StudentOrParentAuthAccountProvidersUpdateColumn>;
  where?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.account_providers". */
export interface StudentOrParentAuthAccountProvidersOrderBy {
  account?: Maybe<StudentOrParentAuthAccountsOrderBy>;
  account_id?: Maybe<StudentOrParentOrderBy>;
  auth_provider?: Maybe<StudentOrParentOrderBy>;
  auth_provider_unique_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  provider?: Maybe<StudentOrParentAuthProvidersOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: auth_account_providers */
export interface StudentOrParentAuthAccountProvidersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_providers" */
export const enum StudentOrParentAuthAccountProvidersSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "auth.account_providers" */
export interface StudentOrParentAuthAccountProvidersSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  auth_provider?: Maybe<Scalars['String']>;
  auth_provider_unique_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "auth.account_providers" */
export const enum StudentOrParentAuthAccountProvidersUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  AUTH_PROVIDER = 'auth_provider',
  /** column name */
  AUTH_PROVIDER_UNIQUE_ID = 'auth_provider_unique_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "auth.account_roles" */
export interface StudentOrParentAuthAccountRoles {
  /** An object relationship */
  account: EntireFieldWrapper<StudentOrParentAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<StudentOrParentAuthRoles>;
}

/** aggregated selection of "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentAuthAccountRoles>>;
}

/** aggregate fields of "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRolesMinFields>>;
}


/** aggregate fields of "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentAuthAccountRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentAuthAccountRolesMaxOrderBy>;
  min?: Maybe<StudentOrParentAuthAccountRolesMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesArrRelInsertInput {
  data: Array<StudentOrParentAuthAccountRolesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentAuthAccountRolesOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.account_roles". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAuthAccountRolesBoolExp {
  _and?: Maybe<Array<StudentOrParentAuthAccountRolesBoolExp>>;
  _not?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
  _or?: Maybe<Array<StudentOrParentAuthAccountRolesBoolExp>>;
  account?: Maybe<StudentOrParentAuthAccountsBoolExp>;
  account_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  role?: Maybe<StudentOrParentStringComparisonExp>;
  roleByRole?: Maybe<StudentOrParentAuthRolesBoolExp>;
}

/** unique or primary key constraints on table "auth.account_roles" */
export const enum StudentOrParentAuthAccountRolesConstraint {
  /** unique or primary key constraint */
  ACCOUNT_ROLES_PKEY = 'account_roles_pkey',
  /** unique or primary key constraint */
  USER_ROLES_ACCOUNT_ID_ROLE_KEY = 'user_roles_account_id_role_key'
};

/** input type for inserting data into table "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesInsertInput {
  account?: Maybe<StudentOrParentAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<StudentOrParentAuthRolesObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentOrParentAuthAccountRolesMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by max() on columns of table "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesMaxOrderBy {
  account_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  role?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentAuthAccountRolesMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** order by min() on columns of table "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesMinOrderBy {
  account_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  role?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentAuthAccountRoles>>;
}

/** on conflict condition type for table "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesOnConflict {
  constraint: StudentOrParentAuthAccountRolesConstraint;
  update_columns?: Array<StudentOrParentAuthAccountRolesUpdateColumn>;
  where?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.account_roles". */
export interface StudentOrParentAuthAccountRolesOrderBy {
  account?: Maybe<StudentOrParentAuthAccountsOrderBy>;
  account_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  role?: Maybe<StudentOrParentOrderBy>;
  roleByRole?: Maybe<StudentOrParentAuthRolesOrderBy>;
}

/** primary key columns input for table: auth_account_roles */
export interface StudentOrParentAuthAccountRolesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.account_roles" */
export const enum StudentOrParentAuthAccountRolesSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.account_roles" */
export interface StudentOrParentAuthAccountRolesSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.account_roles" */
export const enum StudentOrParentAuthAccountRolesUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  ROLE = 'role'
};

/** columns and relationships of "auth.accounts" */
export interface StudentOrParentAuthAccounts {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<StudentOrParentAuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<StudentOrParentAuthAccountProvidersAggregate>;
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<StudentOrParentAuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<StudentOrParentAuthAccountRolesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  default_role: EntireFieldWrapper<Scalars['String']>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbers>>;
  is_active: EntireFieldWrapper<Scalars['Boolean']>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  refresh_tokens: EntireFieldWrapper<Array<StudentOrParentAuthRefreshTokens>>;
  /** An aggregate relationship */
  refresh_tokens_aggregate: EntireFieldWrapper<StudentOrParentAuthRefreshTokensAggregate>;
  /** An object relationship */
  role: EntireFieldWrapper<StudentOrParentAuthRoles>;
  ticket: EntireFieldWrapper<Scalars['uuid']>;
  ticket_expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrParentAuthAccountsAccountProvidersArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrParentAuthAccountsAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrParentAuthAccountsAccountRolesArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrParentAuthAccountsAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrParentAuthAccountsRefreshTokensArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentOrParentAuthRefreshTokensBoolExp>;
}


/** columns and relationships of "auth.accounts" */
export interface StudentOrParentAuthAccountsRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentOrParentAuthRefreshTokensBoolExp>;
}

/** aggregated selection of "auth.accounts" */
export interface StudentOrParentAuthAccountsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentAuthAccounts>>;
}

/** aggregate fields of "auth.accounts" */
export interface StudentOrParentAuthAccountsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountsMinFields>>;
}


/** aggregate fields of "auth.accounts" */
export interface StudentOrParentAuthAccountsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentAuthAccountsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.accounts" */
export interface StudentOrParentAuthAccountsAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentAuthAccountsMaxOrderBy>;
  min?: Maybe<StudentOrParentAuthAccountsMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.accounts" */
export interface StudentOrParentAuthAccountsArrRelInsertInput {
  data: Array<StudentOrParentAuthAccountsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentAuthAccountsOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.accounts". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAuthAccountsBoolExp {
  _and?: Maybe<Array<StudentOrParentAuthAccountsBoolExp>>;
  _not?: Maybe<StudentOrParentAuthAccountsBoolExp>;
  _or?: Maybe<Array<StudentOrParentAuthAccountsBoolExp>>;
  account_providers?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
  account_roles?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  default_role?: Maybe<StudentOrParentStringComparisonExp>;
  email?: Maybe<StudentOrParentCitextComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  insurance_number?: Maybe<StudentOrParentPrivateInsuranceNumbersBoolExp>;
  is_active?: Maybe<StudentOrParentBooleanComparisonExp>;
  new_email?: Maybe<StudentOrParentCitextComparisonExp>;
  password_hash?: Maybe<StudentOrParentStringComparisonExp>;
  refresh_tokens?: Maybe<StudentOrParentAuthRefreshTokensBoolExp>;
  role?: Maybe<StudentOrParentAuthRolesBoolExp>;
  ticket?: Maybe<StudentOrParentUuidComparisonExp>;
  ticket_expires_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user?: Maybe<StudentOrParentUsersBoolExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.accounts" */
export const enum StudentOrParentAuthAccountsConstraint {
  /** unique or primary key constraint */
  ACCOUNTS_EMAIL_KEY = 'accounts_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_NEW_EMAIL_KEY = 'accounts_new_email_key',
  /** unique or primary key constraint */
  ACCOUNTS_PKEY = 'accounts_pkey',
  /** unique or primary key constraint */
  ACCOUNTS_USER_ID_KEY = 'accounts_user_id_key'
};

/** input type for inserting data into table "auth.accounts" */
export interface StudentOrParentAuthAccountsInsertInput {
  account_providers?: Maybe<StudentOrParentAuthAccountProvidersArrRelInsertInput>;
  account_roles?: Maybe<StudentOrParentAuthAccountRolesArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<StudentOrParentPrivateInsuranceNumbersObjRelInsertInput>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  refresh_tokens?: Maybe<StudentOrParentAuthRefreshTokensArrRelInsertInput>;
  role?: Maybe<StudentOrParentAuthRolesObjRelInsertInput>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentOrParentUsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrParentAuthAccountsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.accounts" */
export interface StudentOrParentAuthAccountsMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  default_role?: Maybe<StudentOrParentOrderBy>;
  email?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  new_email?: Maybe<StudentOrParentOrderBy>;
  password_hash?: Maybe<StudentOrParentOrderBy>;
  ticket?: Maybe<StudentOrParentOrderBy>;
  ticket_expires_at?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentAuthAccountsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  default_role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  new_email?: EntireFieldWrapper<Maybe<Scalars['citext']>>;
  password_hash?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  ticket?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ticket_expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.accounts" */
export interface StudentOrParentAuthAccountsMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  default_role?: Maybe<StudentOrParentOrderBy>;
  email?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  new_email?: Maybe<StudentOrParentOrderBy>;
  password_hash?: Maybe<StudentOrParentOrderBy>;
  ticket?: Maybe<StudentOrParentOrderBy>;
  ticket_expires_at?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "auth.accounts" */
export interface StudentOrParentAuthAccountsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentAuthAccounts>>;
}

/** input type for inserting object relation for remote table "auth.accounts" */
export interface StudentOrParentAuthAccountsObjRelInsertInput {
  data: StudentOrParentAuthAccountsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentAuthAccountsOnConflict>;
}

/** on conflict condition type for table "auth.accounts" */
export interface StudentOrParentAuthAccountsOnConflict {
  constraint: StudentOrParentAuthAccountsConstraint;
  update_columns?: Array<StudentOrParentAuthAccountsUpdateColumn>;
  where?: Maybe<StudentOrParentAuthAccountsBoolExp>;
}

/** Ordering options when selecting data from "auth.accounts". */
export interface StudentOrParentAuthAccountsOrderBy {
  account_providers_aggregate?: Maybe<StudentOrParentAuthAccountProvidersAggregateOrderBy>;
  account_roles_aggregate?: Maybe<StudentOrParentAuthAccountRolesAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  default_role?: Maybe<StudentOrParentOrderBy>;
  email?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  insurance_number?: Maybe<StudentOrParentPrivateInsuranceNumbersOrderBy>;
  is_active?: Maybe<StudentOrParentOrderBy>;
  new_email?: Maybe<StudentOrParentOrderBy>;
  password_hash?: Maybe<StudentOrParentOrderBy>;
  refresh_tokens_aggregate?: Maybe<StudentOrParentAuthRefreshTokensAggregateOrderBy>;
  role?: Maybe<StudentOrParentAuthRolesOrderBy>;
  ticket?: Maybe<StudentOrParentOrderBy>;
  ticket_expires_at?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user?: Maybe<StudentOrParentUsersOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: auth_accounts */
export interface StudentOrParentAuthAccountsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "auth.accounts" */
export const enum StudentOrParentAuthAccountsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "auth.accounts" */
export interface StudentOrParentAuthAccountsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  default_role?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['citext']>;
  id?: Maybe<Scalars['uuid']>;
  is_active?: Maybe<Scalars['Boolean']>;
  new_email?: Maybe<Scalars['citext']>;
  password_hash?: Maybe<Scalars['String']>;
  ticket?: Maybe<Scalars['uuid']>;
  ticket_expires_at?: Maybe<Scalars['timestamptz']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.accounts" */
export const enum StudentOrParentAuthAccountsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEFAULT_ROLE = 'default_role',
  /** column name */
  EMAIL = 'email',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ACTIVE = 'is_active',
  /** column name */
  NEW_EMAIL = 'new_email',
  /** column name */
  PASSWORD_HASH = 'password_hash',
  /** column name */
  TICKET = 'ticket',
  /** column name */
  TICKET_EXPIRES_AT = 'ticket_expires_at',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "auth.providers" */
export interface StudentOrParentAuthProviders {
  /** An array relationship */
  account_providers: EntireFieldWrapper<Array<StudentOrParentAuthAccountProviders>>;
  /** An aggregate relationship */
  account_providers_aggregate: EntireFieldWrapper<StudentOrParentAuthAccountProvidersAggregate>;
  provider: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.providers" */
export interface StudentOrParentAuthProvidersAccountProvidersArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
}


/** columns and relationships of "auth.providers" */
export interface StudentOrParentAuthProvidersAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
}

/** aggregated selection of "auth.providers" */
export interface StudentOrParentAuthProvidersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentAuthProvidersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentAuthProviders>>;
}

/** aggregate fields of "auth.providers" */
export interface StudentOrParentAuthProvidersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentAuthProvidersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentAuthProvidersMinFields>>;
}


/** aggregate fields of "auth.providers" */
export interface StudentOrParentAuthProvidersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentAuthProvidersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAuthProvidersBoolExp {
  _and?: Maybe<Array<StudentOrParentAuthProvidersBoolExp>>;
  _not?: Maybe<StudentOrParentAuthProvidersBoolExp>;
  _or?: Maybe<Array<StudentOrParentAuthProvidersBoolExp>>;
  account_providers?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
  provider?: Maybe<StudentOrParentStringComparisonExp>;
}

/** unique or primary key constraints on table "auth.providers" */
export const enum StudentOrParentAuthProvidersConstraint {
  /** unique or primary key constraint */
  PROVIDERS_PKEY = 'providers_pkey'
};

/** input type for inserting data into table "auth.providers" */
export interface StudentOrParentAuthProvidersInsertInput {
  account_providers?: Maybe<StudentOrParentAuthAccountProvidersArrRelInsertInput>;
  provider?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface StudentOrParentAuthProvidersMaxFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentOrParentAuthProvidersMinFields {
  provider?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.providers" */
export interface StudentOrParentAuthProvidersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentAuthProviders>>;
}

/** input type for inserting object relation for remote table "auth.providers" */
export interface StudentOrParentAuthProvidersObjRelInsertInput {
  data: StudentOrParentAuthProvidersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentAuthProvidersOnConflict>;
}

/** on conflict condition type for table "auth.providers" */
export interface StudentOrParentAuthProvidersOnConflict {
  constraint: StudentOrParentAuthProvidersConstraint;
  update_columns?: Array<StudentOrParentAuthProvidersUpdateColumn>;
  where?: Maybe<StudentOrParentAuthProvidersBoolExp>;
}

/** Ordering options when selecting data from "auth.providers". */
export interface StudentOrParentAuthProvidersOrderBy {
  account_providers_aggregate?: Maybe<StudentOrParentAuthAccountProvidersAggregateOrderBy>;
  provider?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: auth_providers */
export interface StudentOrParentAuthProvidersPkColumnsInput {
  provider: Scalars['String'];
}

/** select columns of table "auth.providers" */
export const enum StudentOrParentAuthProvidersSelectColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** input type for updating data in table "auth.providers" */
export interface StudentOrParentAuthProvidersSetInput {
  provider?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.providers" */
export const enum StudentOrParentAuthProvidersUpdateColumn {
  /** column name */
  PROVIDER = 'provider'
};

/** columns and relationships of "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokens {
  /** An object relationship */
  account: EntireFieldWrapper<StudentOrParentAuthAccounts>;
  account_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  expires_at: EntireFieldWrapper<Scalars['timestamptz']>;
  refresh_token: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokensAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentAuthRefreshTokens>>;
}

/** aggregate fields of "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokensMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokensMinFields>>;
}


/** aggregate fields of "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentAuthRefreshTokensSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentAuthRefreshTokensMaxOrderBy>;
  min?: Maybe<StudentOrParentAuthRefreshTokensMinOrderBy>;
}

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensArrRelInsertInput {
  data: Array<StudentOrParentAuthRefreshTokensInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentAuthRefreshTokensOnConflict>;
}

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAuthRefreshTokensBoolExp {
  _and?: Maybe<Array<StudentOrParentAuthRefreshTokensBoolExp>>;
  _not?: Maybe<StudentOrParentAuthRefreshTokensBoolExp>;
  _or?: Maybe<Array<StudentOrParentAuthRefreshTokensBoolExp>>;
  account?: Maybe<StudentOrParentAuthAccountsBoolExp>;
  account_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  expires_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  refresh_token?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** unique or primary key constraints on table "auth.refresh_tokens" */
export const enum StudentOrParentAuthRefreshTokensConstraint {
  /** unique or primary key constraint */
  REFRESH_TOKENS_PKEY = 'refresh_tokens_pkey'
};

/** input type for inserting data into table "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensInsertInput {
  account?: Maybe<StudentOrParentAuthAccountsObjRelInsertInput>;
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrParentAuthRefreshTokensMaxFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensMaxOrderBy {
  account_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  expires_at?: Maybe<StudentOrParentOrderBy>;
  refresh_token?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentAuthRefreshTokensMinFields {
  account_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  expires_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  refresh_token?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensMinOrderBy {
  account_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  expires_at?: Maybe<StudentOrParentOrderBy>;
  refresh_token?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentAuthRefreshTokens>>;
}

/** on conflict condition type for table "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensOnConflict {
  constraint: StudentOrParentAuthRefreshTokensConstraint;
  update_columns?: Array<StudentOrParentAuthRefreshTokensUpdateColumn>;
  where?: Maybe<StudentOrParentAuthRefreshTokensBoolExp>;
}

/** Ordering options when selecting data from "auth.refresh_tokens". */
export interface StudentOrParentAuthRefreshTokensOrderBy {
  account?: Maybe<StudentOrParentAuthAccountsOrderBy>;
  account_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  expires_at?: Maybe<StudentOrParentOrderBy>;
  refresh_token?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: auth_refresh_tokens */
export interface StudentOrParentAuthRefreshTokensPkColumnsInput {
  refresh_token: Scalars['uuid'];
}

/** select columns of table "auth.refresh_tokens" */
export const enum StudentOrParentAuthRefreshTokensSelectColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** input type for updating data in table "auth.refresh_tokens" */
export interface StudentOrParentAuthRefreshTokensSetInput {
  account_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expires_at?: Maybe<Scalars['timestamptz']>;
  refresh_token?: Maybe<Scalars['uuid']>;
}

/** update columns of table "auth.refresh_tokens" */
export const enum StudentOrParentAuthRefreshTokensUpdateColumn {
  /** column name */
  ACCOUNT_ID = 'account_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EXPIRES_AT = 'expires_at',
  /** column name */
  REFRESH_TOKEN = 'refresh_token'
};

/** columns and relationships of "auth.roles" */
export interface StudentOrParentAuthRoles {
  /** An array relationship */
  account_roles: EntireFieldWrapper<Array<StudentOrParentAuthAccountRoles>>;
  /** An aggregate relationship */
  account_roles_aggregate: EntireFieldWrapper<StudentOrParentAuthAccountRolesAggregate>;
  /** An array relationship */
  accounts: EntireFieldWrapper<Array<StudentOrParentAuthAccounts>>;
  /** An aggregate relationship */
  accounts_aggregate: EntireFieldWrapper<StudentOrParentAuthAccountsAggregate>;
  role: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "auth.roles" */
export interface StudentOrParentAuthRolesAccountRolesArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface StudentOrParentAuthRolesAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface StudentOrParentAuthRolesAccountsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountsOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountsBoolExp>;
}


/** columns and relationships of "auth.roles" */
export interface StudentOrParentAuthRolesAccountsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountsOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountsBoolExp>;
}

/** aggregated selection of "auth.roles" */
export interface StudentOrParentAuthRolesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentAuthRolesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentAuthRoles>>;
}

/** aggregate fields of "auth.roles" */
export interface StudentOrParentAuthRolesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentAuthRolesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentAuthRolesMinFields>>;
}


/** aggregate fields of "auth.roles" */
export interface StudentOrParentAuthRolesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentAuthRolesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export interface StudentOrParentAuthRolesBoolExp {
  _and?: Maybe<Array<StudentOrParentAuthRolesBoolExp>>;
  _not?: Maybe<StudentOrParentAuthRolesBoolExp>;
  _or?: Maybe<Array<StudentOrParentAuthRolesBoolExp>>;
  account_roles?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
  accounts?: Maybe<StudentOrParentAuthAccountsBoolExp>;
  role?: Maybe<StudentOrParentStringComparisonExp>;
}

/** unique or primary key constraints on table "auth.roles" */
export const enum StudentOrParentAuthRolesConstraint {
  /** unique or primary key constraint */
  ROLES_PKEY = 'roles_pkey'
};

/** input type for inserting data into table "auth.roles" */
export interface StudentOrParentAuthRolesInsertInput {
  account_roles?: Maybe<StudentOrParentAuthAccountRolesArrRelInsertInput>;
  accounts?: Maybe<StudentOrParentAuthAccountsArrRelInsertInput>;
  role?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface StudentOrParentAuthRolesMaxFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentOrParentAuthRolesMinFields {
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "auth.roles" */
export interface StudentOrParentAuthRolesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentAuthRoles>>;
}

/** input type for inserting object relation for remote table "auth.roles" */
export interface StudentOrParentAuthRolesObjRelInsertInput {
  data: StudentOrParentAuthRolesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentAuthRolesOnConflict>;
}

/** on conflict condition type for table "auth.roles" */
export interface StudentOrParentAuthRolesOnConflict {
  constraint: StudentOrParentAuthRolesConstraint;
  update_columns?: Array<StudentOrParentAuthRolesUpdateColumn>;
  where?: Maybe<StudentOrParentAuthRolesBoolExp>;
}

/** Ordering options when selecting data from "auth.roles". */
export interface StudentOrParentAuthRolesOrderBy {
  account_roles_aggregate?: Maybe<StudentOrParentAuthAccountRolesAggregateOrderBy>;
  accounts_aggregate?: Maybe<StudentOrParentAuthAccountsAggregateOrderBy>;
  role?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: auth_roles */
export interface StudentOrParentAuthRolesPkColumnsInput {
  role: Scalars['String'];
}

/** select columns of table "auth.roles" */
export const enum StudentOrParentAuthRolesSelectColumn {
  /** column name */
  ROLE = 'role'
};

/** input type for updating data in table "auth.roles" */
export interface StudentOrParentAuthRolesSetInput {
  role?: Maybe<Scalars['String']>;
}

/** update columns of table "auth.roles" */
export const enum StudentOrParentAuthRolesUpdateColumn {
  /** column name */
  ROLE = 'role'
};


/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export interface StudentOrParentBigintComparisonExp {
  _eq?: Maybe<Scalars['bigint']>;
  _gt?: Maybe<Scalars['bigint']>;
  _gte?: Maybe<Scalars['bigint']>;
  _in?: Maybe<Array<Scalars['bigint']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['bigint']>;
  _lte?: Maybe<Scalars['bigint']>;
  _neq?: Maybe<Scalars['bigint']>;
  _nin?: Maybe<Array<Scalars['bigint']>>;
}

/** columns and relationships of "book_chapter_type" */
export interface StudentOrParentBookChapterType {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentOrParentBookChapters>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "book_chapter_type" */
export interface StudentOrParentBookChapterTypeBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookChaptersOrderBy>>;
  where?: Maybe<StudentOrParentBookChaptersBoolExp>;
}

/** Boolean expression to filter rows from the table "book_chapter_type". All fields are combined with a logical 'AND'. */
export interface StudentOrParentBookChapterTypeBoolExp {
  _and?: Maybe<Array<StudentOrParentBookChapterTypeBoolExp>>;
  _not?: Maybe<StudentOrParentBookChapterTypeBoolExp>;
  _or?: Maybe<Array<StudentOrParentBookChapterTypeBoolExp>>;
  book_chapters?: Maybe<StudentOrParentBookChaptersBoolExp>;
  description?: Maybe<StudentOrParentStringComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
}

export const enum StudentOrParentBookChapterTypeEnum {
  HTML = 'HTML',
  QUIZZ = 'QUIZZ'
};

/** Boolean expression to compare columns of type "book_chapter_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrParentBookChapterTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrParentBookChapterTypeEnum>;
  _in?: Maybe<Array<StudentOrParentBookChapterTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrParentBookChapterTypeEnum>;
  _nin?: Maybe<Array<StudentOrParentBookChapterTypeEnum>>;
}

/** Ordering options when selecting data from "book_chapter_type". */
export interface StudentOrParentBookChapterTypeOrderBy {
  book_chapters_aggregate?: Maybe<StudentOrParentBookChaptersAggregateOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "book_chapter_type" */
export const enum StudentOrParentBookChapterTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "book_chapters" */
export interface StudentOrParentBookChapters {
  /** An array relationship */
  assignment_book_chapters: EntireFieldWrapper<Array<StudentOrParentAssignmentBookChapter>>;
  /** An object relationship */
  book: EntireFieldWrapper<StudentOrParentBooks>;
  /** An object relationship */
  book_chapter_type: EntireFieldWrapper<StudentOrParentBookChapterType>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentOrParentChapterSections>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  due_at: EntireFieldWrapper<Scalars['date']>;
  /** A computed field, executes function "book_chapter_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentOrParentBookChapterTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "book_chapters" */
export interface StudentOrParentBookChaptersAssignmentBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentBookChapterBoolExp>;
}


/** columns and relationships of "book_chapters" */
export interface StudentOrParentBookChaptersChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionsOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionsBoolExp>;
}

/** order by aggregate values of table "book_chapters" */
export interface StudentOrParentBookChaptersAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentBookChaptersMaxOrderBy>;
  min?: Maybe<StudentOrParentBookChaptersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_chapters". All fields are combined with a logical 'AND'. */
export interface StudentOrParentBookChaptersBoolExp {
  _and?: Maybe<Array<StudentOrParentBookChaptersBoolExp>>;
  _not?: Maybe<StudentOrParentBookChaptersBoolExp>;
  _or?: Maybe<Array<StudentOrParentBookChaptersBoolExp>>;
  assignment_book_chapters?: Maybe<StudentOrParentAssignmentBookChapterBoolExp>;
  book?: Maybe<StudentOrParentBooksBoolExp>;
  book_chapter_type?: Maybe<StudentOrParentBookChapterTypeBoolExp>;
  book_id?: Maybe<StudentOrParentUuidComparisonExp>;
  chapter_sections?: Maybe<StudentOrParentChapterSectionsBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  due_at?: Maybe<StudentOrParentDateComparisonExp>;
  duration_left?: Maybe<StudentOrParentBigintComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  status?: Maybe<StudentOrParentStringComparisonExp>;
  title?: Maybe<StudentOrParentStringComparisonExp>;
  type?: Maybe<StudentOrParentBookChapterTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "book_chapters" */
export interface StudentOrParentBookChaptersMaxOrderBy {
  book_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  due_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "book_chapters" */
export interface StudentOrParentBookChaptersMinOrderBy {
  book_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  due_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "book_chapters". */
export interface StudentOrParentBookChaptersOrderBy {
  assignment_book_chapters_aggregate?: Maybe<StudentOrParentAssignmentBookChapterAggregateOrderBy>;
  book?: Maybe<StudentOrParentBooksOrderBy>;
  book_chapter_type?: Maybe<StudentOrParentBookChapterTypeOrderBy>;
  book_id?: Maybe<StudentOrParentOrderBy>;
  chapter_sections_aggregate?: Maybe<StudentOrParentChapterSectionsAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  due_at?: Maybe<StudentOrParentOrderBy>;
  duration_left?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "book_chapters" */
export const enum StudentOrParentBookChaptersSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DUE_AT = 'due_at',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "book_course" */
export interface StudentOrParentBookCourse {
  /** An object relationship */
  book: EntireFieldWrapper<StudentOrParentBooks>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrParentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_course" */
export interface StudentOrParentBookCourseAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentBookCourseMaxOrderBy>;
  min?: Maybe<StudentOrParentBookCourseMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_course". All fields are combined with a logical 'AND'. */
export interface StudentOrParentBookCourseBoolExp {
  _and?: Maybe<Array<StudentOrParentBookCourseBoolExp>>;
  _not?: Maybe<StudentOrParentBookCourseBoolExp>;
  _or?: Maybe<Array<StudentOrParentBookCourseBoolExp>>;
  book?: Maybe<StudentOrParentBooksBoolExp>;
  book_id?: Maybe<StudentOrParentUuidComparisonExp>;
  course?: Maybe<StudentOrParentCoursesBoolExp>;
  course_id?: Maybe<StudentOrParentUuidComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** order by max() on columns of table "book_course" */
export interface StudentOrParentBookCourseMaxOrderBy {
  book_id?: Maybe<StudentOrParentOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "book_course" */
export interface StudentOrParentBookCourseMinOrderBy {
  book_id?: Maybe<StudentOrParentOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "book_course". */
export interface StudentOrParentBookCourseOrderBy {
  book?: Maybe<StudentOrParentBooksOrderBy>;
  book_id?: Maybe<StudentOrParentOrderBy>;
  course?: Maybe<StudentOrParentCoursesOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "book_course" */
export const enum StudentOrParentBookCourseSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "book_user" */
export interface StudentOrParentBookUser {
  /** An object relationship */
  book: EntireFieldWrapper<StudentOrParentBooks>;
  book_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "book_user" */
export interface StudentOrParentBookUserAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentBookUserMaxOrderBy>;
  min?: Maybe<StudentOrParentBookUserMinOrderBy>;
}

/** Boolean expression to filter rows from the table "book_user". All fields are combined with a logical 'AND'. */
export interface StudentOrParentBookUserBoolExp {
  _and?: Maybe<Array<StudentOrParentBookUserBoolExp>>;
  _not?: Maybe<StudentOrParentBookUserBoolExp>;
  _or?: Maybe<Array<StudentOrParentBookUserBoolExp>>;
  book?: Maybe<StudentOrParentBooksBoolExp>;
  book_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** order by max() on columns of table "book_user" */
export interface StudentOrParentBookUserMaxOrderBy {
  book_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "book_user" */
export interface StudentOrParentBookUserMinOrderBy {
  book_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "book_user". */
export interface StudentOrParentBookUserOrderBy {
  book?: Maybe<StudentOrParentBooksOrderBy>;
  book_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "book_user" */
export const enum StudentOrParentBookUserSelectColumn {
  /** column name */
  BOOK_ID = 'book_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "books" */
export interface StudentOrParentBooks {
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentOrParentBookChapters>>;
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<StudentOrParentBookCourse>>;
  /** An array relationship */
  book_users: EntireFieldWrapper<Array<StudentOrParentBookUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  subject: EntireFieldWrapper<StudentOrParentSubjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  title: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "books" */
export interface StudentOrParentBooksBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookChaptersOrderBy>>;
  where?: Maybe<StudentOrParentBookChaptersBoolExp>;
}


/** columns and relationships of "books" */
export interface StudentOrParentBooksBookCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookCourseOrderBy>>;
  where?: Maybe<StudentOrParentBookCourseBoolExp>;
}


/** columns and relationships of "books" */
export interface StudentOrParentBooksBookUsersArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookUserOrderBy>>;
  where?: Maybe<StudentOrParentBookUserBoolExp>;
}

/** order by aggregate values of table "books" */
export interface StudentOrParentBooksAggregateOrderBy {
  avg?: Maybe<StudentOrParentBooksAvgOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentBooksMaxOrderBy>;
  min?: Maybe<StudentOrParentBooksMinOrderBy>;
  stddev?: Maybe<StudentOrParentBooksStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrParentBooksStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrParentBooksStddevSampOrderBy>;
  sum?: Maybe<StudentOrParentBooksSumOrderBy>;
  var_pop?: Maybe<StudentOrParentBooksVarPopOrderBy>;
  var_samp?: Maybe<StudentOrParentBooksVarSampOrderBy>;
  variance?: Maybe<StudentOrParentBooksVarianceOrderBy>;
}

/** order by avg() on columns of table "books" */
export interface StudentOrParentBooksAvgOrderBy {
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** Boolean expression to filter rows from the table "books". All fields are combined with a logical 'AND'. */
export interface StudentOrParentBooksBoolExp {
  _and?: Maybe<Array<StudentOrParentBooksBoolExp>>;
  _not?: Maybe<StudentOrParentBooksBoolExp>;
  _or?: Maybe<Array<StudentOrParentBooksBoolExp>>;
  book_chapters?: Maybe<StudentOrParentBookChaptersBoolExp>;
  book_courses?: Maybe<StudentOrParentBookCourseBoolExp>;
  book_users?: Maybe<StudentOrParentBookUserBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  sort?: Maybe<StudentOrParentIntComparisonExp>;
  status?: Maybe<StudentOrParentStringComparisonExp>;
  subject?: Maybe<StudentOrParentSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrParentUuidComparisonExp>;
  title?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "books" */
export interface StudentOrParentBooksMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "books" */
export interface StudentOrParentBooksMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "books". */
export interface StudentOrParentBooksOrderBy {
  book_chapters_aggregate?: Maybe<StudentOrParentBookChaptersAggregateOrderBy>;
  book_courses_aggregate?: Maybe<StudentOrParentBookCourseAggregateOrderBy>;
  book_users_aggregate?: Maybe<StudentOrParentBookUserAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  subject?: Maybe<StudentOrParentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "books" */
export const enum StudentOrParentBooksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "books" */
export interface StudentOrParentBooksStddevOrderBy {
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_pop() on columns of table "books" */
export interface StudentOrParentBooksStddevPopOrderBy {
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_samp() on columns of table "books" */
export interface StudentOrParentBooksStddevSampOrderBy {
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by sum() on columns of table "books" */
export interface StudentOrParentBooksSumOrderBy {
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_pop() on columns of table "books" */
export interface StudentOrParentBooksVarPopOrderBy {
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_samp() on columns of table "books" */
export interface StudentOrParentBooksVarSampOrderBy {
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by variance() on columns of table "books" */
export interface StudentOrParentBooksVarianceOrderBy {
  sort?: Maybe<StudentOrParentOrderBy>;
}

/**
 * DEPRECATED - change to assignments_notes
 *
 *
 * columns and relationships of "chapter_section_notes"
 */
export interface StudentOrParentChapterSectionNotes {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chapter_section: EntireFieldWrapper<StudentOrParentChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentOrParentStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
}

/** order by aggregate values of table "chapter_section_notes" */
export interface StudentOrParentChapterSectionNotesAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentChapterSectionNotesMaxOrderBy>;
  min?: Maybe<StudentOrParentChapterSectionNotesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_notes". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChapterSectionNotesBoolExp {
  _and?: Maybe<Array<StudentOrParentChapterSectionNotesBoolExp>>;
  _not?: Maybe<StudentOrParentChapterSectionNotesBoolExp>;
  _or?: Maybe<Array<StudentOrParentChapterSectionNotesBoolExp>>;
  body?: Maybe<StudentOrParentStringComparisonExp>;
  chapter_section?: Maybe<StudentOrParentChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  student?: Maybe<StudentOrParentStudentsBoolExp>;
  student_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "chapter_section_notes" */
export interface StudentOrParentChapterSectionNotesMaxOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  chapter_section_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "chapter_section_notes" */
export interface StudentOrParentChapterSectionNotesMinOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  chapter_section_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "chapter_section_notes". */
export interface StudentOrParentChapterSectionNotesOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  chapter_section?: Maybe<StudentOrParentChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  student?: Maybe<StudentOrParentStudentsOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "chapter_section_notes" */
export const enum StudentOrParentChapterSectionNotesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmits {
  /** An object relationship */
  chapter_section: EntireFieldWrapper<StudentOrParentChapterSections>;
  chapter_section_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration_spent: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentOrParentStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsAggregateOrderBy {
  avg?: Maybe<StudentOrParentChapterSectionSubmitsAvgOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentChapterSectionSubmitsMaxOrderBy>;
  min?: Maybe<StudentOrParentChapterSectionSubmitsMinOrderBy>;
  stddev?: Maybe<StudentOrParentChapterSectionSubmitsStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrParentChapterSectionSubmitsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrParentChapterSectionSubmitsStddevSampOrderBy>;
  sum?: Maybe<StudentOrParentChapterSectionSubmitsSumOrderBy>;
  var_pop?: Maybe<StudentOrParentChapterSectionSubmitsVarPopOrderBy>;
  var_samp?: Maybe<StudentOrParentChapterSectionSubmitsVarSampOrderBy>;
  variance?: Maybe<StudentOrParentChapterSectionSubmitsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsAvgOrderBy {
  duration_spent?: Maybe<StudentOrParentOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_section_submits". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChapterSectionSubmitsBoolExp {
  _and?: Maybe<Array<StudentOrParentChapterSectionSubmitsBoolExp>>;
  _not?: Maybe<StudentOrParentChapterSectionSubmitsBoolExp>;
  _or?: Maybe<Array<StudentOrParentChapterSectionSubmitsBoolExp>>;
  chapter_section?: Maybe<StudentOrParentChapterSectionsBoolExp>;
  chapter_section_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  duration_spent?: Maybe<StudentOrParentIntComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_completed?: Maybe<StudentOrParentBooleanComparisonExp>;
  student?: Maybe<StudentOrParentStudentsBoolExp>;
  student_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsMaxOrderBy {
  chapter_section_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  duration_spent?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsMinOrderBy {
  chapter_section_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  duration_spent?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "chapter_section_submits". */
export interface StudentOrParentChapterSectionSubmitsOrderBy {
  chapter_section?: Maybe<StudentOrParentChapterSectionsOrderBy>;
  chapter_section_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  duration_spent?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_completed?: Maybe<StudentOrParentOrderBy>;
  student?: Maybe<StudentOrParentStudentsOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "chapter_section_submits" */
export const enum StudentOrParentChapterSectionSubmitsSelectColumn {
  /** column name */
  CHAPTER_SECTION_ID = 'chapter_section_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION_SPENT = 'duration_spent',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsStddevOrderBy {
  duration_spent?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsStddevPopOrderBy {
  duration_spent?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsStddevSampOrderBy {
  duration_spent?: Maybe<StudentOrParentOrderBy>;
}

/** order by sum() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsSumOrderBy {
  duration_spent?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_pop() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsVarPopOrderBy {
  duration_spent?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_samp() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsVarSampOrderBy {
  duration_spent?: Maybe<StudentOrParentOrderBy>;
}

/** order by variance() on columns of table "chapter_section_submits" */
export interface StudentOrParentChapterSectionSubmitsVarianceOrderBy {
  duration_spent?: Maybe<StudentOrParentOrderBy>;
}

/** columns and relationships of "chapter_section_type" */
export interface StudentOrParentChapterSectionType {
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentOrParentChapterSections>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chapter_section_type" */
export interface StudentOrParentChapterSectionTypeChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionsOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionsBoolExp>;
}

/** Boolean expression to filter rows from the table "chapter_section_type". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChapterSectionTypeBoolExp {
  _and?: Maybe<Array<StudentOrParentChapterSectionTypeBoolExp>>;
  _not?: Maybe<StudentOrParentChapterSectionTypeBoolExp>;
  _or?: Maybe<Array<StudentOrParentChapterSectionTypeBoolExp>>;
  chapter_sections?: Maybe<StudentOrParentChapterSectionsBoolExp>;
  icon?: Maybe<StudentOrParentStringComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
}

export const enum StudentOrParentChapterSectionTypeEnum {
  HTML = 'HTML',
  INFORMATION = 'Information',
  QUIZZ = 'Quizz'
};

/** Boolean expression to compare columns of type "chapter_section_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrParentChapterSectionTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrParentChapterSectionTypeEnum>;
  _in?: Maybe<Array<StudentOrParentChapterSectionTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrParentChapterSectionTypeEnum>;
  _nin?: Maybe<Array<StudentOrParentChapterSectionTypeEnum>>;
}

/** Ordering options when selecting data from "chapter_section_type". */
export interface StudentOrParentChapterSectionTypeOrderBy {
  chapter_sections_aggregate?: Maybe<StudentOrParentChapterSectionsAggregateOrderBy>;
  icon?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "chapter_section_type" */
export const enum StudentOrParentChapterSectionTypeSelectColumn {
  /** column name */
  ICON = 'icon',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chapter_sections" */
export interface StudentOrParentChapterSections {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  book_chapter: EntireFieldWrapper<StudentOrParentBookChapters>;
  book_chapter_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentOrParentChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<StudentOrParentChapterSectionSubmits>>;
  /** An object relationship */
  chapter_section_type: EntireFieldWrapper<StudentOrParentChapterSectionType>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  /** A computed field, executes function "section_duration_left" */
  duration_left?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "section_is_completed" */
  is_completed?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  sort: EntireFieldWrapper<Scalars['Int']>;
  status: EntireFieldWrapper<Scalars['String']>;
  title: EntireFieldWrapper<Scalars['String']>;
  type: EntireFieldWrapper<StudentOrParentChapterSectionTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "chapter_sections" */
export interface StudentOrParentChapterSectionsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionNotesBoolExp>;
}


/** columns and relationships of "chapter_sections" */
export interface StudentOrParentChapterSectionsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionSubmitsBoolExp>;
}

/** order by aggregate values of table "chapter_sections" */
export interface StudentOrParentChapterSectionsAggregateOrderBy {
  avg?: Maybe<StudentOrParentChapterSectionsAvgOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentChapterSectionsMaxOrderBy>;
  min?: Maybe<StudentOrParentChapterSectionsMinOrderBy>;
  stddev?: Maybe<StudentOrParentChapterSectionsStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrParentChapterSectionsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrParentChapterSectionsStddevSampOrderBy>;
  sum?: Maybe<StudentOrParentChapterSectionsSumOrderBy>;
  var_pop?: Maybe<StudentOrParentChapterSectionsVarPopOrderBy>;
  var_samp?: Maybe<StudentOrParentChapterSectionsVarSampOrderBy>;
  variance?: Maybe<StudentOrParentChapterSectionsVarianceOrderBy>;
}

/** order by avg() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsAvgOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** Boolean expression to filter rows from the table "chapter_sections". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChapterSectionsBoolExp {
  _and?: Maybe<Array<StudentOrParentChapterSectionsBoolExp>>;
  _not?: Maybe<StudentOrParentChapterSectionsBoolExp>;
  _or?: Maybe<Array<StudentOrParentChapterSectionsBoolExp>>;
  body?: Maybe<StudentOrParentStringComparisonExp>;
  book_chapter?: Maybe<StudentOrParentBookChaptersBoolExp>;
  book_chapter_id?: Maybe<StudentOrParentUuidComparisonExp>;
  chapter_section_notes?: Maybe<StudentOrParentChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<StudentOrParentChapterSectionSubmitsBoolExp>;
  chapter_section_type?: Maybe<StudentOrParentChapterSectionTypeBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  duration?: Maybe<StudentOrParentIntComparisonExp>;
  duration_left?: Maybe<StudentOrParentIntComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_completed?: Maybe<StudentOrParentBooleanComparisonExp>;
  sort?: Maybe<StudentOrParentIntComparisonExp>;
  status?: Maybe<StudentOrParentStringComparisonExp>;
  title?: Maybe<StudentOrParentStringComparisonExp>;
  type?: Maybe<StudentOrParentChapterSectionTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsMaxOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  book_chapter_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsMinOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  book_chapter_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "chapter_sections". */
export interface StudentOrParentChapterSectionsOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  book_chapter?: Maybe<StudentOrParentBookChaptersOrderBy>;
  book_chapter_id?: Maybe<StudentOrParentOrderBy>;
  chapter_section_notes_aggregate?: Maybe<StudentOrParentChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<StudentOrParentChapterSectionSubmitsAggregateOrderBy>;
  chapter_section_type?: Maybe<StudentOrParentChapterSectionTypeOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  duration_left?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_completed?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "chapter_sections" */
export const enum StudentOrParentChapterSectionsSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  BOOK_CHAPTER_ID = 'book_chapter_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  SORT = 'sort',
  /** column name */
  STATUS = 'status',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsStddevOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_pop() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsStddevPopOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_samp() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsStddevSampOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by sum() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsSumOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_pop() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsVarPopOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_samp() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsVarSampOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** order by variance() on columns of table "chapter_sections" */
export interface StudentOrParentChapterSectionsVarianceOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
  sort?: Maybe<StudentOrParentOrderBy>;
}

/** columns and relationships of "chat_message_likes" */
export interface StudentOrParentChatMessageLikes {
  chat_like_user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<StudentOrParentChatMessages>>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "chat_message_likes" */
export interface StudentOrParentChatMessageLikesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageLikesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentChatMessageLikes>>;
}

/** aggregate fields of "chat_message_likes" */
export interface StudentOrParentChatMessageLikesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageLikesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageLikesMinFields>>;
}


/** aggregate fields of "chat_message_likes" */
export interface StudentOrParentChatMessageLikesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentChatMessageLikesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_message_likes" */
export interface StudentOrParentChatMessageLikesAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentChatMessageLikesMaxOrderBy>;
  min?: Maybe<StudentOrParentChatMessageLikesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_likes" */
export interface StudentOrParentChatMessageLikesArrRelInsertInput {
  data: Array<StudentOrParentChatMessageLikesInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_message_likes". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChatMessageLikesBoolExp {
  _and?: Maybe<Array<StudentOrParentChatMessageLikesBoolExp>>;
  _not?: Maybe<StudentOrParentChatMessageLikesBoolExp>;
  _or?: Maybe<Array<StudentOrParentChatMessageLikesBoolExp>>;
  chat_message?: Maybe<StudentOrParentChatMessagesBoolExp>;
  chat_message_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** input type for inserting data into table "chat_message_likes" */
export interface StudentOrParentChatMessageLikesInsertInput {
  chat_message?: Maybe<StudentOrParentChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrParentChatMessageLikesMaxFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_message_likes" */
export interface StudentOrParentChatMessageLikesMaxOrderBy {
  chat_message_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentChatMessageLikesMinFields {
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_message_likes" */
export interface StudentOrParentChatMessageLikesMinOrderBy {
  chat_message_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "chat_message_likes" */
export interface StudentOrParentChatMessageLikesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentChatMessageLikes>>;
}

/** Ordering options when selecting data from "chat_message_likes". */
export interface StudentOrParentChatMessageLikesOrderBy {
  chat_message?: Maybe<StudentOrParentChatMessagesOrderBy>;
  chat_message_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "chat_message_likes" */
export const enum StudentOrParentChatMessageLikesSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chat_message_reads" */
export interface StudentOrParentChatMessageReads {
  /** An object relationship */
  chat_message: EntireFieldWrapper<StudentOrParentChatMessages>;
  chat_message_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_read: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_message_reads" */
export interface StudentOrParentChatMessageReadsAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentChatMessageReadsMaxOrderBy>;
  min?: Maybe<StudentOrParentChatMessageReadsMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_message_reads" */
export interface StudentOrParentChatMessageReadsArrRelInsertInput {
  data: Array<StudentOrParentChatMessageReadsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentChatMessageReadsOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_message_reads". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChatMessageReadsBoolExp {
  _and?: Maybe<Array<StudentOrParentChatMessageReadsBoolExp>>;
  _not?: Maybe<StudentOrParentChatMessageReadsBoolExp>;
  _or?: Maybe<Array<StudentOrParentChatMessageReadsBoolExp>>;
  chat_message?: Maybe<StudentOrParentChatMessagesBoolExp>;
  chat_message_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_read?: Maybe<StudentOrParentBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_message_reads" */
export const enum StudentOrParentChatMessageReadsConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGE_USER_PKEY = 'chat_message_user_pkey'
};

/** input type for inserting data into table "chat_message_reads" */
export interface StudentOrParentChatMessageReadsInsertInput {
  chat_message?: Maybe<StudentOrParentChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_read?: Maybe<Scalars['Boolean']>;
}

/** order by max() on columns of table "chat_message_reads" */
export interface StudentOrParentChatMessageReadsMaxOrderBy {
  chat_message_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "chat_message_reads" */
export interface StudentOrParentChatMessageReadsMinOrderBy {
  chat_message_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "chat_message_reads" */
export interface StudentOrParentChatMessageReadsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentChatMessageReads>>;
}

/** on conflict condition type for table "chat_message_reads" */
export interface StudentOrParentChatMessageReadsOnConflict {
  constraint: StudentOrParentChatMessageReadsConstraint;
  update_columns?: Array<StudentOrParentChatMessageReadsUpdateColumn>;
  where?: Maybe<StudentOrParentChatMessageReadsBoolExp>;
}

/** Ordering options when selecting data from "chat_message_reads". */
export interface StudentOrParentChatMessageReadsOrderBy {
  chat_message?: Maybe<StudentOrParentChatMessagesOrderBy>;
  chat_message_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_read?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: chat_message_reads */
export interface StudentOrParentChatMessageReadsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_message_reads" */
export const enum StudentOrParentChatMessageReadsSelectColumn {
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_READ = 'is_read',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_message_reads" */
export interface StudentOrParentChatMessageReadsSetInput {
  is_read?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_message_reads" */
export const enum StudentOrParentChatMessageReadsUpdateColumn {
  /** column name */
  IS_READ = 'is_read'
};

/** columns and relationships of "chat_messages" */
export interface StudentOrParentChatMessages {
  body: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  chat: EntireFieldWrapper<StudentOrParentChats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  chat_message?: EntireFieldWrapper<Maybe<StudentOrParentChatMessages>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<StudentOrParentChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<StudentOrParentChatMessageLikesAggregate>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<StudentOrParentChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentOrParentChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentOrParentChatMessagesAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrParentFiles>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_pinned: EntireFieldWrapper<Scalars['Boolean']>;
  /** A computed field, executes function "chat_message_replys" */
  replys?: EntireFieldWrapper<Maybe<Array<StudentOrParentChatMessages>>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrParentChatMessagesChatMessageLikesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrParentChatMessagesChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessageLikesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrParentChatMessagesChatMessageReadsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessageReadsOrderBy>>;
  where?: Maybe<StudentOrParentChatMessageReadsBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrParentChatMessagesChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrParentChatMessagesChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrParentChatMessagesFilesArgs {
  distinct_on?: Maybe<Array<StudentOrParentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentFilesOrderBy>>;
  where?: Maybe<StudentOrParentFilesBoolExp>;
}


/** columns and relationships of "chat_messages" */
export interface StudentOrParentChatMessagesReplysArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}

/** aggregated selection of "chat_messages" */
export interface StudentOrParentChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentChatMessages>>;
}

/** aggregate fields of "chat_messages" */
export interface StudentOrParentChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentChatMessagesMinFields>>;
}


/** aggregate fields of "chat_messages" */
export interface StudentOrParentChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "chat_messages" */
export interface StudentOrParentChatMessagesAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentChatMessagesMaxOrderBy>;
  min?: Maybe<StudentOrParentChatMessagesMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_messages" */
export interface StudentOrParentChatMessagesArrRelInsertInput {
  data: Array<StudentOrParentChatMessagesInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentChatMessagesOnConflict>;
}

/** Boolean expression to filter rows from the table "chat_messages". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChatMessagesBoolExp {
  _and?: Maybe<Array<StudentOrParentChatMessagesBoolExp>>;
  _not?: Maybe<StudentOrParentChatMessagesBoolExp>;
  _or?: Maybe<Array<StudentOrParentChatMessagesBoolExp>>;
  body?: Maybe<StudentOrParentStringComparisonExp>;
  chat?: Maybe<StudentOrParentChatsBoolExp>;
  chat_id?: Maybe<StudentOrParentUuidComparisonExp>;
  chat_message?: Maybe<StudentOrParentChatMessagesBoolExp>;
  chat_message_id?: Maybe<StudentOrParentUuidComparisonExp>;
  chat_message_likes?: Maybe<StudentOrParentChatMessageLikesBoolExp>;
  chat_message_reads?: Maybe<StudentOrParentChatMessageReadsBoolExp>;
  chat_messages?: Maybe<StudentOrParentChatMessagesBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  files?: Maybe<StudentOrParentFilesBoolExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_pinned?: Maybe<StudentOrParentBooleanComparisonExp>;
  replys?: Maybe<StudentOrParentChatMessagesBoolExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** unique or primary key constraints on table "chat_messages" */
export const enum StudentOrParentChatMessagesConstraint {
  /** unique or primary key constraint */
  CHAT_MESSAGES_PKEY = 'chat_messages_pkey'
};

/** input type for inserting data into table "chat_messages" */
export interface StudentOrParentChatMessagesInsertInput {
  body?: Maybe<Scalars['String']>;
  chat?: Maybe<StudentOrParentChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message?: Maybe<StudentOrParentChatMessagesObjRelInsertInput>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  chat_message_likes?: Maybe<StudentOrParentChatMessageLikesArrRelInsertInput>;
  chat_message_reads?: Maybe<StudentOrParentChatMessageReadsArrRelInsertInput>;
  chat_messages?: Maybe<StudentOrParentChatMessagesArrRelInsertInput>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrParentChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "chat_messages" */
export interface StudentOrParentChatMessagesMaxOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  chat_id?: Maybe<StudentOrParentOrderBy>;
  chat_message_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  chat_message_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "chat_messages" */
export interface StudentOrParentChatMessagesMinOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  chat_id?: Maybe<StudentOrParentOrderBy>;
  chat_message_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "chat_messages" */
export interface StudentOrParentChatMessagesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentChatMessages>>;
}

/** input type for inserting object relation for remote table "chat_messages" */
export interface StudentOrParentChatMessagesObjRelInsertInput {
  data: StudentOrParentChatMessagesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentChatMessagesOnConflict>;
}

/** on conflict condition type for table "chat_messages" */
export interface StudentOrParentChatMessagesOnConflict {
  constraint: StudentOrParentChatMessagesConstraint;
  update_columns?: Array<StudentOrParentChatMessagesUpdateColumn>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}

/** Ordering options when selecting data from "chat_messages". */
export interface StudentOrParentChatMessagesOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  chat?: Maybe<StudentOrParentChatsOrderBy>;
  chat_id?: Maybe<StudentOrParentOrderBy>;
  chat_message?: Maybe<StudentOrParentChatMessagesOrderBy>;
  chat_message_id?: Maybe<StudentOrParentOrderBy>;
  chat_message_likes_aggregate?: Maybe<StudentOrParentChatMessageLikesAggregateOrderBy>;
  chat_message_reads_aggregate?: Maybe<StudentOrParentChatMessageReadsAggregateOrderBy>;
  chat_messages_aggregate?: Maybe<StudentOrParentChatMessagesAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  files_aggregate?: Maybe<StudentOrParentFilesAggregateOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_pinned?: Maybe<StudentOrParentOrderBy>;
  replys_aggregate?: Maybe<StudentOrParentChatMessagesAggregateOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: chat_messages */
export interface StudentOrParentChatMessagesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chat_messages" */
export const enum StudentOrParentChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chat_messages" */
export interface StudentOrParentChatMessagesSetInput {
  body?: Maybe<Scalars['String']>;
  chat_id?: Maybe<Scalars['uuid']>;
  chat_message_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  is_pinned?: Maybe<Scalars['Boolean']>;
}

/** update columns of table "chat_messages" */
export const enum StudentOrParentChatMessagesUpdateColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CHAT_MESSAGE_ID = 'chat_message_id',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PINNED = 'is_pinned'
};

/** columns and relationships of "chat_type" */
export interface StudentOrParentChatType {
  /** An array relationship */
  chats: EntireFieldWrapper<Array<StudentOrParentChats>>;
  description: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "chat_type" */
export interface StudentOrParentChatTypeChatsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatsOrderBy>>;
  where?: Maybe<StudentOrParentChatsBoolExp>;
}

/** Boolean expression to filter rows from the table "chat_type". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChatTypeBoolExp {
  _and?: Maybe<Array<StudentOrParentChatTypeBoolExp>>;
  _not?: Maybe<StudentOrParentChatTypeBoolExp>;
  _or?: Maybe<Array<StudentOrParentChatTypeBoolExp>>;
  chats?: Maybe<StudentOrParentChatsBoolExp>;
  description?: Maybe<StudentOrParentStringComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
}

export const enum StudentOrParentChatTypeEnum {
  /** Group conversation */
  GROUP = 'GROUP',
  /** Private conversation */
  PRIVATE = 'PRIVATE'
};

/** Boolean expression to compare columns of type "chat_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrParentChatTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrParentChatTypeEnum>;
  _in?: Maybe<Array<StudentOrParentChatTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrParentChatTypeEnum>;
  _nin?: Maybe<Array<StudentOrParentChatTypeEnum>>;
}

/** Ordering options when selecting data from "chat_type". */
export interface StudentOrParentChatTypeOrderBy {
  chats_aggregate?: Maybe<StudentOrParentChatsAggregateOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "chat_type" */
export const enum StudentOrParentChatTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "chat_user" */
export interface StudentOrParentChatUser {
  /** An object relationship */
  chat: EntireFieldWrapper<StudentOrParentChats>;
  chat_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "chat_user" */
export interface StudentOrParentChatUserAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentChatUserMaxOrderBy>;
  min?: Maybe<StudentOrParentChatUserMinOrderBy>;
}

/** input type for inserting array relation for remote table "chat_user" */
export interface StudentOrParentChatUserArrRelInsertInput {
  data: Array<StudentOrParentChatUserInsertInput>;
}

/** Boolean expression to filter rows from the table "chat_user". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChatUserBoolExp {
  _and?: Maybe<Array<StudentOrParentChatUserBoolExp>>;
  _not?: Maybe<StudentOrParentChatUserBoolExp>;
  _or?: Maybe<Array<StudentOrParentChatUserBoolExp>>;
  chat?: Maybe<StudentOrParentChatsBoolExp>;
  chat_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** input type for inserting data into table "chat_user" */
export interface StudentOrParentChatUserInsertInput {
  chat?: Maybe<StudentOrParentChatsObjRelInsertInput>;
  chat_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** order by max() on columns of table "chat_user" */
export interface StudentOrParentChatUserMaxOrderBy {
  chat_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "chat_user" */
export interface StudentOrParentChatUserMinOrderBy {
  chat_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "chat_user" */
export interface StudentOrParentChatUserMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentChatUser>>;
}

/** Ordering options when selecting data from "chat_user". */
export interface StudentOrParentChatUserOrderBy {
  chat?: Maybe<StudentOrParentChatsOrderBy>;
  chat_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "chat_user" */
export const enum StudentOrParentChatUserSelectColumn {
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "chats" */
export interface StudentOrParentChats {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentOrParentChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentOrParentChatMessagesAggregate>;
  /** An object relationship */
  chat_type: EntireFieldWrapper<StudentOrParentChatType>;
  /** An array relationship */
  chat_users: EntireFieldWrapper<Array<StudentOrParentChatUser>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type: EntireFieldWrapper<StudentOrParentChatTypeEnum>;
  /** A computed field, executes function "unread_messages" */
  unread_messages?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}


/** columns and relationships of "chats" */
export interface StudentOrParentChatsChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface StudentOrParentChatsChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}


/** columns and relationships of "chats" */
export interface StudentOrParentChatsChatUsersArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatUserOrderBy>>;
  where?: Maybe<StudentOrParentChatUserBoolExp>;
}

/** order by aggregate values of table "chats" */
export interface StudentOrParentChatsAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentChatsMaxOrderBy>;
  min?: Maybe<StudentOrParentChatsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "chats". All fields are combined with a logical 'AND'. */
export interface StudentOrParentChatsBoolExp {
  _and?: Maybe<Array<StudentOrParentChatsBoolExp>>;
  _not?: Maybe<StudentOrParentChatsBoolExp>;
  _or?: Maybe<Array<StudentOrParentChatsBoolExp>>;
  avatar_url?: Maybe<StudentOrParentStringComparisonExp>;
  chat_messages?: Maybe<StudentOrParentChatMessagesBoolExp>;
  chat_type?: Maybe<StudentOrParentChatTypeBoolExp>;
  chat_users?: Maybe<StudentOrParentChatUserBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  title?: Maybe<StudentOrParentStringComparisonExp>;
  type?: Maybe<StudentOrParentChatTypeEnumComparisonExp>;
  unread_messages?: Maybe<StudentOrParentBigintComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** unique or primary key constraints on table "chats" */
export const enum StudentOrParentChatsConstraint {
  /** unique or primary key constraint */
  CHATS_PKEY = 'chats_pkey'
};

/** input type for inserting data into table "chats" */
export interface StudentOrParentChatsInsertInput {
  avatar_url?: Maybe<Scalars['String']>;
  chat_messages?: Maybe<StudentOrParentChatMessagesArrRelInsertInput>;
  chat_users?: Maybe<StudentOrParentChatUserArrRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** order by max() on columns of table "chats" */
export interface StudentOrParentChatsMaxOrderBy {
  avatar_url?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "chats" */
export interface StudentOrParentChatsMinOrderBy {
  avatar_url?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "chats" */
export interface StudentOrParentChatsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentChats>>;
}

/** input type for inserting object relation for remote table "chats" */
export interface StudentOrParentChatsObjRelInsertInput {
  data: StudentOrParentChatsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentChatsOnConflict>;
}

/** on conflict condition type for table "chats" */
export interface StudentOrParentChatsOnConflict {
  constraint: StudentOrParentChatsConstraint;
  update_columns?: Array<StudentOrParentChatsUpdateColumn>;
  where?: Maybe<StudentOrParentChatsBoolExp>;
}

/** Ordering options when selecting data from "chats". */
export interface StudentOrParentChatsOrderBy {
  avatar_url?: Maybe<StudentOrParentOrderBy>;
  chat_messages_aggregate?: Maybe<StudentOrParentChatMessagesAggregateOrderBy>;
  chat_type?: Maybe<StudentOrParentChatTypeOrderBy>;
  chat_users_aggregate?: Maybe<StudentOrParentChatUserAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  unread_messages?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: chats */
export interface StudentOrParentChatsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "chats" */
export const enum StudentOrParentChatsSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "chats" */
export interface StudentOrParentChatsSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
}

/** update columns of table "chats" */
export const enum StudentOrParentChatsUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  TITLE = 'title'
};


/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export interface StudentOrParentCitextComparisonExp {
  _eq?: Maybe<Scalars['citext']>;
  _gt?: Maybe<Scalars['citext']>;
  _gte?: Maybe<Scalars['citext']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: Maybe<Scalars['citext']>;
  _in?: Maybe<Array<Scalars['citext']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: Maybe<Scalars['citext']>;
  _is_null?: Maybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: Maybe<Scalars['citext']>;
  _lt?: Maybe<Scalars['citext']>;
  _lte?: Maybe<Scalars['citext']>;
  _neq?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: Maybe<Scalars['citext']>;
  _nin?: Maybe<Array<Scalars['citext']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given pattern */
  _nlike?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: Maybe<Scalars['citext']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: Maybe<Scalars['citext']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: Maybe<Scalars['citext']>;
  /** does the column match the given SQL regular expression */
  _similar?: Maybe<Scalars['citext']>;
}

/** columns and relationships of "class_levels" */
export interface StudentOrParentClassLevels {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrParentClasses>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  number: EntireFieldWrapper<Scalars['Int']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "class_levels" */
export interface StudentOrParentClassLevelsClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassesOrderBy>>;
  where?: Maybe<StudentOrParentClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_levels". All fields are combined with a logical 'AND'. */
export interface StudentOrParentClassLevelsBoolExp {
  _and?: Maybe<Array<StudentOrParentClassLevelsBoolExp>>;
  _not?: Maybe<StudentOrParentClassLevelsBoolExp>;
  _or?: Maybe<Array<StudentOrParentClassLevelsBoolExp>>;
  classes?: Maybe<StudentOrParentClassesBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  number?: Maybe<StudentOrParentIntComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "class_levels". */
export interface StudentOrParentClassLevelsOrderBy {
  classes_aggregate?: Maybe<StudentOrParentClassesAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  number?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "class_levels" */
export const enum StudentOrParentClassLevelsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "class_type" */
export interface StudentOrParentClassType {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrParentClasses>>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  name: EntireFieldWrapper<Scalars['String']>;
}


/** columns and relationships of "class_type" */
export interface StudentOrParentClassTypeClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassesOrderBy>>;
  where?: Maybe<StudentOrParentClassesBoolExp>;
}

/** Boolean expression to filter rows from the table "class_type". All fields are combined with a logical 'AND'. */
export interface StudentOrParentClassTypeBoolExp {
  _and?: Maybe<Array<StudentOrParentClassTypeBoolExp>>;
  _not?: Maybe<StudentOrParentClassTypeBoolExp>;
  _or?: Maybe<Array<StudentOrParentClassTypeBoolExp>>;
  classes?: Maybe<StudentOrParentClassesBoolExp>;
  description?: Maybe<StudentOrParentStringComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
}

export const enum StudentOrParentClassTypeEnum {
  C = 'C',
  GEISTESWISSENSCHAFTEN = 'Geisteswissenschaften',
  TECHNOLOGIE = 'Technologie'
};

/** Boolean expression to compare columns of type "class_type_enum". All fields are combined with logical 'AND'. */
export interface StudentOrParentClassTypeEnumComparisonExp {
  _eq?: Maybe<StudentOrParentClassTypeEnum>;
  _in?: Maybe<Array<StudentOrParentClassTypeEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrParentClassTypeEnum>;
  _nin?: Maybe<Array<StudentOrParentClassTypeEnum>>;
}

/** Ordering options when selecting data from "class_type". */
export interface StudentOrParentClassTypeOrderBy {
  classes_aggregate?: Maybe<StudentOrParentClassesAggregateOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "class_type" */
export const enum StudentOrParentClassTypeSelectColumn {
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "classes" */
export interface StudentOrParentClasses {
  /** An object relationship */
  class_type: EntireFieldWrapper<StudentOrParentClassType>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<StudentOrParentCourseClass>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  identifier?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  level: EntireFieldWrapper<StudentOrParentClassLevels>;
  level_id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "class_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentOrParentStudents>>;
  /** An object relationship */
  teacher: EntireFieldWrapper<StudentOrParentTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<StudentOrParentClassTypeEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classes" */
export interface StudentOrParentClassesCourseClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseClassOrderBy>>;
  where?: Maybe<StudentOrParentCourseClassBoolExp>;
}


/** columns and relationships of "classes" */
export interface StudentOrParentClassesStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentStudentsOrderBy>>;
  where?: Maybe<StudentOrParentStudentsBoolExp>;
}

/** order by aggregate values of table "classes" */
export interface StudentOrParentClassesAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentClassesMaxOrderBy>;
  min?: Maybe<StudentOrParentClassesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classes". All fields are combined with a logical 'AND'. */
export interface StudentOrParentClassesBoolExp {
  _and?: Maybe<Array<StudentOrParentClassesBoolExp>>;
  _not?: Maybe<StudentOrParentClassesBoolExp>;
  _or?: Maybe<Array<StudentOrParentClassesBoolExp>>;
  class_type?: Maybe<StudentOrParentClassTypeBoolExp>;
  course_classes?: Maybe<StudentOrParentCourseClassBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  identifier?: Maybe<StudentOrParentStringComparisonExp>;
  level?: Maybe<StudentOrParentClassLevelsBoolExp>;
  level_id?: Maybe<StudentOrParentUuidComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  students?: Maybe<StudentOrParentStudentsBoolExp>;
  teacher?: Maybe<StudentOrParentTeachersBoolExp>;
  teacher_id?: Maybe<StudentOrParentUuidComparisonExp>;
  type?: Maybe<StudentOrParentClassTypeEnumComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "classes" */
export interface StudentOrParentClassesMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  identifier?: Maybe<StudentOrParentOrderBy>;
  level_id?: Maybe<StudentOrParentOrderBy>;
  teacher_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "classes" */
export interface StudentOrParentClassesMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  identifier?: Maybe<StudentOrParentOrderBy>;
  level_id?: Maybe<StudentOrParentOrderBy>;
  teacher_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "classes". */
export interface StudentOrParentClassesOrderBy {
  class_type?: Maybe<StudentOrParentClassTypeOrderBy>;
  course_classes_aggregate?: Maybe<StudentOrParentCourseClassAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  identifier?: Maybe<StudentOrParentOrderBy>;
  level?: Maybe<StudentOrParentClassLevelsOrderBy>;
  level_id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  students_aggregate?: Maybe<StudentOrParentStudentsAggregateOrderBy>;
  teacher?: Maybe<StudentOrParentTeachersOrderBy>;
  teacher_id?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "classes" */
export const enum StudentOrParentClassesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IDENTIFIER = 'identifier',
  /** column name */
  LEVEL_ID = 'level_id',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "classrooms" */
export interface StudentOrParentClassrooms {
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<StudentOrParentCourseClassroom>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  floor: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentOrParentLessons>>;
  name: EntireFieldWrapper<Scalars['String']>;
  room: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentOrParentSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<StudentOrParentTeachers>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "classrooms" */
export interface StudentOrParentClassroomsCourseClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseClassroomOrderBy>>;
  where?: Maybe<StudentOrParentCourseClassroomBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface StudentOrParentClassroomsLessonsArgs {
  distinct_on?: Maybe<Array<StudentOrParentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLessonsOrderBy>>;
  where?: Maybe<StudentOrParentLessonsBoolExp>;
}


/** columns and relationships of "classrooms" */
export interface StudentOrParentClassroomsTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrParentTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachersOrderBy>>;
  where?: Maybe<StudentOrParentTeachersBoolExp>;
}

/** order by aggregate values of table "classrooms" */
export interface StudentOrParentClassroomsAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentClassroomsMaxOrderBy>;
  min?: Maybe<StudentOrParentClassroomsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "classrooms". All fields are combined with a logical 'AND'. */
export interface StudentOrParentClassroomsBoolExp {
  _and?: Maybe<Array<StudentOrParentClassroomsBoolExp>>;
  _not?: Maybe<StudentOrParentClassroomsBoolExp>;
  _or?: Maybe<Array<StudentOrParentClassroomsBoolExp>>;
  course_classrooms?: Maybe<StudentOrParentCourseClassroomBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  floor?: Maybe<StudentOrParentStringComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  lessons?: Maybe<StudentOrParentLessonsBoolExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  room?: Maybe<StudentOrParentStringComparisonExp>;
  subject?: Maybe<StudentOrParentSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrParentUuidComparisonExp>;
  teachers?: Maybe<StudentOrParentTeachersBoolExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "classrooms" */
export interface StudentOrParentClassroomsMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  floor?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  room?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "classrooms" */
export interface StudentOrParentClassroomsMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  floor?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  room?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "classrooms". */
export interface StudentOrParentClassroomsOrderBy {
  course_classrooms_aggregate?: Maybe<StudentOrParentCourseClassroomAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  floor?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  lessons_aggregate?: Maybe<StudentOrParentLessonsAggregateOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  room?: Maybe<StudentOrParentOrderBy>;
  subject?: Maybe<StudentOrParentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  teachers_aggregate?: Maybe<StudentOrParentTeachersAggregateOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "classrooms" */
export const enum StudentOrParentClassroomsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FLOOR = 'floor',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  ROOM = 'room',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_class" */
export interface StudentOrParentCourseClass {
  /** An object relationship */
  class: EntireFieldWrapper<StudentOrParentClasses>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrParentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_class" */
export interface StudentOrParentCourseClassAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentCourseClassMaxOrderBy>;
  min?: Maybe<StudentOrParentCourseClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_class". All fields are combined with a logical 'AND'. */
export interface StudentOrParentCourseClassBoolExp {
  _and?: Maybe<Array<StudentOrParentCourseClassBoolExp>>;
  _not?: Maybe<StudentOrParentCourseClassBoolExp>;
  _or?: Maybe<Array<StudentOrParentCourseClassBoolExp>>;
  class?: Maybe<StudentOrParentClassesBoolExp>;
  class_id?: Maybe<StudentOrParentUuidComparisonExp>;
  course?: Maybe<StudentOrParentCoursesBoolExp>;
  course_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_class" */
export interface StudentOrParentCourseClassMaxOrderBy {
  class_id?: Maybe<StudentOrParentOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "course_class" */
export interface StudentOrParentCourseClassMinOrderBy {
  class_id?: Maybe<StudentOrParentOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "course_class". */
export interface StudentOrParentCourseClassOrderBy {
  class?: Maybe<StudentOrParentClassesOrderBy>;
  class_id?: Maybe<StudentOrParentOrderBy>;
  course?: Maybe<StudentOrParentCoursesOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "course_class" */
export const enum StudentOrParentCourseClassSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_classroom" */
export interface StudentOrParentCourseClassroom {
  /** An object relationship */
  classroom: EntireFieldWrapper<StudentOrParentClassrooms>;
  classroom_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrParentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_classroom" */
export interface StudentOrParentCourseClassroomAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentCourseClassroomMaxOrderBy>;
  min?: Maybe<StudentOrParentCourseClassroomMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_classroom". All fields are combined with a logical 'AND'. */
export interface StudentOrParentCourseClassroomBoolExp {
  _and?: Maybe<Array<StudentOrParentCourseClassroomBoolExp>>;
  _not?: Maybe<StudentOrParentCourseClassroomBoolExp>;
  _or?: Maybe<Array<StudentOrParentCourseClassroomBoolExp>>;
  classroom?: Maybe<StudentOrParentClassroomsBoolExp>;
  classroom_id?: Maybe<StudentOrParentUuidComparisonExp>;
  course?: Maybe<StudentOrParentCoursesBoolExp>;
  course_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_classroom" */
export interface StudentOrParentCourseClassroomMaxOrderBy {
  classroom_id?: Maybe<StudentOrParentOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "course_classroom" */
export interface StudentOrParentCourseClassroomMinOrderBy {
  classroom_id?: Maybe<StudentOrParentOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "course_classroom". */
export interface StudentOrParentCourseClassroomOrderBy {
  classroom?: Maybe<StudentOrParentClassroomsOrderBy>;
  classroom_id?: Maybe<StudentOrParentOrderBy>;
  course?: Maybe<StudentOrParentCoursesOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "course_classroom" */
export const enum StudentOrParentCourseClassroomSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_student" */
export interface StudentOrParentCourseStudent {
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrParentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentOrParentStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_student" */
export interface StudentOrParentCourseStudentAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentCourseStudentMaxOrderBy>;
  min?: Maybe<StudentOrParentCourseStudentMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_student". All fields are combined with a logical 'AND'. */
export interface StudentOrParentCourseStudentBoolExp {
  _and?: Maybe<Array<StudentOrParentCourseStudentBoolExp>>;
  _not?: Maybe<StudentOrParentCourseStudentBoolExp>;
  _or?: Maybe<Array<StudentOrParentCourseStudentBoolExp>>;
  course?: Maybe<StudentOrParentCoursesBoolExp>;
  course_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  student?: Maybe<StudentOrParentStudentsBoolExp>;
  student_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_student" */
export interface StudentOrParentCourseStudentMaxOrderBy {
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "course_student" */
export interface StudentOrParentCourseStudentMinOrderBy {
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "course_student". */
export interface StudentOrParentCourseStudentOrderBy {
  course?: Maybe<StudentOrParentCoursesOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  student?: Maybe<StudentOrParentStudentsOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "course_student" */
export const enum StudentOrParentCourseStudentSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "course_teacher" */
export interface StudentOrParentCourseTeacher {
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrParentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_primary: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  teacher: EntireFieldWrapper<StudentOrParentTeachers>;
  teacher_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "course_teacher" */
export interface StudentOrParentCourseTeacherAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentCourseTeacherMaxOrderBy>;
  min?: Maybe<StudentOrParentCourseTeacherMinOrderBy>;
}

/** Boolean expression to filter rows from the table "course_teacher". All fields are combined with a logical 'AND'. */
export interface StudentOrParentCourseTeacherBoolExp {
  _and?: Maybe<Array<StudentOrParentCourseTeacherBoolExp>>;
  _not?: Maybe<StudentOrParentCourseTeacherBoolExp>;
  _or?: Maybe<Array<StudentOrParentCourseTeacherBoolExp>>;
  course?: Maybe<StudentOrParentCoursesBoolExp>;
  course_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_primary?: Maybe<StudentOrParentBooleanComparisonExp>;
  teacher?: Maybe<StudentOrParentTeachersBoolExp>;
  teacher_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "course_teacher" */
export interface StudentOrParentCourseTeacherMaxOrderBy {
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  teacher_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "course_teacher" */
export interface StudentOrParentCourseTeacherMinOrderBy {
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  teacher_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "course_teacher". */
export interface StudentOrParentCourseTeacherOrderBy {
  course?: Maybe<StudentOrParentCoursesOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_primary?: Maybe<StudentOrParentOrderBy>;
  teacher?: Maybe<StudentOrParentTeachersOrderBy>;
  teacher_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "course_teacher" */
export const enum StudentOrParentCourseTeacherSelectColumn {
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PRIMARY = 'is_primary',
  /** column name */
  TEACHER_ID = 'teacher_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "courses" */
export interface StudentOrParentCourses {
  /** An array relationship */
  book_courses: EntireFieldWrapper<Array<StudentOrParentBookCourse>>;
  /** An array relationship */
  course_classes: EntireFieldWrapper<Array<StudentOrParentCourseClass>>;
  /** An array relationship */
  course_classrooms: EntireFieldWrapper<Array<StudentOrParentCourseClassroom>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<StudentOrParentCourseTeacher>>;
  /** An array relationship */
  course_users: EntireFieldWrapper<Array<StudentOrParentCourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_everybody: EntireFieldWrapper<Scalars['Boolean']>;
  is_mandatory: EntireFieldWrapper<Scalars['Boolean']>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentOrParentLessons>>;
  /** An object relationship */
  semester: EntireFieldWrapper<StudentOrParentSemesters>;
  semester_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  subject: EntireFieldWrapper<StudentOrParentSubjects>;
  subject_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "courses" */
export interface StudentOrParentCoursesBookCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookCourseOrderBy>>;
  where?: Maybe<StudentOrParentBookCourseBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrParentCoursesCourseClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseClassOrderBy>>;
  where?: Maybe<StudentOrParentCourseClassBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrParentCoursesCourseClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseClassroomOrderBy>>;
  where?: Maybe<StudentOrParentCourseClassroomBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrParentCoursesCourseTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseTeacherOrderBy>>;
  where?: Maybe<StudentOrParentCourseTeacherBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrParentCoursesCourseUsersArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseStudentOrderBy>>;
  where?: Maybe<StudentOrParentCourseStudentBoolExp>;
}


/** columns and relationships of "courses" */
export interface StudentOrParentCoursesLessonsArgs {
  distinct_on?: Maybe<Array<StudentOrParentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLessonsOrderBy>>;
  where?: Maybe<StudentOrParentLessonsBoolExp>;
}

/** order by aggregate values of table "courses" */
export interface StudentOrParentCoursesAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentCoursesMaxOrderBy>;
  min?: Maybe<StudentOrParentCoursesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "courses". All fields are combined with a logical 'AND'. */
export interface StudentOrParentCoursesBoolExp {
  _and?: Maybe<Array<StudentOrParentCoursesBoolExp>>;
  _not?: Maybe<StudentOrParentCoursesBoolExp>;
  _or?: Maybe<Array<StudentOrParentCoursesBoolExp>>;
  book_courses?: Maybe<StudentOrParentBookCourseBoolExp>;
  course_classes?: Maybe<StudentOrParentCourseClassBoolExp>;
  course_classrooms?: Maybe<StudentOrParentCourseClassroomBoolExp>;
  course_teachers?: Maybe<StudentOrParentCourseTeacherBoolExp>;
  course_users?: Maybe<StudentOrParentCourseStudentBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  description?: Maybe<StudentOrParentStringComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_everybody?: Maybe<StudentOrParentBooleanComparisonExp>;
  is_mandatory?: Maybe<StudentOrParentBooleanComparisonExp>;
  lessons?: Maybe<StudentOrParentLessonsBoolExp>;
  semester?: Maybe<StudentOrParentSemestersBoolExp>;
  semester_id?: Maybe<StudentOrParentUuidComparisonExp>;
  subject?: Maybe<StudentOrParentSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "courses" */
export interface StudentOrParentCoursesMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  semester_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "courses" */
export interface StudentOrParentCoursesMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  semester_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "courses". */
export interface StudentOrParentCoursesOrderBy {
  book_courses_aggregate?: Maybe<StudentOrParentBookCourseAggregateOrderBy>;
  course_classes_aggregate?: Maybe<StudentOrParentCourseClassAggregateOrderBy>;
  course_classrooms_aggregate?: Maybe<StudentOrParentCourseClassroomAggregateOrderBy>;
  course_teachers_aggregate?: Maybe<StudentOrParentCourseTeacherAggregateOrderBy>;
  course_users_aggregate?: Maybe<StudentOrParentCourseStudentAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_everybody?: Maybe<StudentOrParentOrderBy>;
  is_mandatory?: Maybe<StudentOrParentOrderBy>;
  lessons_aggregate?: Maybe<StudentOrParentLessonsAggregateOrderBy>;
  semester?: Maybe<StudentOrParentSemestersOrderBy>;
  semester_id?: Maybe<StudentOrParentOrderBy>;
  subject?: Maybe<StudentOrParentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "courses" */
export const enum StudentOrParentCoursesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  IS_EVERYBODY = 'is_everybody',
  /** column name */
  IS_MANDATORY = 'is_mandatory',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export interface StudentOrParentDateComparisonExp {
  _eq?: Maybe<Scalars['date']>;
  _gt?: Maybe<Scalars['date']>;
  _gte?: Maybe<Scalars['date']>;
  _in?: Maybe<Array<Scalars['date']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['date']>;
  _lte?: Maybe<Scalars['date']>;
  _neq?: Maybe<Scalars['date']>;
  _nin?: Maybe<Array<Scalars['date']>>;
}

/** columns and relationships of "event_users" */
export interface StudentOrParentEventUsers {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  event: EntireFieldWrapper<StudentOrParentEvents>;
  event_id: EntireFieldWrapper<Scalars['uuid']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  paid?: EntireFieldWrapper<Maybe<Scalars['Boolean']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "event_users". All fields are combined with a logical 'AND'. */
export interface StudentOrParentEventUsersBoolExp {
  _and?: Maybe<Array<StudentOrParentEventUsersBoolExp>>;
  _not?: Maybe<StudentOrParentEventUsersBoolExp>;
  _or?: Maybe<Array<StudentOrParentEventUsersBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  event?: Maybe<StudentOrParentEventsBoolExp>;
  event_id?: Maybe<StudentOrParentUuidComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  paid?: Maybe<StudentOrParentBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** Ordering options when selecting data from "event_users". */
export interface StudentOrParentEventUsersOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  event?: Maybe<StudentOrParentEventsOrderBy>;
  event_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  paid?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "event_users" */
export const enum StudentOrParentEventUsersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  EVENT_ID = 'event_id',
  /** column name */
  ID = 'id',
  /** column name */
  PAID = 'paid',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "events" */
export interface StudentOrParentEvents {
  cost: EntireFieldWrapper<Scalars['float8']>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  date: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  time?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title: EntireFieldWrapper<Scalars['String']>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export interface StudentOrParentEventsBoolExp {
  _and?: Maybe<Array<StudentOrParentEventsBoolExp>>;
  _not?: Maybe<StudentOrParentEventsBoolExp>;
  _or?: Maybe<Array<StudentOrParentEventsBoolExp>>;
  cost?: Maybe<StudentOrParentFloat8ComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  date?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  description?: Maybe<StudentOrParentStringComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  status?: Maybe<StudentOrParentStringComparisonExp>;
  time?: Maybe<StudentOrParentIntComparisonExp>;
  title?: Maybe<StudentOrParentStringComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** Ordering options when selecting data from "events". */
export interface StudentOrParentEventsOrderBy {
  cost?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  date?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  time?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "events" */
export const enum StudentOrParentEventsSelectColumn {
  /** column name */
  COST = 'cost',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DATE = 'date',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  ID = 'id',
  /** column name */
  STATUS = 'status',
  /** column name */
  TIME = 'time',
  /** column name */
  TITLE = 'title',
  /** column name */
  USER_ID = 'user_id'
};

export const enum StudentOrParentFileTableTypesEnum {
  ASSIGNMENT_SUBMITS = 'assignment_submits',
  ASSIGNMENTS = 'assignments',
  CHATS = 'chats',
  PROFILE_PICTURES = 'profile_pictures'
};

/** Boolean expression to compare columns of type "file_table_types_enum". All fields are combined with logical 'AND'. */
export interface StudentOrParentFileTableTypesEnumComparisonExp {
  _eq?: Maybe<StudentOrParentFileTableTypesEnum>;
  _in?: Maybe<Array<StudentOrParentFileTableTypesEnum>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _neq?: Maybe<StudentOrParentFileTableTypesEnum>;
  _nin?: Maybe<Array<StudentOrParentFileTableTypesEnum>>;
}

/** columns and relationships of "files" */
export interface StudentOrParentFiles {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  file_name: EntireFieldWrapper<Scalars['String']>;
  foreign_id: EntireFieldWrapper<Scalars['uuid']>;
  hash: EntireFieldWrapper<Scalars['String']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  path: EntireFieldWrapper<Scalars['String']>;
  table: EntireFieldWrapper<StudentOrParentFileTableTypesEnum>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** order by aggregate values of table "files" */
export interface StudentOrParentFilesAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentFilesMaxOrderBy>;
  min?: Maybe<StudentOrParentFilesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "files". All fields are combined with a logical 'AND'. */
export interface StudentOrParentFilesBoolExp {
  _and?: Maybe<Array<StudentOrParentFilesBoolExp>>;
  _not?: Maybe<StudentOrParentFilesBoolExp>;
  _or?: Maybe<Array<StudentOrParentFilesBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  file_name?: Maybe<StudentOrParentStringComparisonExp>;
  foreign_id?: Maybe<StudentOrParentUuidComparisonExp>;
  hash?: Maybe<StudentOrParentStringComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  path?: Maybe<StudentOrParentStringComparisonExp>;
  table?: Maybe<StudentOrParentFileTableTypesEnumComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "files" */
export interface StudentOrParentFilesMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  file_name?: Maybe<StudentOrParentOrderBy>;
  foreign_id?: Maybe<StudentOrParentOrderBy>;
  hash?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  path?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "files" */
export interface StudentOrParentFilesMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  file_name?: Maybe<StudentOrParentOrderBy>;
  foreign_id?: Maybe<StudentOrParentOrderBy>;
  hash?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  path?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "files". */
export interface StudentOrParentFilesOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  file_name?: Maybe<StudentOrParentOrderBy>;
  foreign_id?: Maybe<StudentOrParentOrderBy>;
  hash?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  path?: Maybe<StudentOrParentOrderBy>;
  table?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "files" */
export const enum StudentOrParentFilesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FILE_NAME = 'file_name',
  /** column name */
  FOREIGN_ID = 'foreign_id',
  /** column name */
  HASH = 'hash',
  /** column name */
  ID = 'id',
  /** column name */
  PATH = 'path',
  /** column name */
  TABLE = 'table',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export interface StudentOrParentFloat8ComparisonExp {
  _eq?: Maybe<Scalars['float8']>;
  _gt?: Maybe<Scalars['float8']>;
  _gte?: Maybe<Scalars['float8']>;
  _in?: Maybe<Array<Scalars['float8']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['float8']>;
  _lte?: Maybe<Scalars['float8']>;
  _neq?: Maybe<Scalars['float8']>;
  _nin?: Maybe<Array<Scalars['float8']>>;
}

/** columns and relationships of "grade_types" */
export interface StudentOrParentGradeTypes {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<StudentOrParentGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrParentGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrParentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrParentGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentOrParentViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentOrParentViewGradesAggregate>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrParentGradeTypesGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradeTypesOrderBy>>;
  where?: Maybe<StudentOrParentGradeTypesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrParentGradeTypesGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrParentGradeTypesGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrParentGradeTypesViewGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradesOrderBy>>;
  where?: Maybe<StudentOrParentViewGradesBoolExp>;
}


/** columns and relationships of "grade_types" */
export interface StudentOrParentGradeTypesViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradesOrderBy>>;
  where?: Maybe<StudentOrParentViewGradesBoolExp>;
}

/** order by aggregate values of table "grade_types" */
export interface StudentOrParentGradeTypesAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentGradeTypesMaxOrderBy>;
  min?: Maybe<StudentOrParentGradeTypesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "grade_types". All fields are combined with a logical 'AND'. */
export interface StudentOrParentGradeTypesBoolExp {
  _and?: Maybe<Array<StudentOrParentGradeTypesBoolExp>>;
  _not?: Maybe<StudentOrParentGradeTypesBoolExp>;
  _or?: Maybe<Array<StudentOrParentGradeTypesBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  grade_type?: Maybe<StudentOrParentGradeTypesBoolExp>;
  grade_type_id?: Maybe<StudentOrParentUuidComparisonExp>;
  grade_types?: Maybe<StudentOrParentGradeTypesBoolExp>;
  grades?: Maybe<StudentOrParentGradesBoolExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  view_grades?: Maybe<StudentOrParentViewGradesBoolExp>;
}

/** order by max() on columns of table "grade_types" */
export interface StudentOrParentGradeTypesMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "grade_types" */
export interface StudentOrParentGradeTypesMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "grade_types". */
export interface StudentOrParentGradeTypesOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  grade_type?: Maybe<StudentOrParentGradeTypesOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  grade_types_aggregate?: Maybe<StudentOrParentGradeTypesAggregateOrderBy>;
  grades_aggregate?: Maybe<StudentOrParentGradesAggregateOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  view_grades_aggregate?: Maybe<StudentOrParentViewGradesAggregateOrderBy>;
}

/** select columns of table "grade_types" */
export const enum StudentOrParentGradeTypesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "grades" */
export interface StudentOrParentGrades {
  /** An object relationship */
  assignment: EntireFieldWrapper<StudentOrParentAssignments>;
  assignment_id: EntireFieldWrapper<Scalars['uuid']>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<StudentOrParentGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  mark?: EntireFieldWrapper<Maybe<StudentOrParentMarks>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student: EntireFieldWrapper<StudentOrParentStudents>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  weight: EntireFieldWrapper<Scalars['Int']>;
}

/** aggregated selection of "grades" */
export interface StudentOrParentGradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentGradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentGrades>>;
}

/** aggregate fields of "grades" */
export interface StudentOrParentGradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrParentGradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentGradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentGradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrParentGradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrParentGradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrParentGradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrParentGradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrParentGradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrParentGradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrParentGradesVarianceFields>>;
}


/** aggregate fields of "grades" */
export interface StudentOrParentGradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "grades" */
export interface StudentOrParentGradesAggregateOrderBy {
  avg?: Maybe<StudentOrParentGradesAvgOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentGradesMaxOrderBy>;
  min?: Maybe<StudentOrParentGradesMinOrderBy>;
  stddev?: Maybe<StudentOrParentGradesStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrParentGradesStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrParentGradesStddevSampOrderBy>;
  sum?: Maybe<StudentOrParentGradesSumOrderBy>;
  var_pop?: Maybe<StudentOrParentGradesVarPopOrderBy>;
  var_samp?: Maybe<StudentOrParentGradesVarSampOrderBy>;
  variance?: Maybe<StudentOrParentGradesVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentOrParentGradesAvgFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "grades" */
export interface StudentOrParentGradesAvgOrderBy {
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** Boolean expression to filter rows from the table "grades". All fields are combined with a logical 'AND'. */
export interface StudentOrParentGradesBoolExp {
  _and?: Maybe<Array<StudentOrParentGradesBoolExp>>;
  _not?: Maybe<StudentOrParentGradesBoolExp>;
  _or?: Maybe<Array<StudentOrParentGradesBoolExp>>;
  assignment?: Maybe<StudentOrParentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrParentUuidComparisonExp>;
  comment?: Maybe<StudentOrParentStringComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  grade_type?: Maybe<StudentOrParentGradeTypesBoolExp>;
  grade_type_id?: Maybe<StudentOrParentUuidComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  mark?: Maybe<StudentOrParentMarksBoolExp>;
  mark_id?: Maybe<StudentOrParentUuidComparisonExp>;
  student?: Maybe<StudentOrParentStudentsBoolExp>;
  student_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  weight?: Maybe<StudentOrParentIntComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrParentGradesMaxFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "grades" */
export interface StudentOrParentGradesMaxOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  comment?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  mark_id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentGradesMinFields {
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  comment?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  mark_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "grades" */
export interface StudentOrParentGradesMinOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  comment?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  mark_id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "grades". */
export interface StudentOrParentGradesOrderBy {
  assignment?: Maybe<StudentOrParentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  comment?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  grade_type?: Maybe<StudentOrParentGradeTypesOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  mark?: Maybe<StudentOrParentMarksOrderBy>;
  mark_id?: Maybe<StudentOrParentOrderBy>;
  student?: Maybe<StudentOrParentStudentsOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "grades" */
export const enum StudentOrParentGradesSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  COMMENT = 'comment',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  MARK_ID = 'mark_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate stddev on columns */
export interface StudentOrParentGradesStddevFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "grades" */
export interface StudentOrParentGradesStddevOrderBy {
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrParentGradesStddevPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "grades" */
export interface StudentOrParentGradesStddevPopOrderBy {
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrParentGradesStddevSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "grades" */
export interface StudentOrParentGradesStddevSampOrderBy {
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate sum on columns */
export interface StudentOrParentGradesSumFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "grades" */
export interface StudentOrParentGradesSumOrderBy {
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentOrParentGradesVarPopFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "grades" */
export interface StudentOrParentGradesVarPopOrderBy {
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentOrParentGradesVarSampFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "grades" */
export interface StudentOrParentGradesVarSampOrderBy {
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate variance on columns */
export interface StudentOrParentGradesVarianceFields {
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "grades" */
export interface StudentOrParentGradesVarianceOrderBy {
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** columns and relationships of "lesson_attendace_type" */
export interface StudentOrParentLessonAttendaceType {
  name: EntireFieldWrapper<Scalars['String']>;
}

/** Boolean expression to filter rows from the table "lesson_attendace_type". All fields are combined with a logical 'AND'. */
export interface StudentOrParentLessonAttendaceTypeBoolExp {
  _and?: Maybe<Array<StudentOrParentLessonAttendaceTypeBoolExp>>;
  _not?: Maybe<StudentOrParentLessonAttendaceTypeBoolExp>;
  _or?: Maybe<Array<StudentOrParentLessonAttendaceTypeBoolExp>>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
}

/** Ordering options when selecting data from "lesson_attendace_type". */
export interface StudentOrParentLessonAttendaceTypeOrderBy {
  name?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "lesson_attendace_type" */
export const enum StudentOrParentLessonAttendaceTypeSelectColumn {
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "lesson_attendances" */
export interface StudentOrParentLessonAttendances {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  lesson: EntireFieldWrapper<StudentOrParentLessons>;
  lesson_id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "lesson_attendances" */
export interface StudentOrParentLessonAttendancesAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentLessonAttendancesMaxOrderBy>;
  min?: Maybe<StudentOrParentLessonAttendancesMinOrderBy>;
}

/** Boolean expression to filter rows from the table "lesson_attendances". All fields are combined with a logical 'AND'. */
export interface StudentOrParentLessonAttendancesBoolExp {
  _and?: Maybe<Array<StudentOrParentLessonAttendancesBoolExp>>;
  _not?: Maybe<StudentOrParentLessonAttendancesBoolExp>;
  _or?: Maybe<Array<StudentOrParentLessonAttendancesBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  lesson?: Maybe<StudentOrParentLessonsBoolExp>;
  lesson_id?: Maybe<StudentOrParentUuidComparisonExp>;
  type?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** order by max() on columns of table "lesson_attendances" */
export interface StudentOrParentLessonAttendancesMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  lesson_id?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "lesson_attendances" */
export interface StudentOrParentLessonAttendancesMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  lesson_id?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "lesson_attendances". */
export interface StudentOrParentLessonAttendancesOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  lesson?: Maybe<StudentOrParentLessonsOrderBy>;
  lesson_id?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "lesson_attendances" */
export const enum StudentOrParentLessonAttendancesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "lessons" */
export interface StudentOrParentLessons {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrParentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrParentAssignmentsAggregate>;
  /** An array relationship */
  attendaces: EntireFieldWrapper<Array<StudentOrParentLessonAttendances>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<StudentOrParentClassrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  course: EntireFieldWrapper<StudentOrParentCourses>;
  course_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_online: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  live_classes?: EntireFieldWrapper<Maybe<StudentOrParentLiveClasses>>;
  start_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "lessons" */
export interface StudentOrParentLessonsAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface StudentOrParentLessonsAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


/** columns and relationships of "lessons" */
export interface StudentOrParentLessonsAttendacesArgs {
  distinct_on?: Maybe<Array<StudentOrParentLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLessonAttendancesOrderBy>>;
  where?: Maybe<StudentOrParentLessonAttendancesBoolExp>;
}

/** order by aggregate values of table "lessons" */
export interface StudentOrParentLessonsAggregateOrderBy {
  avg?: Maybe<StudentOrParentLessonsAvgOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentLessonsMaxOrderBy>;
  min?: Maybe<StudentOrParentLessonsMinOrderBy>;
  stddev?: Maybe<StudentOrParentLessonsStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrParentLessonsStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrParentLessonsStddevSampOrderBy>;
  sum?: Maybe<StudentOrParentLessonsSumOrderBy>;
  var_pop?: Maybe<StudentOrParentLessonsVarPopOrderBy>;
  var_samp?: Maybe<StudentOrParentLessonsVarSampOrderBy>;
  variance?: Maybe<StudentOrParentLessonsVarianceOrderBy>;
}

/** order by avg() on columns of table "lessons" */
export interface StudentOrParentLessonsAvgOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** Boolean expression to filter rows from the table "lessons". All fields are combined with a logical 'AND'. */
export interface StudentOrParentLessonsBoolExp {
  _and?: Maybe<Array<StudentOrParentLessonsBoolExp>>;
  _not?: Maybe<StudentOrParentLessonsBoolExp>;
  _or?: Maybe<Array<StudentOrParentLessonsBoolExp>>;
  assignments?: Maybe<StudentOrParentAssignmentsBoolExp>;
  attendaces?: Maybe<StudentOrParentLessonAttendancesBoolExp>;
  classroom?: Maybe<StudentOrParentClassroomsBoolExp>;
  classroom_id?: Maybe<StudentOrParentUuidComparisonExp>;
  course?: Maybe<StudentOrParentCoursesBoolExp>;
  course_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  description?: Maybe<StudentOrParentStringComparisonExp>;
  duration?: Maybe<StudentOrParentIntComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_online?: Maybe<StudentOrParentBooleanComparisonExp>;
  live_classes?: Maybe<StudentOrParentLiveClassesBoolExp>;
  start_at?: Maybe<StudentOrParentTimetzComparisonExp>;
  start_date?: Maybe<StudentOrParentDateComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "lessons" */
export interface StudentOrParentLessonsMaxOrderBy {
  classroom_id?: Maybe<StudentOrParentOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  start_at?: Maybe<StudentOrParentOrderBy>;
  start_date?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "lessons" */
export interface StudentOrParentLessonsMinOrderBy {
  classroom_id?: Maybe<StudentOrParentOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  start_at?: Maybe<StudentOrParentOrderBy>;
  start_date?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "lessons". */
export interface StudentOrParentLessonsOrderBy {
  assignments_aggregate?: Maybe<StudentOrParentAssignmentsAggregateOrderBy>;
  attendaces_aggregate?: Maybe<StudentOrParentLessonAttendancesAggregateOrderBy>;
  classroom?: Maybe<StudentOrParentClassroomsOrderBy>;
  classroom_id?: Maybe<StudentOrParentOrderBy>;
  course?: Maybe<StudentOrParentCoursesOrderBy>;
  course_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_online?: Maybe<StudentOrParentOrderBy>;
  live_classes?: Maybe<StudentOrParentLiveClassesOrderBy>;
  start_at?: Maybe<StudentOrParentOrderBy>;
  start_date?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "lessons" */
export const enum StudentOrParentLessonsSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  COURSE_ID = 'course_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  IS_ONLINE = 'is_online',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** order by stddev() on columns of table "lessons" */
export interface StudentOrParentLessonsStddevOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_pop() on columns of table "lessons" */
export interface StudentOrParentLessonsStddevPopOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_samp() on columns of table "lessons" */
export interface StudentOrParentLessonsStddevSampOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** order by sum() on columns of table "lessons" */
export interface StudentOrParentLessonsSumOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_pop() on columns of table "lessons" */
export interface StudentOrParentLessonsVarPopOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_samp() on columns of table "lessons" */
export interface StudentOrParentLessonsVarSampOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** order by variance() on columns of table "lessons" */
export interface StudentOrParentLessonsVarianceOrderBy {
  duration?: Maybe<StudentOrParentOrderBy>;
}

/** columns and relationships of "live_classes" */
export interface StudentOrParentLiveClasses {
  attendeePW: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  description?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  duration: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  lesson_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meetingID: EntireFieldWrapper<Scalars['String']>;
  moderatorPW: EntireFieldWrapper<Scalars['String']>;
  name: EntireFieldWrapper<Scalars['String']>;
  recording_private_id?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  starting_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  status?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  voice_bridge?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** Boolean expression to filter rows from the table "live_classes". All fields are combined with a logical 'AND'. */
export interface StudentOrParentLiveClassesBoolExp {
  _and?: Maybe<Array<StudentOrParentLiveClassesBoolExp>>;
  _not?: Maybe<StudentOrParentLiveClassesBoolExp>;
  _or?: Maybe<Array<StudentOrParentLiveClassesBoolExp>>;
  attendeePW?: Maybe<StudentOrParentStringComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  description?: Maybe<StudentOrParentStringComparisonExp>;
  duration?: Maybe<StudentOrParentIntComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  lesson_id?: Maybe<StudentOrParentUuidComparisonExp>;
  meetingID?: Maybe<StudentOrParentStringComparisonExp>;
  moderatorPW?: Maybe<StudentOrParentStringComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  recording_private_id?: Maybe<StudentOrParentIntComparisonExp>;
  starting_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  status?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  voice_bridge?: Maybe<StudentOrParentStringComparisonExp>;
}

/** Ordering options when selecting data from "live_classes". */
export interface StudentOrParentLiveClassesOrderBy {
  attendeePW?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  description?: Maybe<StudentOrParentOrderBy>;
  duration?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  lesson_id?: Maybe<StudentOrParentOrderBy>;
  meetingID?: Maybe<StudentOrParentOrderBy>;
  moderatorPW?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  recording_private_id?: Maybe<StudentOrParentOrderBy>;
  starting_at?: Maybe<StudentOrParentOrderBy>;
  status?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  voice_bridge?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "live_classes" */
export const enum StudentOrParentLiveClassesSelectColumn {
  /** column name */
  ATTENDEEPW = 'attendeePW',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DESCRIPTION = 'description',
  /** column name */
  DURATION = 'duration',
  /** column name */
  ID = 'id',
  /** column name */
  LESSON_ID = 'lesson_id',
  /** column name */
  MEETINGID = 'meetingID',
  /** column name */
  MODERATORPW = 'moderatorPW',
  /** column name */
  NAME = 'name',
  /** column name */
  RECORDING_PRIVATE_ID = 'recording_private_id',
  /** column name */
  STARTING_AT = 'starting_at',
  /** column name */
  STATUS = 'status',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VOICE_BRIDGE = 'voice_bridge'
};

/** columns and relationships of "marks" */
export interface StudentOrParentMarks {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrParentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrParentGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  value: EntireFieldWrapper<Scalars['Int']>;
}


/** columns and relationships of "marks" */
export interface StudentOrParentMarksGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}


/** columns and relationships of "marks" */
export interface StudentOrParentMarksGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}

/** Boolean expression to filter rows from the table "marks". All fields are combined with a logical 'AND'. */
export interface StudentOrParentMarksBoolExp {
  _and?: Maybe<Array<StudentOrParentMarksBoolExp>>;
  _not?: Maybe<StudentOrParentMarksBoolExp>;
  _or?: Maybe<Array<StudentOrParentMarksBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  grades?: Maybe<StudentOrParentGradesBoolExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  value?: Maybe<StudentOrParentIntComparisonExp>;
}

/** Ordering options when selecting data from "marks". */
export interface StudentOrParentMarksOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  grades_aggregate?: Maybe<StudentOrParentGradesAggregateOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  value?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "marks" */
export const enum StudentOrParentMarksSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  VALUE = 'value'
};

/** columns and relationships of "meeting_user" */
export interface StudentOrParentMeetingUser {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  meeting_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "meeting_user" */
export interface StudentOrParentMeetingUserAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentMeetingUserAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentMeetingUser>>;
}

/** aggregate fields of "meeting_user" */
export interface StudentOrParentMeetingUserAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentMeetingUserMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentMeetingUserMinFields>>;
}


/** aggregate fields of "meeting_user" */
export interface StudentOrParentMeetingUserAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentMeetingUserSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "meeting_user". All fields are combined with a logical 'AND'. */
export interface StudentOrParentMeetingUserBoolExp {
  _and?: Maybe<Array<StudentOrParentMeetingUserBoolExp>>;
  _not?: Maybe<StudentOrParentMeetingUserBoolExp>;
  _or?: Maybe<Array<StudentOrParentMeetingUserBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  meeting_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrParentMeetingUserMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentOrParentMeetingUserMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  meeting_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Ordering options when selecting data from "meeting_user". */
export interface StudentOrParentMeetingUserOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  meeting_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "meeting_user" */
export const enum StudentOrParentMeetingUserSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  MEETING_ID = 'meeting_id',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** mutation root */
export interface StudentOrParentMutationRoot {
  change_password?: EntireFieldWrapper<Maybe<StudentOrParentMessageResponse>>;
  /** delete data from the table: "auth.account_providers" */
  delete_auth_account_providers?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProvidersMutationResponse>>;
  /** delete single row from the table: "auth.account_providers" */
  delete_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProviders>>;
  /** delete data from the table: "auth.account_roles" */
  delete_auth_account_roles?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRolesMutationResponse>>;
  /** delete single row from the table: "auth.account_roles" */
  delete_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRoles>>;
  /** delete data from the table: "auth.accounts" */
  delete_auth_accounts?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountsMutationResponse>>;
  /** delete single row from the table: "auth.accounts" */
  delete_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccounts>>;
  /** delete data from the table: "auth.providers" */
  delete_auth_providers?: EntireFieldWrapper<Maybe<StudentOrParentAuthProvidersMutationResponse>>;
  /** delete single row from the table: "auth.providers" */
  delete_auth_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthProviders>>;
  /** delete data from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokensMutationResponse>>;
  /** delete single row from the table: "auth.refresh_tokens" */
  delete_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokens>>;
  /** delete data from the table: "auth.roles" */
  delete_auth_roles?: EntireFieldWrapper<Maybe<StudentOrParentAuthRolesMutationResponse>>;
  /** delete single row from the table: "auth.roles" */
  delete_auth_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthRoles>>;
  /** delete data from the table: "chat_message_likes" */
  delete_chat_message_likes?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageLikesMutationResponse>>;
  /** delete single row from the table: "chat_message_likes" */
  delete_chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageLikes>>;
  /** delete data from the table: "chats" */
  delete_chats?: EntireFieldWrapper<Maybe<StudentOrParentChatsMutationResponse>>;
  /** delete single row from the table: "chats" */
  delete_chats_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChats>>;
  /** delete data from the table: "private.adresses" */
  delete_private_adresses?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdressesMutationResponse>>;
  /** delete single row from the table: "private.adresses" */
  delete_private_adresses_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdresses>>;
  /** delete data from the table: "private.birthdays" */
  delete_private_birthdays?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdaysMutationResponse>>;
  /** delete single row from the table: "private.birthdays" */
  delete_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdays>>;
  /** delete data from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbersMutationResponse>>;
  /** delete single row from the table: "private.insurance_numbers" */
  delete_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbers>>;
  /** delete data from the table: "private.phone_numbers" */
  delete_private_phone_numbers?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbersMutationResponse>>;
  /** delete single row from the table: "private.phone_numbers" */
  delete_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbers>>;
  /** delete data from the table: "relationships" */
  delete_relationships?: EntireFieldWrapper<Maybe<StudentOrParentRelationshipsMutationResponse>>;
  /** delete single row from the table: "relationships" */
  delete_relationships_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentRelationships>>;
  /** delete data from the table: "school_settings" */
  delete_school_settings?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsMutationResponse>>;
  /** delete single row from the table: "school_settings" */
  delete_school_settings_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettings>>;
  /** delete data from the table: "school_settings_modules" */
  delete_school_settings_modules?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModulesMutationResponse>>;
  /** delete single row from the table: "school_settings_modules" */
  delete_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModules>>;
  /** delete data from the table: "schools" */
  delete_schools?: EntireFieldWrapper<Maybe<StudentOrParentSchoolsMutationResponse>>;
  /** delete single row from the table: "schools" */
  delete_schools_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSchools>>;
  /** delete data from the table: "tasks" */
  delete_tasks?: EntireFieldWrapper<Maybe<StudentOrParentTasksMutationResponse>>;
  /** delete single row from the table: "tasks" */
  delete_tasks_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentTasks>>;
  /** delete data from the table: "users" */
  delete_users?: EntireFieldWrapper<Maybe<StudentOrParentUsersMutationResponse>>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  /** insert data into the table: "auth.account_providers" */
  insert_auth_account_providers?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.account_providers" */
  insert_auth_account_providers_one?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProviders>>;
  /** insert data into the table: "auth.account_roles" */
  insert_auth_account_roles?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRolesMutationResponse>>;
  /** insert a single row into the table: "auth.account_roles" */
  insert_auth_account_roles_one?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRoles>>;
  /** insert data into the table: "auth.accounts" */
  insert_auth_accounts?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountsMutationResponse>>;
  /** insert a single row into the table: "auth.accounts" */
  insert_auth_accounts_one?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccounts>>;
  /** insert data into the table: "auth.providers" */
  insert_auth_providers?: EntireFieldWrapper<Maybe<StudentOrParentAuthProvidersMutationResponse>>;
  /** insert a single row into the table: "auth.providers" */
  insert_auth_providers_one?: EntireFieldWrapper<Maybe<StudentOrParentAuthProviders>>;
  /** insert data into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokensMutationResponse>>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insert_auth_refresh_tokens_one?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokens>>;
  /** insert data into the table: "auth.roles" */
  insert_auth_roles?: EntireFieldWrapper<Maybe<StudentOrParentAuthRolesMutationResponse>>;
  /** insert a single row into the table: "auth.roles" */
  insert_auth_roles_one?: EntireFieldWrapper<Maybe<StudentOrParentAuthRoles>>;
  /** insert data into the table: "chat_message_likes" */
  insert_chat_message_likes?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageLikesMutationResponse>>;
  /** insert a single row into the table: "chat_message_likes" */
  insert_chat_message_likes_one?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageLikes>>;
  /** insert data into the table: "chat_message_reads" */
  insert_chat_message_reads?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageReadsMutationResponse>>;
  /** insert a single row into the table: "chat_message_reads" */
  insert_chat_message_reads_one?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageReads>>;
  /** insert data into the table: "chat_messages" */
  insert_chat_messages?: EntireFieldWrapper<Maybe<StudentOrParentChatMessagesMutationResponse>>;
  /** insert a single row into the table: "chat_messages" */
  insert_chat_messages_one?: EntireFieldWrapper<Maybe<StudentOrParentChatMessages>>;
  /** insert data into the table: "chat_user" */
  insert_chat_user?: EntireFieldWrapper<Maybe<StudentOrParentChatUserMutationResponse>>;
  /** insert a single row into the table: "chat_user" */
  insert_chat_user_one?: EntireFieldWrapper<Maybe<StudentOrParentChatUser>>;
  /** insert data into the table: "chats" */
  insert_chats?: EntireFieldWrapper<Maybe<StudentOrParentChatsMutationResponse>>;
  /** insert a single row into the table: "chats" */
  insert_chats_one?: EntireFieldWrapper<Maybe<StudentOrParentChats>>;
  /** insert data into the table: "private.adresses" */
  insert_private_adresses?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdressesMutationResponse>>;
  /** insert a single row into the table: "private.adresses" */
  insert_private_adresses_one?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdresses>>;
  /** insert data into the table: "private.birthdays" */
  insert_private_birthdays?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdaysMutationResponse>>;
  /** insert a single row into the table: "private.birthdays" */
  insert_private_birthdays_one?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdays>>;
  /** insert data into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbersMutationResponse>>;
  /** insert a single row into the table: "private.insurance_numbers" */
  insert_private_insurance_numbers_one?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbers>>;
  /** insert data into the table: "private.phone_numbers" */
  insert_private_phone_numbers?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbersMutationResponse>>;
  /** insert a single row into the table: "private.phone_numbers" */
  insert_private_phone_numbers_one?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbers>>;
  /** insert data into the table: "relationships" */
  insert_relationships?: EntireFieldWrapper<Maybe<StudentOrParentRelationshipsMutationResponse>>;
  /** insert a single row into the table: "relationships" */
  insert_relationships_one?: EntireFieldWrapper<Maybe<StudentOrParentRelationships>>;
  /** insert data into the table: "school_settings" */
  insert_school_settings?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsMutationResponse>>;
  /** insert data into the table: "school_settings_modules" */
  insert_school_settings_modules?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModulesMutationResponse>>;
  /** insert a single row into the table: "school_settings_modules" */
  insert_school_settings_modules_one?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModules>>;
  /** insert a single row into the table: "school_settings" */
  insert_school_settings_one?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettings>>;
  /** insert data into the table: "schools" */
  insert_schools?: EntireFieldWrapper<Maybe<StudentOrParentSchoolsMutationResponse>>;
  /** insert a single row into the table: "schools" */
  insert_schools_one?: EntireFieldWrapper<Maybe<StudentOrParentSchools>>;
  /** insert data into the table: "users" */
  insert_users?: EntireFieldWrapper<Maybe<StudentOrParentUsersMutationResponse>>;
  /** insert a single row into the table: "users" */
  insert_users_one?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  invite_parent?: EntireFieldWrapper<Maybe<StudentOrParentSession>>;
  invite_student?: EntireFieldWrapper<Maybe<StudentOrParentSession>>;
  lost_password?: EntireFieldWrapper<Maybe<StudentOrParentMessageResponse>>;
  refresh_token?: EntireFieldWrapper<Maybe<StudentOrParentSession>>;
  reset_password?: EntireFieldWrapper<Maybe<StudentOrParentMessageResponse>>;
  revoke_token?: EntireFieldWrapper<Maybe<StudentOrParentMessageResponse>>;
  /** update data of the table: "auth.account_providers" */
  update_auth_account_providers?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProvidersMutationResponse>>;
  /** update single row of the table: "auth.account_providers" */
  update_auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProviders>>;
  /** update data of the table: "auth.account_roles" */
  update_auth_account_roles?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRolesMutationResponse>>;
  /** update single row of the table: "auth.account_roles" */
  update_auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRoles>>;
  /** update data of the table: "auth.accounts" */
  update_auth_accounts?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountsMutationResponse>>;
  /** update single row of the table: "auth.accounts" */
  update_auth_accounts_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccounts>>;
  /** update data of the table: "auth.providers" */
  update_auth_providers?: EntireFieldWrapper<Maybe<StudentOrParentAuthProvidersMutationResponse>>;
  /** update single row of the table: "auth.providers" */
  update_auth_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthProviders>>;
  /** update data of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokensMutationResponse>>;
  /** update single row of the table: "auth.refresh_tokens" */
  update_auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokens>>;
  /** update data of the table: "auth.roles" */
  update_auth_roles?: EntireFieldWrapper<Maybe<StudentOrParentAuthRolesMutationResponse>>;
  /** update single row of the table: "auth.roles" */
  update_auth_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthRoles>>;
  /** update data of the table: "chat_message_reads" */
  update_chat_message_reads?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageReadsMutationResponse>>;
  /** update single row of the table: "chat_message_reads" */
  update_chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageReads>>;
  /** update data of the table: "chat_messages" */
  update_chat_messages?: EntireFieldWrapper<Maybe<StudentOrParentChatMessagesMutationResponse>>;
  /** update single row of the table: "chat_messages" */
  update_chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatMessages>>;
  /** update data of the table: "chats" */
  update_chats?: EntireFieldWrapper<Maybe<StudentOrParentChatsMutationResponse>>;
  /** update single row of the table: "chats" */
  update_chats_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChats>>;
  /** update data of the table: "private.adresses" */
  update_private_adresses?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdressesMutationResponse>>;
  /** update single row of the table: "private.adresses" */
  update_private_adresses_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdresses>>;
  /** update data of the table: "private.birthdays" */
  update_private_birthdays?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdaysMutationResponse>>;
  /** update single row of the table: "private.birthdays" */
  update_private_birthdays_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdays>>;
  /** update data of the table: "private.insurance_numbers" */
  update_private_insurance_numbers?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbersMutationResponse>>;
  /** update single row of the table: "private.insurance_numbers" */
  update_private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbers>>;
  /** update data of the table: "private.phone_numbers" */
  update_private_phone_numbers?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbersMutationResponse>>;
  /** update single row of the table: "private.phone_numbers" */
  update_private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbers>>;
  /** update data of the table: "relationships" */
  update_relationships?: EntireFieldWrapper<Maybe<StudentOrParentRelationshipsMutationResponse>>;
  /** update single row of the table: "relationships" */
  update_relationships_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentRelationships>>;
  /** update data of the table: "school_settings" */
  update_school_settings?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsMutationResponse>>;
  /** update single row of the table: "school_settings" */
  update_school_settings_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettings>>;
  /** update data of the table: "school_settings_modules" */
  update_school_settings_modules?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModulesMutationResponse>>;
  /** update single row of the table: "school_settings_modules" */
  update_school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModules>>;
  /** update data of the table: "schools" */
  update_schools?: EntireFieldWrapper<Maybe<StudentOrParentSchoolsMutationResponse>>;
  /** update single row of the table: "schools" */
  update_schools_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSchools>>;
  /** update data of the table: "users" */
  update_users?: EntireFieldWrapper<Maybe<StudentOrParentUsersMutationResponse>>;
  /** update single row of the table: "users" */
  update_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
}


/** mutation root */
export interface StudentOrParentMutationRootChangePasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthAccountProvidersArgs {
  where: StudentOrParentAuthAccountProvidersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthAccountRolesArgs {
  where: StudentOrParentAuthAccountRolesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthAccountsArgs {
  where: StudentOrParentAuthAccountsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthProvidersArgs {
  where: StudentOrParentAuthProvidersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthRefreshTokensArgs {
  where: StudentOrParentAuthRefreshTokensBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthRolesArgs {
  where: StudentOrParentAuthRolesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteAuthRolesByPkArgs {
  role: Scalars['String'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteChatMessageLikesArgs {
  where: StudentOrParentChatMessageLikesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteChatsArgs {
  where: StudentOrParentChatsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteChatsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeletePrivateAdressesArgs {
  where: StudentOrParentPrivateAdressesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeletePrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeletePrivateBirthdaysArgs {
  where: StudentOrParentPrivateBirthdaysBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeletePrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeletePrivateInsuranceNumbersArgs {
  where: StudentOrParentPrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeletePrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeletePrivatePhoneNumbersArgs {
  where: StudentOrParentPrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeletePrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteRelationshipsArgs {
  where: StudentOrParentRelationshipsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteSchoolSettingsArgs {
  where: StudentOrParentSchoolSettingsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteSchoolSettingsModulesArgs {
  where: StudentOrParentSchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteSchoolsArgs {
  where: StudentOrParentSchoolsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteSchoolsByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteTasksArgs {
  where: StudentOrParentTasksBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteTasksByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteUsersArgs {
  where: StudentOrParentUsersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootDeleteUsersByPkArgs {
  id: Scalars['uuid'];
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthAccountProvidersArgs {
  objects: Array<StudentOrParentAuthAccountProvidersInsertInput>;
  on_conflict?: Maybe<StudentOrParentAuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthAccountProvidersOneArgs {
  object: StudentOrParentAuthAccountProvidersInsertInput;
  on_conflict?: Maybe<StudentOrParentAuthAccountProvidersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthAccountRolesArgs {
  objects: Array<StudentOrParentAuthAccountRolesInsertInput>;
  on_conflict?: Maybe<StudentOrParentAuthAccountRolesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthAccountRolesOneArgs {
  object: StudentOrParentAuthAccountRolesInsertInput;
  on_conflict?: Maybe<StudentOrParentAuthAccountRolesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthAccountsArgs {
  objects: Array<StudentOrParentAuthAccountsInsertInput>;
  on_conflict?: Maybe<StudentOrParentAuthAccountsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthAccountsOneArgs {
  object: StudentOrParentAuthAccountsInsertInput;
  on_conflict?: Maybe<StudentOrParentAuthAccountsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthProvidersArgs {
  objects: Array<StudentOrParentAuthProvidersInsertInput>;
  on_conflict?: Maybe<StudentOrParentAuthProvidersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthProvidersOneArgs {
  object: StudentOrParentAuthProvidersInsertInput;
  on_conflict?: Maybe<StudentOrParentAuthProvidersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthRefreshTokensArgs {
  objects: Array<StudentOrParentAuthRefreshTokensInsertInput>;
  on_conflict?: Maybe<StudentOrParentAuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthRefreshTokensOneArgs {
  object: StudentOrParentAuthRefreshTokensInsertInput;
  on_conflict?: Maybe<StudentOrParentAuthRefreshTokensOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthRolesArgs {
  objects: Array<StudentOrParentAuthRolesInsertInput>;
  on_conflict?: Maybe<StudentOrParentAuthRolesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertAuthRolesOneArgs {
  object: StudentOrParentAuthRolesInsertInput;
  on_conflict?: Maybe<StudentOrParentAuthRolesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatMessageLikesArgs {
  objects: Array<StudentOrParentChatMessageLikesInsertInput>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatMessageLikesOneArgs {
  object: StudentOrParentChatMessageLikesInsertInput;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatMessageReadsArgs {
  objects: Array<StudentOrParentChatMessageReadsInsertInput>;
  on_conflict?: Maybe<StudentOrParentChatMessageReadsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatMessageReadsOneArgs {
  object: StudentOrParentChatMessageReadsInsertInput;
  on_conflict?: Maybe<StudentOrParentChatMessageReadsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatMessagesArgs {
  objects: Array<StudentOrParentChatMessagesInsertInput>;
  on_conflict?: Maybe<StudentOrParentChatMessagesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatMessagesOneArgs {
  object: StudentOrParentChatMessagesInsertInput;
  on_conflict?: Maybe<StudentOrParentChatMessagesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatUserArgs {
  objects: Array<StudentOrParentChatUserInsertInput>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatUserOneArgs {
  object: StudentOrParentChatUserInsertInput;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatsArgs {
  objects: Array<StudentOrParentChatsInsertInput>;
  on_conflict?: Maybe<StudentOrParentChatsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertChatsOneArgs {
  object: StudentOrParentChatsInsertInput;
  on_conflict?: Maybe<StudentOrParentChatsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertPrivateAdressesArgs {
  objects: Array<StudentOrParentPrivateAdressesInsertInput>;
  on_conflict?: Maybe<StudentOrParentPrivateAdressesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertPrivateAdressesOneArgs {
  object: StudentOrParentPrivateAdressesInsertInput;
  on_conflict?: Maybe<StudentOrParentPrivateAdressesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertPrivateBirthdaysArgs {
  objects: Array<StudentOrParentPrivateBirthdaysInsertInput>;
  on_conflict?: Maybe<StudentOrParentPrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertPrivateBirthdaysOneArgs {
  object: StudentOrParentPrivateBirthdaysInsertInput;
  on_conflict?: Maybe<StudentOrParentPrivateBirthdaysOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertPrivateInsuranceNumbersArgs {
  objects: Array<StudentOrParentPrivateInsuranceNumbersInsertInput>;
  on_conflict?: Maybe<StudentOrParentPrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertPrivateInsuranceNumbersOneArgs {
  object: StudentOrParentPrivateInsuranceNumbersInsertInput;
  on_conflict?: Maybe<StudentOrParentPrivateInsuranceNumbersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertPrivatePhoneNumbersArgs {
  objects: Array<StudentOrParentPrivatePhoneNumbersInsertInput>;
  on_conflict?: Maybe<StudentOrParentPrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertPrivatePhoneNumbersOneArgs {
  object: StudentOrParentPrivatePhoneNumbersInsertInput;
  on_conflict?: Maybe<StudentOrParentPrivatePhoneNumbersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertRelationshipsArgs {
  objects: Array<StudentOrParentRelationshipsInsertInput>;
  on_conflict?: Maybe<StudentOrParentRelationshipsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertRelationshipsOneArgs {
  object: StudentOrParentRelationshipsInsertInput;
  on_conflict?: Maybe<StudentOrParentRelationshipsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertSchoolSettingsArgs {
  objects: Array<StudentOrParentSchoolSettingsInsertInput>;
  on_conflict?: Maybe<StudentOrParentSchoolSettingsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertSchoolSettingsModulesArgs {
  objects: Array<StudentOrParentSchoolSettingsModulesInsertInput>;
  on_conflict?: Maybe<StudentOrParentSchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertSchoolSettingsModulesOneArgs {
  object: StudentOrParentSchoolSettingsModulesInsertInput;
  on_conflict?: Maybe<StudentOrParentSchoolSettingsModulesOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertSchoolSettingsOneArgs {
  object: StudentOrParentSchoolSettingsInsertInput;
  on_conflict?: Maybe<StudentOrParentSchoolSettingsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertSchoolsArgs {
  objects: Array<StudentOrParentSchoolsInsertInput>;
  on_conflict?: Maybe<StudentOrParentSchoolsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertSchoolsOneArgs {
  object: StudentOrParentSchoolsInsertInput;
  on_conflict?: Maybe<StudentOrParentSchoolsOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertUsersArgs {
  objects: Array<StudentOrParentUsersInsertInput>;
  on_conflict?: Maybe<StudentOrParentUsersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInsertUsersOneArgs {
  object: StudentOrParentUsersInsertInput;
  on_conflict?: Maybe<StudentOrParentUsersOnConflict>;
}


/** mutation root */
export interface StudentOrParentMutationRootInviteParentArgs {
  email: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  school_options?: Maybe<StudentOrParentInviteParentInput>;
  user_data: StudentOrParentUserInsertInput;
}


/** mutation root */
export interface StudentOrParentMutationRootInviteStudentArgs {
  email: Scalars['String'];
  password?: Maybe<Scalars['String']>;
  school_options: StudentOrParentInviteStudentClassInsertInput;
  user_data: StudentOrParentUserInsertInput;
}


/** mutation root */
export interface StudentOrParentMutationRootLostPasswordArgs {
  email: Scalars['String'];
}


/** mutation root */
export interface StudentOrParentMutationRootRefreshTokenArgs {
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface StudentOrParentMutationRootResetPasswordArgs {
  new_password: Scalars['String'];
  old_password: Scalars['String'];
}


/** mutation root */
export interface StudentOrParentMutationRootRevokeTokenArgs {
  all?: Maybe<Scalars['Boolean']>;
  refresh_token: Scalars['String'];
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthAccountProvidersArgs {
  _set?: Maybe<StudentOrParentAuthAccountProvidersSetInput>;
  where: StudentOrParentAuthAccountProvidersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthAccountProvidersByPkArgs {
  _set?: Maybe<StudentOrParentAuthAccountProvidersSetInput>;
  pk_columns: StudentOrParentAuthAccountProvidersPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthAccountRolesArgs {
  _set?: Maybe<StudentOrParentAuthAccountRolesSetInput>;
  where: StudentOrParentAuthAccountRolesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthAccountRolesByPkArgs {
  _set?: Maybe<StudentOrParentAuthAccountRolesSetInput>;
  pk_columns: StudentOrParentAuthAccountRolesPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthAccountsArgs {
  _set?: Maybe<StudentOrParentAuthAccountsSetInput>;
  where: StudentOrParentAuthAccountsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthAccountsByPkArgs {
  _set?: Maybe<StudentOrParentAuthAccountsSetInput>;
  pk_columns: StudentOrParentAuthAccountsPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthProvidersArgs {
  _set?: Maybe<StudentOrParentAuthProvidersSetInput>;
  where: StudentOrParentAuthProvidersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthProvidersByPkArgs {
  _set?: Maybe<StudentOrParentAuthProvidersSetInput>;
  pk_columns: StudentOrParentAuthProvidersPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthRefreshTokensArgs {
  _set?: Maybe<StudentOrParentAuthRefreshTokensSetInput>;
  where: StudentOrParentAuthRefreshTokensBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthRefreshTokensByPkArgs {
  _set?: Maybe<StudentOrParentAuthRefreshTokensSetInput>;
  pk_columns: StudentOrParentAuthRefreshTokensPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthRolesArgs {
  _set?: Maybe<StudentOrParentAuthRolesSetInput>;
  where: StudentOrParentAuthRolesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateAuthRolesByPkArgs {
  _set?: Maybe<StudentOrParentAuthRolesSetInput>;
  pk_columns: StudentOrParentAuthRolesPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateChatMessageReadsArgs {
  _set?: Maybe<StudentOrParentChatMessageReadsSetInput>;
  where: StudentOrParentChatMessageReadsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateChatMessageReadsByPkArgs {
  _set?: Maybe<StudentOrParentChatMessageReadsSetInput>;
  pk_columns: StudentOrParentChatMessageReadsPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateChatMessagesArgs {
  _set?: Maybe<StudentOrParentChatMessagesSetInput>;
  where: StudentOrParentChatMessagesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateChatMessagesByPkArgs {
  _set?: Maybe<StudentOrParentChatMessagesSetInput>;
  pk_columns: StudentOrParentChatMessagesPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateChatsArgs {
  _set?: Maybe<StudentOrParentChatsSetInput>;
  where: StudentOrParentChatsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateChatsByPkArgs {
  _set?: Maybe<StudentOrParentChatsSetInput>;
  pk_columns: StudentOrParentChatsPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdatePrivateAdressesArgs {
  _set?: Maybe<StudentOrParentPrivateAdressesSetInput>;
  where: StudentOrParentPrivateAdressesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdatePrivateAdressesByPkArgs {
  _set?: Maybe<StudentOrParentPrivateAdressesSetInput>;
  pk_columns: StudentOrParentPrivateAdressesPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdatePrivateBirthdaysArgs {
  _set?: Maybe<StudentOrParentPrivateBirthdaysSetInput>;
  where: StudentOrParentPrivateBirthdaysBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdatePrivateBirthdaysByPkArgs {
  _set?: Maybe<StudentOrParentPrivateBirthdaysSetInput>;
  pk_columns: StudentOrParentPrivateBirthdaysPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdatePrivateInsuranceNumbersArgs {
  _set?: Maybe<StudentOrParentPrivateInsuranceNumbersSetInput>;
  where: StudentOrParentPrivateInsuranceNumbersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdatePrivateInsuranceNumbersByPkArgs {
  _set?: Maybe<StudentOrParentPrivateInsuranceNumbersSetInput>;
  pk_columns: StudentOrParentPrivateInsuranceNumbersPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdatePrivatePhoneNumbersArgs {
  _set?: Maybe<StudentOrParentPrivatePhoneNumbersSetInput>;
  where: StudentOrParentPrivatePhoneNumbersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdatePrivatePhoneNumbersByPkArgs {
  _set?: Maybe<StudentOrParentPrivatePhoneNumbersSetInput>;
  pk_columns: StudentOrParentPrivatePhoneNumbersPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateRelationshipsArgs {
  _set?: Maybe<StudentOrParentRelationshipsSetInput>;
  where: StudentOrParentRelationshipsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateRelationshipsByPkArgs {
  _set?: Maybe<StudentOrParentRelationshipsSetInput>;
  pk_columns: StudentOrParentRelationshipsPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateSchoolSettingsArgs {
  _set?: Maybe<StudentOrParentSchoolSettingsSetInput>;
  where: StudentOrParentSchoolSettingsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateSchoolSettingsByPkArgs {
  _set?: Maybe<StudentOrParentSchoolSettingsSetInput>;
  pk_columns: StudentOrParentSchoolSettingsPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateSchoolSettingsModulesArgs {
  _set?: Maybe<StudentOrParentSchoolSettingsModulesSetInput>;
  where: StudentOrParentSchoolSettingsModulesBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateSchoolSettingsModulesByPkArgs {
  _set?: Maybe<StudentOrParentSchoolSettingsModulesSetInput>;
  pk_columns: StudentOrParentSchoolSettingsModulesPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateSchoolsArgs {
  _set?: Maybe<StudentOrParentSchoolsSetInput>;
  where: StudentOrParentSchoolsBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateSchoolsByPkArgs {
  _set?: Maybe<StudentOrParentSchoolsSetInput>;
  pk_columns: StudentOrParentSchoolsPkColumnsInput;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateUsersArgs {
  _set?: Maybe<StudentOrParentUsersSetInput>;
  where: StudentOrParentUsersBoolExp;
}


/** mutation root */
export interface StudentOrParentMutationRootUpdateUsersByPkArgs {
  _set?: Maybe<StudentOrParentUsersSetInput>;
  pk_columns: StudentOrParentUsersPkColumnsInput;
}


/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export interface StudentOrParentNumericComparisonExp {
  _eq?: Maybe<Scalars['numeric']>;
  _gt?: Maybe<Scalars['numeric']>;
  _gte?: Maybe<Scalars['numeric']>;
  _in?: Maybe<Array<Scalars['numeric']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['numeric']>;
  _lte?: Maybe<Scalars['numeric']>;
  _neq?: Maybe<Scalars['numeric']>;
  _nin?: Maybe<Array<Scalars['numeric']>>;
}

/** column ordering options */
export const enum StudentOrParentOrderBy {
  /** in ascending order, nulls last */
  ASC = 'asc',
  /** in ascending order, nulls first */
  ASC_NULLS_FIRST = 'asc_nulls_first',
  /** in ascending order, nulls last */
  ASC_NULLS_LAST = 'asc_nulls_last',
  /** in descending order, nulls first */
  DESC = 'desc',
  /** in descending order, nulls first */
  DESC_NULLS_FIRST = 'desc_nulls_first',
  /** in descending order, nulls last */
  DESC_NULLS_LAST = 'desc_nulls_last'
};

/** columns and relationships of "parent_student" */
export interface StudentOrParentParentStudent {
  id: EntireFieldWrapper<Scalars['uuid']>;
  parent_id: EntireFieldWrapper<Scalars['uuid']>;
  student?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  student_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** Boolean expression to filter rows from the table "parent_student". All fields are combined with a logical 'AND'. */
export interface StudentOrParentParentStudentBoolExp {
  _and?: Maybe<Array<StudentOrParentParentStudentBoolExp>>;
  _not?: Maybe<StudentOrParentParentStudentBoolExp>;
  _or?: Maybe<Array<StudentOrParentParentStudentBoolExp>>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  parent_id?: Maybe<StudentOrParentUuidComparisonExp>;
  student_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** Ordering options when selecting data from "parent_student". */
export interface StudentOrParentParentStudentOrderBy {
  id?: Maybe<StudentOrParentOrderBy>;
  parent_id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "parent_student" */
export const enum StudentOrParentParentStudentSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "parents" */
export interface StudentOrParentParents {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "parents". All fields are combined with a logical 'AND'. */
export interface StudentOrParentParentsBoolExp {
  _and?: Maybe<Array<StudentOrParentParentsBoolExp>>;
  _not?: Maybe<StudentOrParentParentsBoolExp>;
  _or?: Maybe<Array<StudentOrParentParentsBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "parents". */
export interface StudentOrParentParentsOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "parents" */
export const enum StudentOrParentParentsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.adresses" */
export interface StudentOrParentPrivateAdresses {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentOrParentUsers>;
}

/** aggregated selection of "private.adresses" */
export interface StudentOrParentPrivateAdressesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdressesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentPrivateAdresses>>;
}

/** aggregate fields of "private.adresses" */
export interface StudentOrParentPrivateAdressesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdressesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdressesMinFields>>;
}


/** aggregate fields of "private.adresses" */
export interface StudentOrParentPrivateAdressesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentPrivateAdressesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.adresses". All fields are combined with a logical 'AND'. */
export interface StudentOrParentPrivateAdressesBoolExp {
  _and?: Maybe<Array<StudentOrParentPrivateAdressesBoolExp>>;
  _not?: Maybe<StudentOrParentPrivateAdressesBoolExp>;
  _or?: Maybe<Array<StudentOrParentPrivateAdressesBoolExp>>;
  area?: Maybe<StudentOrParentStringComparisonExp>;
  city?: Maybe<StudentOrParentStringComparisonExp>;
  country?: Maybe<StudentOrParentStringComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  postal_code?: Maybe<StudentOrParentStringComparisonExp>;
  street?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user?: Maybe<StudentOrParentUsersBoolExp>;
}

/** unique or primary key constraints on table "private.adresses" */
export const enum StudentOrParentPrivateAdressesConstraint {
  /** unique or primary key constraint */
  ADRESSES_PKEY = 'adresses_pkey'
};

/** input type for inserting data into table "private.adresses" */
export interface StudentOrParentPrivateAdressesInsertInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentOrParentUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentOrParentPrivateAdressesMaxFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrParentPrivateAdressesMinFields {
  area?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  city?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  country?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  postal_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  street?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.adresses" */
export interface StudentOrParentPrivateAdressesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentPrivateAdresses>>;
}

/** input type for inserting object relation for remote table "private.adresses" */
export interface StudentOrParentPrivateAdressesObjRelInsertInput {
  data: StudentOrParentPrivateAdressesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentPrivateAdressesOnConflict>;
}

/** on conflict condition type for table "private.adresses" */
export interface StudentOrParentPrivateAdressesOnConflict {
  constraint: StudentOrParentPrivateAdressesConstraint;
  update_columns?: Array<StudentOrParentPrivateAdressesUpdateColumn>;
  where?: Maybe<StudentOrParentPrivateAdressesBoolExp>;
}

/** Ordering options when selecting data from "private.adresses". */
export interface StudentOrParentPrivateAdressesOrderBy {
  area?: Maybe<StudentOrParentOrderBy>;
  city?: Maybe<StudentOrParentOrderBy>;
  country?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  postal_code?: Maybe<StudentOrParentOrderBy>;
  street?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user?: Maybe<StudentOrParentUsersOrderBy>;
}

/** primary key columns input for table: private_adresses */
export interface StudentOrParentPrivateAdressesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.adresses" */
export const enum StudentOrParentPrivateAdressesSelectColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.adresses" */
export interface StudentOrParentPrivateAdressesSetInput {
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  postal_code?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.adresses" */
export const enum StudentOrParentPrivateAdressesUpdateColumn {
  /** column name */
  AREA = 'area',
  /** column name */
  CITY = 'city',
  /** column name */
  COUNTRY = 'country',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  POSTAL_CODE = 'postal_code',
  /** column name */
  STREET = 'street',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "private.birthdays" */
export interface StudentOrParentPrivateBirthdays {
  date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "private.birthdays" */
export interface StudentOrParentPrivateBirthdaysAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdaysAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentPrivateBirthdays>>;
}

/** aggregate fields of "private.birthdays" */
export interface StudentOrParentPrivateBirthdaysAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdaysMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdaysMinFields>>;
}


/** aggregate fields of "private.birthdays" */
export interface StudentOrParentPrivateBirthdaysAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentPrivateBirthdaysSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.birthdays". All fields are combined with a logical 'AND'. */
export interface StudentOrParentPrivateBirthdaysBoolExp {
  _and?: Maybe<Array<StudentOrParentPrivateBirthdaysBoolExp>>;
  _not?: Maybe<StudentOrParentPrivateBirthdaysBoolExp>;
  _or?: Maybe<Array<StudentOrParentPrivateBirthdaysBoolExp>>;
  date?: Maybe<StudentOrParentDateComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** unique or primary key constraints on table "private.birthdays" */
export const enum StudentOrParentPrivateBirthdaysConstraint {
  /** unique or primary key constraint */
  BIRTHDAYS_PKEY = 'birthdays_pkey'
};

/** input type for inserting data into table "private.birthdays" */
export interface StudentOrParentPrivateBirthdaysInsertInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrParentPrivateBirthdaysMaxFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentOrParentPrivateBirthdaysMinFields {
  date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "private.birthdays" */
export interface StudentOrParentPrivateBirthdaysMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentPrivateBirthdays>>;
}

/** input type for inserting object relation for remote table "private.birthdays" */
export interface StudentOrParentPrivateBirthdaysObjRelInsertInput {
  data: StudentOrParentPrivateBirthdaysInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentPrivateBirthdaysOnConflict>;
}

/** on conflict condition type for table "private.birthdays" */
export interface StudentOrParentPrivateBirthdaysOnConflict {
  constraint: StudentOrParentPrivateBirthdaysConstraint;
  update_columns?: Array<StudentOrParentPrivateBirthdaysUpdateColumn>;
  where?: Maybe<StudentOrParentPrivateBirthdaysBoolExp>;
}

/** Ordering options when selecting data from "private.birthdays". */
export interface StudentOrParentPrivateBirthdaysOrderBy {
  date?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: private_birthdays */
export interface StudentOrParentPrivateBirthdaysPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.birthdays" */
export const enum StudentOrParentPrivateBirthdaysSelectColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** input type for updating data in table "private.birthdays" */
export interface StudentOrParentPrivateBirthdaysSetInput {
  date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "private.birthdays" */
export const enum StudentOrParentPrivateBirthdaysUpdateColumn {
  /** column name */
  DATE = 'date',
  /** column name */
  ID = 'id'
};

/** columns and relationships of "private.insurance_numbers" */
export interface StudentOrParentPrivateInsuranceNumbers {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentOrParentUsers>;
}

/** aggregated selection of "private.insurance_numbers" */
export interface StudentOrParentPrivateInsuranceNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentPrivateInsuranceNumbers>>;
}

/** aggregate fields of "private.insurance_numbers" */
export interface StudentOrParentPrivateInsuranceNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbersMinFields>>;
}


/** aggregate fields of "private.insurance_numbers" */
export interface StudentOrParentPrivateInsuranceNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentPrivateInsuranceNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.insurance_numbers". All fields are combined with a logical 'AND'. */
export interface StudentOrParentPrivateInsuranceNumbersBoolExp {
  _and?: Maybe<Array<StudentOrParentPrivateInsuranceNumbersBoolExp>>;
  _not?: Maybe<StudentOrParentPrivateInsuranceNumbersBoolExp>;
  _or?: Maybe<Array<StudentOrParentPrivateInsuranceNumbersBoolExp>>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  user?: Maybe<StudentOrParentUsersBoolExp>;
}

/** unique or primary key constraints on table "private.insurance_numbers" */
export const enum StudentOrParentPrivateInsuranceNumbersConstraint {
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_NAME_KEY = 'insurance_numbers_name_key',
  /** unique or primary key constraint */
  INSURANCE_NUMBERS_PKEY = 'insurance_numbers_pkey'
};

/** input type for inserting data into table "private.insurance_numbers" */
export interface StudentOrParentPrivateInsuranceNumbersInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  user?: Maybe<StudentOrParentUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentOrParentPrivateInsuranceNumbersMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentOrParentPrivateInsuranceNumbersMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "private.insurance_numbers" */
export interface StudentOrParentPrivateInsuranceNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentPrivateInsuranceNumbers>>;
}

/** input type for inserting object relation for remote table "private.insurance_numbers" */
export interface StudentOrParentPrivateInsuranceNumbersObjRelInsertInput {
  data: StudentOrParentPrivateInsuranceNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentPrivateInsuranceNumbersOnConflict>;
}

/** on conflict condition type for table "private.insurance_numbers" */
export interface StudentOrParentPrivateInsuranceNumbersOnConflict {
  constraint: StudentOrParentPrivateInsuranceNumbersConstraint;
  update_columns?: Array<StudentOrParentPrivateInsuranceNumbersUpdateColumn>;
  where?: Maybe<StudentOrParentPrivateInsuranceNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.insurance_numbers". */
export interface StudentOrParentPrivateInsuranceNumbersOrderBy {
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  user?: Maybe<StudentOrParentUsersOrderBy>;
}

/** primary key columns input for table: private_insurance_numbers */
export interface StudentOrParentPrivateInsuranceNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.insurance_numbers" */
export const enum StudentOrParentPrivateInsuranceNumbersSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** input type for updating data in table "private.insurance_numbers" */
export interface StudentOrParentPrivateInsuranceNumbersSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
}

/** update columns of table "private.insurance_numbers" */
export const enum StudentOrParentPrivateInsuranceNumbersUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name'
};

/** columns and relationships of "private.phone_numbers" */
export interface StudentOrParentPrivatePhoneNumbers {
  country_code: EntireFieldWrapper<Scalars['String']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  number: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentOrParentUsers>;
}

/** aggregated selection of "private.phone_numbers" */
export interface StudentOrParentPrivatePhoneNumbersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentPrivatePhoneNumbers>>;
}

/** aggregate fields of "private.phone_numbers" */
export interface StudentOrParentPrivatePhoneNumbersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbersMinFields>>;
}


/** aggregate fields of "private.phone_numbers" */
export interface StudentOrParentPrivatePhoneNumbersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentPrivatePhoneNumbersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "private.phone_numbers". All fields are combined with a logical 'AND'. */
export interface StudentOrParentPrivatePhoneNumbersBoolExp {
  _and?: Maybe<Array<StudentOrParentPrivatePhoneNumbersBoolExp>>;
  _not?: Maybe<StudentOrParentPrivatePhoneNumbersBoolExp>;
  _or?: Maybe<Array<StudentOrParentPrivatePhoneNumbersBoolExp>>;
  country_code?: Maybe<StudentOrParentStringComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  number?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user?: Maybe<StudentOrParentUsersBoolExp>;
}

/** unique or primary key constraints on table "private.phone_numbers" */
export const enum StudentOrParentPrivatePhoneNumbersConstraint {
  /** unique or primary key constraint */
  PHONE_NUMBERS_COUNTRY_CODE_NUMBER_KEY = 'phone_numbers_country_code_number_key',
  /** unique or primary key constraint */
  PHONE_NUMBERS_PKEY = 'phone_numbers_pkey'
};

/** input type for inserting data into table "private.phone_numbers" */
export interface StudentOrParentPrivatePhoneNumbersInsertInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentOrParentUsersObjRelInsertInput>;
}

/** aggregate max on columns */
export interface StudentOrParentPrivatePhoneNumbersMaxFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrParentPrivatePhoneNumbersMinFields {
  country_code?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  number?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "private.phone_numbers" */
export interface StudentOrParentPrivatePhoneNumbersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentPrivatePhoneNumbers>>;
}

/** input type for inserting object relation for remote table "private.phone_numbers" */
export interface StudentOrParentPrivatePhoneNumbersObjRelInsertInput {
  data: StudentOrParentPrivatePhoneNumbersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentPrivatePhoneNumbersOnConflict>;
}

/** on conflict condition type for table "private.phone_numbers" */
export interface StudentOrParentPrivatePhoneNumbersOnConflict {
  constraint: StudentOrParentPrivatePhoneNumbersConstraint;
  update_columns?: Array<StudentOrParentPrivatePhoneNumbersUpdateColumn>;
  where?: Maybe<StudentOrParentPrivatePhoneNumbersBoolExp>;
}

/** Ordering options when selecting data from "private.phone_numbers". */
export interface StudentOrParentPrivatePhoneNumbersOrderBy {
  country_code?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  number?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user?: Maybe<StudentOrParentUsersOrderBy>;
}

/** primary key columns input for table: private_phone_numbers */
export interface StudentOrParentPrivatePhoneNumbersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "private.phone_numbers" */
export const enum StudentOrParentPrivatePhoneNumbersSelectColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "private.phone_numbers" */
export interface StudentOrParentPrivatePhoneNumbersSetInput {
  country_code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "private.phone_numbers" */
export const enum StudentOrParentPrivatePhoneNumbersUpdateColumn {
  /** column name */
  COUNTRY_CODE = 'country_code',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  NUMBER = 'number',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "promotions" */
export interface StudentOrParentPromotions {
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_promoted: EntireFieldWrapper<Scalars['Boolean']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  year: EntireFieldWrapper<StudentOrParentYears>;
  year_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** order by aggregate values of table "promotions" */
export interface StudentOrParentPromotionsAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentPromotionsMaxOrderBy>;
  min?: Maybe<StudentOrParentPromotionsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "promotions". All fields are combined with a logical 'AND'. */
export interface StudentOrParentPromotionsBoolExp {
  _and?: Maybe<Array<StudentOrParentPromotionsBoolExp>>;
  _not?: Maybe<StudentOrParentPromotionsBoolExp>;
  _or?: Maybe<Array<StudentOrParentPromotionsBoolExp>>;
  class_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_promoted?: Maybe<StudentOrParentBooleanComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  year?: Maybe<StudentOrParentYearsBoolExp>;
  year_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** order by max() on columns of table "promotions" */
export interface StudentOrParentPromotionsMaxOrderBy {
  class_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  year_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "promotions" */
export interface StudentOrParentPromotionsMinOrderBy {
  class_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  year_id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "promotions". */
export interface StudentOrParentPromotionsOrderBy {
  class_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_promoted?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  year?: Maybe<StudentOrParentYearsOrderBy>;
  year_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "promotions" */
export const enum StudentOrParentPromotionsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_PROMOTED = 'is_promoted',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  YEAR_ID = 'year_id'
};

export interface StudentOrParentQueryRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<StudentOrParentAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<StudentOrParentAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<StudentOrParentAssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<StudentOrParentAssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeights>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<StudentOrParentAssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<StudentOrParentAssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<StudentOrParentAssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrParentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrParentAssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignments>>;
  /** fetch data from the table: "auth.account_providers" */
  auth_account_providers: EntireFieldWrapper<Array<StudentOrParentAuthAccountProviders>>;
  /** fetch aggregated fields from the table: "auth.account_providers" */
  auth_account_providers_aggregate: EntireFieldWrapper<StudentOrParentAuthAccountProvidersAggregate>;
  /** fetch data from the table: "auth.account_providers" using primary key columns */
  auth_account_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountProviders>>;
  /** fetch data from the table: "auth.account_roles" */
  auth_account_roles: EntireFieldWrapper<Array<StudentOrParentAuthAccountRoles>>;
  /** fetch aggregated fields from the table: "auth.account_roles" */
  auth_account_roles_aggregate: EntireFieldWrapper<StudentOrParentAuthAccountRolesAggregate>;
  /** fetch data from the table: "auth.account_roles" using primary key columns */
  auth_account_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccountRoles>>;
  /** fetch data from the table: "auth.accounts" */
  auth_accounts: EntireFieldWrapper<Array<StudentOrParentAuthAccounts>>;
  /** fetch aggregated fields from the table: "auth.accounts" */
  auth_accounts_aggregate: EntireFieldWrapper<StudentOrParentAuthAccountsAggregate>;
  /** fetch data from the table: "auth.accounts" using primary key columns */
  auth_accounts_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccounts>>;
  /** fetch data from the table: "auth.providers" */
  auth_providers: EntireFieldWrapper<Array<StudentOrParentAuthProviders>>;
  /** fetch aggregated fields from the table: "auth.providers" */
  auth_providers_aggregate: EntireFieldWrapper<StudentOrParentAuthProvidersAggregate>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  auth_providers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthProviders>>;
  /** fetch data from the table: "auth.refresh_tokens" */
  auth_refresh_tokens: EntireFieldWrapper<Array<StudentOrParentAuthRefreshTokens>>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  auth_refresh_tokens_aggregate: EntireFieldWrapper<StudentOrParentAuthRefreshTokensAggregate>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  auth_refresh_tokens_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthRefreshTokens>>;
  /** fetch data from the table: "auth.roles" */
  auth_roles: EntireFieldWrapper<Array<StudentOrParentAuthRoles>>;
  /** fetch aggregated fields from the table: "auth.roles" */
  auth_roles_aggregate: EntireFieldWrapper<StudentOrParentAuthRolesAggregate>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  auth_roles_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAuthRoles>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<StudentOrParentBookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentOrParentBookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<StudentOrParentBookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<StudentOrParentBookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<StudentOrParentBooks>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBooks>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentOrParentChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<StudentOrParentChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<StudentOrParentChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentOrParentChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<StudentOrParentChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<StudentOrParentChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<StudentOrParentChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentOrParentChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentOrParentChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<StudentOrParentChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<StudentOrParentChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<StudentOrParentChats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<StudentOrParentClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<StudentOrParentClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrParentClasses>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentClasses>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<StudentOrParentClassrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentClassrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<StudentOrParentCourseClass>>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<StudentOrParentCourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<StudentOrParentCourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<StudentOrParentCourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<StudentOrParentCourses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<StudentOrParentEventUsers>>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentEventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<StudentOrParentEvents>>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentEvents>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrParentFiles>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentFiles>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrParentGradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrParentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrParentGradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentGrades>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<StudentOrParentLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<StudentOrParentLessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentLessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentOrParentLessons>>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentLessons>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<StudentOrParentLiveClasses>>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentLiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<StudentOrParentMarks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentMarks>>;
  me?: EntireFieldWrapper<Maybe<StudentOrParentUserData>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<StudentOrParentMeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<StudentOrParentMeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentMeetingUser>>;
  /** fetch data from the table: "parent_student" */
  parent_student: EntireFieldWrapper<Array<StudentOrParentParentStudent>>;
  /** fetch data from the table: "parent_student" using primary key columns */
  parent_student_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentParentStudent>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<StudentOrParentParents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentParents>>;
  /** fetch data from the table: "private.adresses" */
  private_adresses: EntireFieldWrapper<Array<StudentOrParentPrivateAdresses>>;
  /** fetch aggregated fields from the table: "private.adresses" */
  private_adresses_aggregate: EntireFieldWrapper<StudentOrParentPrivateAdressesAggregate>;
  /** fetch data from the table: "private.adresses" using primary key columns */
  private_adresses_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdresses>>;
  /** fetch data from the table: "private.birthdays" */
  private_birthdays: EntireFieldWrapper<Array<StudentOrParentPrivateBirthdays>>;
  /** fetch aggregated fields from the table: "private.birthdays" */
  private_birthdays_aggregate: EntireFieldWrapper<StudentOrParentPrivateBirthdaysAggregate>;
  /** fetch data from the table: "private.birthdays" using primary key columns */
  private_birthdays_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdays>>;
  /** fetch data from the table: "private.insurance_numbers" */
  private_insurance_numbers: EntireFieldWrapper<Array<StudentOrParentPrivateInsuranceNumbers>>;
  /** fetch aggregated fields from the table: "private.insurance_numbers" */
  private_insurance_numbers_aggregate: EntireFieldWrapper<StudentOrParentPrivateInsuranceNumbersAggregate>;
  /** fetch data from the table: "private.insurance_numbers" using primary key columns */
  private_insurance_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbers>>;
  /** fetch data from the table: "private.phone_numbers" */
  private_phone_numbers: EntireFieldWrapper<Array<StudentOrParentPrivatePhoneNumbers>>;
  /** fetch aggregated fields from the table: "private.phone_numbers" */
  private_phone_numbers_aggregate: EntireFieldWrapper<StudentOrParentPrivatePhoneNumbersAggregate>;
  /** fetch data from the table: "private.phone_numbers" using primary key columns */
  private_phone_numbers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbers>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<StudentOrParentPromotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPromotions>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<StudentOrParentRelationships>>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<StudentOrParentRelationshipsAggregate>;
  /** fetch data from the table: "relationships" using primary key columns */
  relationships_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentRelationships>>;
  /** fetch data from the table: "school_settings" */
  school_settings: EntireFieldWrapper<Array<StudentOrParentSchoolSettings>>;
  /** fetch aggregated fields from the table: "school_settings" */
  school_settings_aggregate: EntireFieldWrapper<StudentOrParentSchoolSettingsAggregate>;
  /** fetch data from the table: "school_settings" using primary key columns */
  school_settings_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettings>>;
  /** fetch data from the table: "school_settings_modules" */
  school_settings_modules: EntireFieldWrapper<Array<StudentOrParentSchoolSettingsModules>>;
  /** fetch aggregated fields from the table: "school_settings_modules" */
  school_settings_modules_aggregate: EntireFieldWrapper<StudentOrParentSchoolSettingsModulesAggregate>;
  /** fetch data from the table: "school_settings_modules" using primary key columns */
  school_settings_modules_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModules>>;
  /** fetch data from the table: "schools" */
  schools: EntireFieldWrapper<Array<StudentOrParentSchools>>;
  /** fetch aggregated fields from the table: "schools" */
  schools_aggregate: EntireFieldWrapper<StudentOrParentSchoolsAggregate>;
  /** fetch data from the table: "schools" using primary key columns */
  schools_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSchools>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<StudentOrParentSemesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSemesters>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentOrParentStudents>>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentStudents>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<StudentOrParentSubjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSubjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<StudentOrParentTasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<StudentOrParentTasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentTasks>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<StudentOrParentTeachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentTeachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<StudentOrParentTeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<StudentOrParentTeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<StudentOrParentTeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<StudentOrParentTeachingStructuresAggregate>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<StudentOrParentTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<StudentOrParentTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructures>>;
  /** fetch data from the table: "users" */
  users: EntireFieldWrapper<Array<StudentOrParentUsers>>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: EntireFieldWrapper<StudentOrParentUsersAggregate>;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<StudentOrParentViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<StudentOrParentViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<StudentOrParentViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<StudentOrParentViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentOrParentViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentOrParentViewGradesAggregate>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<StudentOrParentViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<StudentOrParentViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<StudentOrParentViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<StudentOrParentViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<StudentOrParentViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<StudentOrParentYears>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<StudentOrParentYearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentYears>>;
}


export interface StudentOrParentQueryRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentAttendeeTypeBoolExp>;
}


export interface StudentOrParentQueryRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface StudentOrParentQueryRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentBookChapterBoolExp>;
}


export interface StudentOrParentQueryRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentGradeWeightsBoolExp>;
}


export interface StudentOrParentQueryRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentGradeWeightsBoolExp>;
}


export interface StudentOrParentQueryRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentSubmitsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentSubmitsBoolExp>;
}


export interface StudentOrParentQueryRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentTypeOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentTypeBoolExp>;
}


export interface StudentOrParentQueryRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentQueryRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentUserOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentUserBoolExp>;
}


export interface StudentOrParentQueryRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


export interface StudentOrParentQueryRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


export interface StudentOrParentQueryRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootAuthAccountProvidersArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
}


export interface StudentOrParentQueryRootAuthAccountProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountProvidersOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountProvidersBoolExp>;
}


export interface StudentOrParentQueryRootAuthAccountProvidersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootAuthAccountRolesArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
}


export interface StudentOrParentQueryRootAuthAccountRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountRolesOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountRolesBoolExp>;
}


export interface StudentOrParentQueryRootAuthAccountRolesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootAuthAccountsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountsOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountsBoolExp>;
}


export interface StudentOrParentQueryRootAuthAccountsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthAccountsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthAccountsOrderBy>>;
  where?: Maybe<StudentOrParentAuthAccountsBoolExp>;
}


export interface StudentOrParentQueryRootAuthAccountsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootAuthProvidersArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthProvidersOrderBy>>;
  where?: Maybe<StudentOrParentAuthProvidersBoolExp>;
}


export interface StudentOrParentQueryRootAuthProvidersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthProvidersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthProvidersOrderBy>>;
  where?: Maybe<StudentOrParentAuthProvidersBoolExp>;
}


export interface StudentOrParentQueryRootAuthProvidersByPkArgs {
  provider: Scalars['String'];
}


export interface StudentOrParentQueryRootAuthRefreshTokensArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentOrParentAuthRefreshTokensBoolExp>;
}


export interface StudentOrParentQueryRootAuthRefreshTokensAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthRefreshTokensSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthRefreshTokensOrderBy>>;
  where?: Maybe<StudentOrParentAuthRefreshTokensBoolExp>;
}


export interface StudentOrParentQueryRootAuthRefreshTokensByPkArgs {
  refresh_token: Scalars['uuid'];
}


export interface StudentOrParentQueryRootAuthRolesArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthRolesOrderBy>>;
  where?: Maybe<StudentOrParentAuthRolesBoolExp>;
}


export interface StudentOrParentQueryRootAuthRolesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAuthRolesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAuthRolesOrderBy>>;
  where?: Maybe<StudentOrParentAuthRolesBoolExp>;
}


export interface StudentOrParentQueryRootAuthRolesByPkArgs {
  role: Scalars['String'];
}


export interface StudentOrParentQueryRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookChapterTypeOrderBy>>;
  where?: Maybe<StudentOrParentBookChapterTypeBoolExp>;
}


export interface StudentOrParentQueryRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentQueryRootBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookChaptersOrderBy>>;
  where?: Maybe<StudentOrParentBookChaptersBoolExp>;
}


export interface StudentOrParentQueryRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootBookCourseArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookCourseOrderBy>>;
  where?: Maybe<StudentOrParentBookCourseBoolExp>;
}


export interface StudentOrParentQueryRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootBookUserArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookUserOrderBy>>;
  where?: Maybe<StudentOrParentBookUserBoolExp>;
}


export interface StudentOrParentQueryRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootBooksArgs {
  distinct_on?: Maybe<Array<StudentOrParentBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBooksOrderBy>>;
  where?: Maybe<StudentOrParentBooksBoolExp>;
}


export interface StudentOrParentQueryRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionNotesBoolExp>;
}


export interface StudentOrParentQueryRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionSubmitsBoolExp>;
}


export interface StudentOrParentQueryRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionTypeOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionTypeBoolExp>;
}


export interface StudentOrParentQueryRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentQueryRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionsOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionsBoolExp>;
}


export interface StudentOrParentQueryRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessageLikesBoolExp>;
}


export interface StudentOrParentQueryRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessageLikesBoolExp>;
}


export interface StudentOrParentQueryRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessageReadsOrderBy>>;
  where?: Maybe<StudentOrParentChatMessageReadsBoolExp>;
}


export interface StudentOrParentQueryRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}


export interface StudentOrParentQueryRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}


export interface StudentOrParentQueryRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootChatTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatTypeOrderBy>>;
  where?: Maybe<StudentOrParentChatTypeBoolExp>;
}


export interface StudentOrParentQueryRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentQueryRootChatUserArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatUserOrderBy>>;
  where?: Maybe<StudentOrParentChatUserBoolExp>;
}


export interface StudentOrParentQueryRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootChatsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatsOrderBy>>;
  where?: Maybe<StudentOrParentChatsBoolExp>;
}


export interface StudentOrParentQueryRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootClassLevelsArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassLevelsOrderBy>>;
  where?: Maybe<StudentOrParentClassLevelsBoolExp>;
}


export interface StudentOrParentQueryRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootClassTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassTypeOrderBy>>;
  where?: Maybe<StudentOrParentClassTypeBoolExp>;
}


export interface StudentOrParentQueryRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentQueryRootClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassesOrderBy>>;
  where?: Maybe<StudentOrParentClassesBoolExp>;
}


export interface StudentOrParentQueryRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassroomsOrderBy>>;
  where?: Maybe<StudentOrParentClassroomsBoolExp>;
}


export interface StudentOrParentQueryRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootCourseClassArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseClassOrderBy>>;
  where?: Maybe<StudentOrParentCourseClassBoolExp>;
}


export interface StudentOrParentQueryRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseClassroomOrderBy>>;
  where?: Maybe<StudentOrParentCourseClassroomBoolExp>;
}


export interface StudentOrParentQueryRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootCourseStudentArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseStudentOrderBy>>;
  where?: Maybe<StudentOrParentCourseStudentBoolExp>;
}


export interface StudentOrParentQueryRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseTeacherOrderBy>>;
  where?: Maybe<StudentOrParentCourseTeacherBoolExp>;
}


export interface StudentOrParentQueryRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrParentCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCoursesOrderBy>>;
  where?: Maybe<StudentOrParentCoursesBoolExp>;
}


export interface StudentOrParentQueryRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootEventUsersArgs {
  distinct_on?: Maybe<Array<StudentOrParentEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentEventUsersOrderBy>>;
  where?: Maybe<StudentOrParentEventUsersBoolExp>;
}


export interface StudentOrParentQueryRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootEventsArgs {
  distinct_on?: Maybe<Array<StudentOrParentEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentEventsOrderBy>>;
  where?: Maybe<StudentOrParentEventsBoolExp>;
}


export interface StudentOrParentQueryRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootFilesArgs {
  distinct_on?: Maybe<Array<StudentOrParentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentFilesOrderBy>>;
  where?: Maybe<StudentOrParentFilesBoolExp>;
}


export interface StudentOrParentQueryRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradeTypesOrderBy>>;
  where?: Maybe<StudentOrParentGradeTypesBoolExp>;
}


export interface StudentOrParentQueryRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}


export interface StudentOrParentQueryRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}


export interface StudentOrParentQueryRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentLessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLessonAttendaceTypeOrderBy>>;
  where?: Maybe<StudentOrParentLessonAttendaceTypeBoolExp>;
}


export interface StudentOrParentQueryRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentQueryRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<StudentOrParentLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLessonAttendancesOrderBy>>;
  where?: Maybe<StudentOrParentLessonAttendancesBoolExp>;
}


export interface StudentOrParentQueryRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootLessonsArgs {
  distinct_on?: Maybe<Array<StudentOrParentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLessonsOrderBy>>;
  where?: Maybe<StudentOrParentLessonsBoolExp>;
}


export interface StudentOrParentQueryRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootLiveClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLiveClassesOrderBy>>;
  where?: Maybe<StudentOrParentLiveClassesBoolExp>;
}


export interface StudentOrParentQueryRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootMarksArgs {
  distinct_on?: Maybe<Array<StudentOrParentMarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentMarksOrderBy>>;
  where?: Maybe<StudentOrParentMarksBoolExp>;
}


export interface StudentOrParentQueryRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootMeetingUserArgs {
  distinct_on?: Maybe<Array<StudentOrParentMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentMeetingUserOrderBy>>;
  where?: Maybe<StudentOrParentMeetingUserBoolExp>;
}


export interface StudentOrParentQueryRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentMeetingUserOrderBy>>;
  where?: Maybe<StudentOrParentMeetingUserBoolExp>;
}


export interface StudentOrParentQueryRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootParentStudentArgs {
  distinct_on?: Maybe<Array<StudentOrParentParentStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentParentStudentOrderBy>>;
  where?: Maybe<StudentOrParentParentStudentBoolExp>;
}


export interface StudentOrParentQueryRootParentStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootParentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentParentsOrderBy>>;
  where?: Maybe<StudentOrParentParentsBoolExp>;
}


export interface StudentOrParentQueryRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootPrivateAdressesArgs {
  distinct_on?: Maybe<Array<StudentOrParentPrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPrivateAdressesOrderBy>>;
  where?: Maybe<StudentOrParentPrivateAdressesBoolExp>;
}


export interface StudentOrParentQueryRootPrivateAdressesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentPrivateAdressesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPrivateAdressesOrderBy>>;
  where?: Maybe<StudentOrParentPrivateAdressesBoolExp>;
}


export interface StudentOrParentQueryRootPrivateAdressesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootPrivateBirthdaysArgs {
  distinct_on?: Maybe<Array<StudentOrParentPrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPrivateBirthdaysOrderBy>>;
  where?: Maybe<StudentOrParentPrivateBirthdaysBoolExp>;
}


export interface StudentOrParentQueryRootPrivateBirthdaysAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentPrivateBirthdaysSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPrivateBirthdaysOrderBy>>;
  where?: Maybe<StudentOrParentPrivateBirthdaysBoolExp>;
}


export interface StudentOrParentQueryRootPrivateBirthdaysByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootPrivateInsuranceNumbersArgs {
  distinct_on?: Maybe<Array<StudentOrParentPrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<StudentOrParentPrivateInsuranceNumbersBoolExp>;
}


export interface StudentOrParentQueryRootPrivateInsuranceNumbersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentPrivateInsuranceNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPrivateInsuranceNumbersOrderBy>>;
  where?: Maybe<StudentOrParentPrivateInsuranceNumbersBoolExp>;
}


export interface StudentOrParentQueryRootPrivateInsuranceNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootPrivatePhoneNumbersArgs {
  distinct_on?: Maybe<Array<StudentOrParentPrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPrivatePhoneNumbersOrderBy>>;
  where?: Maybe<StudentOrParentPrivatePhoneNumbersBoolExp>;
}


export interface StudentOrParentQueryRootPrivatePhoneNumbersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentPrivatePhoneNumbersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPrivatePhoneNumbersOrderBy>>;
  where?: Maybe<StudentOrParentPrivatePhoneNumbersBoolExp>;
}


export interface StudentOrParentQueryRootPrivatePhoneNumbersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootPromotionsArgs {
  distinct_on?: Maybe<Array<StudentOrParentPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPromotionsOrderBy>>;
  where?: Maybe<StudentOrParentPromotionsBoolExp>;
}


export interface StudentOrParentQueryRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootRelationshipsArgs {
  distinct_on?: Maybe<Array<StudentOrParentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentRelationshipsOrderBy>>;
  where?: Maybe<StudentOrParentRelationshipsBoolExp>;
}


export interface StudentOrParentQueryRootRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentRelationshipsOrderBy>>;
  where?: Maybe<StudentOrParentRelationshipsBoolExp>;
}


export interface StudentOrParentQueryRootRelationshipsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootSchoolSettingsArgs {
  distinct_on?: Maybe<Array<StudentOrParentSchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSchoolSettingsOrderBy>>;
  where?: Maybe<StudentOrParentSchoolSettingsBoolExp>;
}


export interface StudentOrParentQueryRootSchoolSettingsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentSchoolSettingsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSchoolSettingsOrderBy>>;
  where?: Maybe<StudentOrParentSchoolSettingsBoolExp>;
}


export interface StudentOrParentQueryRootSchoolSettingsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootSchoolSettingsModulesArgs {
  distinct_on?: Maybe<Array<StudentOrParentSchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSchoolSettingsModulesOrderBy>>;
  where?: Maybe<StudentOrParentSchoolSettingsModulesBoolExp>;
}


export interface StudentOrParentQueryRootSchoolSettingsModulesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentSchoolSettingsModulesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSchoolSettingsModulesOrderBy>>;
  where?: Maybe<StudentOrParentSchoolSettingsModulesBoolExp>;
}


export interface StudentOrParentQueryRootSchoolSettingsModulesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootSchoolsArgs {
  distinct_on?: Maybe<Array<StudentOrParentSchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSchoolsOrderBy>>;
  where?: Maybe<StudentOrParentSchoolsBoolExp>;
}


export interface StudentOrParentQueryRootSchoolsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentSchoolsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSchoolsOrderBy>>;
  where?: Maybe<StudentOrParentSchoolsBoolExp>;
}


export interface StudentOrParentQueryRootSchoolsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootSemestersArgs {
  distinct_on?: Maybe<Array<StudentOrParentSemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSemestersOrderBy>>;
  where?: Maybe<StudentOrParentSemestersBoolExp>;
}


export interface StudentOrParentQueryRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentStudentsOrderBy>>;
  where?: Maybe<StudentOrParentStudentsBoolExp>;
}


export interface StudentOrParentQueryRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootSubjectsArgs {
  distinct_on?: Maybe<Array<StudentOrParentSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSubjectsOrderBy>>;
  where?: Maybe<StudentOrParentSubjectsBoolExp>;
}


export interface StudentOrParentQueryRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootTasksArgs {
  distinct_on?: Maybe<Array<StudentOrParentTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTasksOrderBy>>;
  where?: Maybe<StudentOrParentTasksBoolExp>;
}


export interface StudentOrParentQueryRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTasksOrderBy>>;
  where?: Maybe<StudentOrParentTasksBoolExp>;
}


export interface StudentOrParentQueryRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrParentTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachersOrderBy>>;
  where?: Maybe<StudentOrParentTeachersBoolExp>;
}


export interface StudentOrParentQueryRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootTeachingStructureLeafsArgs {
  args: StudentOrParentTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentQueryRootTeachingStructureLeafsAggregateArgs {
  args: StudentOrParentTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentQueryRootTeachingStructureParentsArgs {
  args: StudentOrParentTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentQueryRootTeachingStructureParentsAggregateArgs {
  args: StudentOrParentTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentQueryRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentQueryRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentQueryRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootUsersArgs {
  distinct_on?: Maybe<Array<StudentOrParentUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentUsersOrderBy>>;
  where?: Maybe<StudentOrParentUsersBoolExp>;
}


export interface StudentOrParentQueryRootUsersAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentUsersOrderBy>>;
  where?: Maybe<StudentOrParentUsersBoolExp>;
}


export interface StudentOrParentQueryRootUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentQueryRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewAssignmentClassOrderBy>>;
  where?: Maybe<StudentOrParentViewAssignmentClassBoolExp>;
}


export interface StudentOrParentQueryRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<StudentOrParentViewAssignmentStudentGradeBoolExp>;
}


export interface StudentOrParentQueryRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewClassStudentOrderBy>>;
  where?: Maybe<StudentOrParentViewClassStudentBoolExp>;
}


export interface StudentOrParentQueryRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<StudentOrParentViewGradeTypeSubjectBoolExp>;
}


export interface StudentOrParentQueryRootViewGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradesOrderBy>>;
  where?: Maybe<StudentOrParentViewGradesBoolExp>;
}


export interface StudentOrParentQueryRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradesOrderBy>>;
  where?: Maybe<StudentOrParentViewGradesBoolExp>;
}


export interface StudentOrParentQueryRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentViewLatestChatMessagesBoolExp>;
}


export interface StudentOrParentQueryRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentViewLatestChatMessagesBoolExp>;
}


export interface StudentOrParentQueryRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface StudentOrParentQueryRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewSubjectSemesterOrderBy>>;
  where?: Maybe<StudentOrParentViewSubjectSemesterBoolExp>;
}


export interface StudentOrParentQueryRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<StudentOrParentViewTeacherClassSubjectBoolExp>;
}


export interface StudentOrParentQueryRootYearsArgs {
  distinct_on?: Maybe<Array<StudentOrParentYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentYearsOrderBy>>;
  where?: Maybe<StudentOrParentYearsBoolExp>;
}


export interface StudentOrParentQueryRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentYearsOrderBy>>;
  where?: Maybe<StudentOrParentYearsBoolExp>;
}


export interface StudentOrParentQueryRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "relationships" */
export interface StudentOrParentRelationships {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  related: EntireFieldWrapper<StudentOrParentUsers>;
  related_id: EntireFieldWrapper<Scalars['uuid']>;
  role: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  roleByRole: EntireFieldWrapper<StudentOrParentAuthRoles>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An object relationship */
  user: EntireFieldWrapper<StudentOrParentUsers>;
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "relationships" */
export interface StudentOrParentRelationshipsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentRelationshipsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentRelationships>>;
}

/** aggregate fields of "relationships" */
export interface StudentOrParentRelationshipsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentRelationshipsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentRelationshipsMinFields>>;
}


/** aggregate fields of "relationships" */
export interface StudentOrParentRelationshipsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentRelationshipsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "relationships" */
export interface StudentOrParentRelationshipsAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentRelationshipsMaxOrderBy>;
  min?: Maybe<StudentOrParentRelationshipsMinOrderBy>;
}

/** input type for inserting array relation for remote table "relationships" */
export interface StudentOrParentRelationshipsArrRelInsertInput {
  data: Array<StudentOrParentRelationshipsInsertInput>;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentRelationshipsOnConflict>;
}

/** Boolean expression to filter rows from the table "relationships". All fields are combined with a logical 'AND'. */
export interface StudentOrParentRelationshipsBoolExp {
  _and?: Maybe<Array<StudentOrParentRelationshipsBoolExp>>;
  _not?: Maybe<StudentOrParentRelationshipsBoolExp>;
  _or?: Maybe<Array<StudentOrParentRelationshipsBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  related?: Maybe<StudentOrParentUsersBoolExp>;
  related_id?: Maybe<StudentOrParentUuidComparisonExp>;
  role?: Maybe<StudentOrParentStringComparisonExp>;
  roleByRole?: Maybe<StudentOrParentAuthRolesBoolExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user?: Maybe<StudentOrParentUsersBoolExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** unique or primary key constraints on table "relationships" */
export const enum StudentOrParentRelationshipsConstraint {
  /** unique or primary key constraint */
  RELATIONSHIPS_PKEY = 'relationships_pkey',
  /** unique or primary key constraint */
  RELATIONSHIPS_USER_ID_RELATED_ID_KEY = 'relationships_user_id_related_id_key'
};

/** input type for inserting data into table "relationships" */
export interface StudentOrParentRelationshipsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related?: Maybe<StudentOrParentUsersObjRelInsertInput>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  roleByRole?: Maybe<StudentOrParentAuthRolesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user?: Maybe<StudentOrParentUsersObjRelInsertInput>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** aggregate max on columns */
export interface StudentOrParentRelationshipsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by max() on columns of table "relationships" */
export interface StudentOrParentRelationshipsMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  related_id?: Maybe<StudentOrParentOrderBy>;
  role?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentRelationshipsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  related_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  role?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by min() on columns of table "relationships" */
export interface StudentOrParentRelationshipsMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  related_id?: Maybe<StudentOrParentOrderBy>;
  role?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** response of any mutation on the table "relationships" */
export interface StudentOrParentRelationshipsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentRelationships>>;
}

/** on conflict condition type for table "relationships" */
export interface StudentOrParentRelationshipsOnConflict {
  constraint: StudentOrParentRelationshipsConstraint;
  update_columns?: Array<StudentOrParentRelationshipsUpdateColumn>;
  where?: Maybe<StudentOrParentRelationshipsBoolExp>;
}

/** Ordering options when selecting data from "relationships". */
export interface StudentOrParentRelationshipsOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  related?: Maybe<StudentOrParentUsersOrderBy>;
  related_id?: Maybe<StudentOrParentOrderBy>;
  role?: Maybe<StudentOrParentOrderBy>;
  roleByRole?: Maybe<StudentOrParentAuthRolesOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user?: Maybe<StudentOrParentUsersOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: relationships */
export interface StudentOrParentRelationshipsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "relationships" */
export const enum StudentOrParentRelationshipsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** input type for updating data in table "relationships" */
export interface StudentOrParentRelationshipsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  related_id?: Maybe<Scalars['uuid']>;
  role?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
}

/** update columns of table "relationships" */
export const enum StudentOrParentRelationshipsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  RELATED_ID = 'related_id',
  /** column name */
  ROLE = 'role',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/**
 * General settings for school
 *
 *
 * columns and relationships of "school_settings"
 */
export interface StudentOrParentSchoolSettings {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school: EntireFieldWrapper<StudentOrParentSchools>;
  school_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  school_settings_module?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModules>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings" */
export interface StudentOrParentSchoolSettingsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentSchoolSettings>>;
}

/** aggregate fields of "school_settings" */
export interface StudentOrParentSchoolSettingsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsMinFields>>;
}


/** aggregate fields of "school_settings" */
export interface StudentOrParentSchoolSettingsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentSchoolSettingsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings". All fields are combined with a logical 'AND'. */
export interface StudentOrParentSchoolSettingsBoolExp {
  _and?: Maybe<Array<StudentOrParentSchoolSettingsBoolExp>>;
  _not?: Maybe<StudentOrParentSchoolSettingsBoolExp>;
  _or?: Maybe<Array<StudentOrParentSchoolSettingsBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  school?: Maybe<StudentOrParentSchoolsBoolExp>;
  school_id?: Maybe<StudentOrParentUuidComparisonExp>;
  school_settings_module?: Maybe<StudentOrParentSchoolSettingsModulesBoolExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings" */
export const enum StudentOrParentSchoolSettingsConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_PKEY = 'school_settings_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_SCHOOL_ID_KEY = 'school_settings_school_id_key'
};

/** input type for inserting data into table "school_settings" */
export interface StudentOrParentSchoolSettingsInsertInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school?: Maybe<StudentOrParentSchoolsObjRelInsertInput>;
  school_id?: Maybe<Scalars['uuid']>;
  school_settings_module?: Maybe<StudentOrParentSchoolSettingsModulesObjRelInsertInput>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentOrParentSchoolSettingsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrParentSchoolSettingsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/**
 * Enable or disable module in application for school of choice
 *
 *
 * columns and relationships of "school_settings_modules"
 */
export interface StudentOrParentSchoolSettingsModules {
  assignments: EntireFieldWrapper<Scalars['Boolean']>;
  chat: EntireFieldWrapper<Scalars['Boolean']>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  grading: EntireFieldWrapper<Scalars['Boolean']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  live_class: EntireFieldWrapper<Scalars['Boolean']>;
  /** An object relationship */
  school_setting: EntireFieldWrapper<StudentOrParentSchoolSettings>;
  school_settings_id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** aggregated selection of "school_settings_modules" */
export interface StudentOrParentSchoolSettingsModulesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModulesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentSchoolSettingsModules>>;
}

/** aggregate fields of "school_settings_modules" */
export interface StudentOrParentSchoolSettingsModulesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModulesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettingsModulesMinFields>>;
}


/** aggregate fields of "school_settings_modules" */
export interface StudentOrParentSchoolSettingsModulesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentSchoolSettingsModulesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "school_settings_modules". All fields are combined with a logical 'AND'. */
export interface StudentOrParentSchoolSettingsModulesBoolExp {
  _and?: Maybe<Array<StudentOrParentSchoolSettingsModulesBoolExp>>;
  _not?: Maybe<StudentOrParentSchoolSettingsModulesBoolExp>;
  _or?: Maybe<Array<StudentOrParentSchoolSettingsModulesBoolExp>>;
  assignments?: Maybe<StudentOrParentBooleanComparisonExp>;
  chat?: Maybe<StudentOrParentBooleanComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  grading?: Maybe<StudentOrParentBooleanComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  live_class?: Maybe<StudentOrParentBooleanComparisonExp>;
  school_setting?: Maybe<StudentOrParentSchoolSettingsBoolExp>;
  school_settings_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "school_settings_modules" */
export const enum StudentOrParentSchoolSettingsModulesConstraint {
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_PKEY = 'school_settings_modules_pkey',
  /** unique or primary key constraint */
  SCHOOL_SETTINGS_MODULES_SCHOOL_SETTINGS_ID_KEY = 'school_settings_modules_school_settings_id_key'
};

/** input type for inserting data into table "school_settings_modules" */
export interface StudentOrParentSchoolSettingsModulesInsertInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_setting?: Maybe<StudentOrParentSchoolSettingsObjRelInsertInput>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentOrParentSchoolSettingsModulesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrParentSchoolSettingsModulesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  school_settings_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "school_settings_modules" */
export interface StudentOrParentSchoolSettingsModulesMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentSchoolSettingsModules>>;
}

/** input type for inserting object relation for remote table "school_settings_modules" */
export interface StudentOrParentSchoolSettingsModulesObjRelInsertInput {
  data: StudentOrParentSchoolSettingsModulesInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentSchoolSettingsModulesOnConflict>;
}

/** on conflict condition type for table "school_settings_modules" */
export interface StudentOrParentSchoolSettingsModulesOnConflict {
  constraint: StudentOrParentSchoolSettingsModulesConstraint;
  update_columns?: Array<StudentOrParentSchoolSettingsModulesUpdateColumn>;
  where?: Maybe<StudentOrParentSchoolSettingsModulesBoolExp>;
}

/** Ordering options when selecting data from "school_settings_modules". */
export interface StudentOrParentSchoolSettingsModulesOrderBy {
  assignments?: Maybe<StudentOrParentOrderBy>;
  chat?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  grading?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  live_class?: Maybe<StudentOrParentOrderBy>;
  school_setting?: Maybe<StudentOrParentSchoolSettingsOrderBy>;
  school_settings_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: school_settings_modules */
export interface StudentOrParentSchoolSettingsModulesPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings_modules" */
export const enum StudentOrParentSchoolSettingsModulesSelectColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings_modules" */
export interface StudentOrParentSchoolSettingsModulesSetInput {
  assignments?: Maybe<Scalars['Boolean']>;
  chat?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  grading?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['uuid']>;
  live_class?: Maybe<Scalars['Boolean']>;
  school_settings_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings_modules" */
export const enum StudentOrParentSchoolSettingsModulesUpdateColumn {
  /** column name */
  ASSIGNMENTS = 'assignments',
  /** column name */
  CHAT = 'chat',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  GRADING = 'grading',
  /** column name */
  ID = 'id',
  /** column name */
  LIVE_CLASS = 'live_class',
  /** column name */
  SCHOOL_SETTINGS_ID = 'school_settings_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** response of any mutation on the table "school_settings" */
export interface StudentOrParentSchoolSettingsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentSchoolSettings>>;
}

/** input type for inserting object relation for remote table "school_settings" */
export interface StudentOrParentSchoolSettingsObjRelInsertInput {
  data: StudentOrParentSchoolSettingsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentSchoolSettingsOnConflict>;
}

/** on conflict condition type for table "school_settings" */
export interface StudentOrParentSchoolSettingsOnConflict {
  constraint: StudentOrParentSchoolSettingsConstraint;
  update_columns?: Array<StudentOrParentSchoolSettingsUpdateColumn>;
  where?: Maybe<StudentOrParentSchoolSettingsBoolExp>;
}

/** Ordering options when selecting data from "school_settings". */
export interface StudentOrParentSchoolSettingsOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  school?: Maybe<StudentOrParentSchoolsOrderBy>;
  school_id?: Maybe<StudentOrParentOrderBy>;
  school_settings_module?: Maybe<StudentOrParentSchoolSettingsModulesOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: school_settings */
export interface StudentOrParentSchoolSettingsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "school_settings" */
export const enum StudentOrParentSchoolSettingsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "school_settings" */
export interface StudentOrParentSchoolSettingsSetInput {
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  school_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "school_settings" */
export const enum StudentOrParentSchoolSettingsUpdateColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  SCHOOL_ID = 'school_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/**
 * Used for UUID tokens for schools.
 *
 *
 * columns and relationships of "schools"
 */
export interface StudentOrParentSchools {
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  path: EntireFieldWrapper<Scalars['String']>;
  /** An object relationship */
  school_setting?: EntireFieldWrapper<Maybe<StudentOrParentSchoolSettings>>;
  serial: EntireFieldWrapper<Scalars['String']>;
}

/** aggregated selection of "schools" */
export interface StudentOrParentSchoolsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentSchoolsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentSchools>>;
}

/** aggregate fields of "schools" */
export interface StudentOrParentSchoolsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentSchoolsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentSchoolsMinFields>>;
}


/** aggregate fields of "schools" */
export interface StudentOrParentSchoolsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentSchoolsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "schools". All fields are combined with a logical 'AND'. */
export interface StudentOrParentSchoolsBoolExp {
  _and?: Maybe<Array<StudentOrParentSchoolsBoolExp>>;
  _not?: Maybe<StudentOrParentSchoolsBoolExp>;
  _or?: Maybe<Array<StudentOrParentSchoolsBoolExp>>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  path?: Maybe<StudentOrParentStringComparisonExp>;
  school_setting?: Maybe<StudentOrParentSchoolSettingsBoolExp>;
  serial?: Maybe<StudentOrParentStringComparisonExp>;
}

/** unique or primary key constraints on table "schools" */
export const enum StudentOrParentSchoolsConstraint {
  /** unique or primary key constraint */
  SCHOOLS_PKEY = 'schools_pkey'
};

/** input type for inserting data into table "schools" */
export interface StudentOrParentSchoolsInsertInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  school_setting?: Maybe<StudentOrParentSchoolSettingsObjRelInsertInput>;
  serial?: Maybe<Scalars['String']>;
}

/** aggregate max on columns */
export interface StudentOrParentSchoolsMaxFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** aggregate min on columns */
export interface StudentOrParentSchoolsMinFields {
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  path?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  serial?: EntireFieldWrapper<Maybe<Scalars['String']>>;
}

/** response of any mutation on the table "schools" */
export interface StudentOrParentSchoolsMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentSchools>>;
}

/** input type for inserting object relation for remote table "schools" */
export interface StudentOrParentSchoolsObjRelInsertInput {
  data: StudentOrParentSchoolsInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentSchoolsOnConflict>;
}

/** on conflict condition type for table "schools" */
export interface StudentOrParentSchoolsOnConflict {
  constraint: StudentOrParentSchoolsConstraint;
  update_columns?: Array<StudentOrParentSchoolsUpdateColumn>;
  where?: Maybe<StudentOrParentSchoolsBoolExp>;
}

/** Ordering options when selecting data from "schools". */
export interface StudentOrParentSchoolsOrderBy {
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  path?: Maybe<StudentOrParentOrderBy>;
  school_setting?: Maybe<StudentOrParentSchoolSettingsOrderBy>;
  serial?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: schools */
export interface StudentOrParentSchoolsPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "schools" */
export const enum StudentOrParentSchoolsSelectColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** input type for updating data in table "schools" */
export interface StudentOrParentSchoolsSetInput {
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
}

/** update columns of table "schools" */
export const enum StudentOrParentSchoolsUpdateColumn {
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  PATH = 'path',
  /** column name */
  SERIAL = 'serial'
};

/** columns and relationships of "semesters" */
export interface StudentOrParentSemesters {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_at: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  start_at: EntireFieldWrapper<Scalars['date']>;
  /** An object relationship */
  teaching_structure?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructures>>;
  teaching_structure_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}

/** Boolean expression to filter rows from the table "semesters". All fields are combined with a logical 'AND'. */
export interface StudentOrParentSemestersBoolExp {
  _and?: Maybe<Array<StudentOrParentSemestersBoolExp>>;
  _not?: Maybe<StudentOrParentSemestersBoolExp>;
  _or?: Maybe<Array<StudentOrParentSemestersBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  end_at?: Maybe<StudentOrParentDateComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  start_at?: Maybe<StudentOrParentDateComparisonExp>;
  teaching_structure?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
  teaching_structure_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** Ordering options when selecting data from "semesters". */
export interface StudentOrParentSemestersOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  end_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  start_at?: Maybe<StudentOrParentOrderBy>;
  teaching_structure?: Maybe<StudentOrParentTeachingStructuresOrderBy>;
  teaching_structure_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "semesters" */
export const enum StudentOrParentSemestersSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_AT = 'end_at',
  /** column name */
  ID = 'id',
  /** column name */
  START_AT = 'start_at',
  /** column name */
  TEACHING_STRUCTURE_ID = 'teaching_structure_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "students" */
export interface StudentOrParentStudents {
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentOrParentChapterSectionNotes>>;
  /** An array relationship */
  chapter_section_students: EntireFieldWrapper<Array<StudentOrParentChapterSectionSubmits>>;
  /** An object relationship */
  class: EntireFieldWrapper<StudentOrParentClasses>;
  class_id: EntireFieldWrapper<Scalars['uuid']>;
  /** An array relationship */
  course_students: EntireFieldWrapper<Array<StudentOrParentCourseStudent>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrParentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrParentGradesAggregate>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
}


/** columns and relationships of "students" */
export interface StudentOrParentStudentsChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionNotesBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentOrParentStudentsChapterSectionStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionSubmitsBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentOrParentStudentsCourseStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseStudentOrderBy>>;
  where?: Maybe<StudentOrParentCourseStudentBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentOrParentStudentsGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}


/** columns and relationships of "students" */
export interface StudentOrParentStudentsGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}

/** order by aggregate values of table "students" */
export interface StudentOrParentStudentsAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentStudentsMaxOrderBy>;
  min?: Maybe<StudentOrParentStudentsMinOrderBy>;
}

/** Boolean expression to filter rows from the table "students". All fields are combined with a logical 'AND'. */
export interface StudentOrParentStudentsBoolExp {
  _and?: Maybe<Array<StudentOrParentStudentsBoolExp>>;
  _not?: Maybe<StudentOrParentStudentsBoolExp>;
  _or?: Maybe<Array<StudentOrParentStudentsBoolExp>>;
  chapter_section_notes?: Maybe<StudentOrParentChapterSectionNotesBoolExp>;
  chapter_section_students?: Maybe<StudentOrParentChapterSectionSubmitsBoolExp>;
  class?: Maybe<StudentOrParentClassesBoolExp>;
  class_id?: Maybe<StudentOrParentUuidComparisonExp>;
  course_students?: Maybe<StudentOrParentCourseStudentBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  grades?: Maybe<StudentOrParentGradesBoolExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "students" */
export interface StudentOrParentStudentsMaxOrderBy {
  class_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "students" */
export interface StudentOrParentStudentsMinOrderBy {
  class_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "students". */
export interface StudentOrParentStudentsOrderBy {
  chapter_section_notes_aggregate?: Maybe<StudentOrParentChapterSectionNotesAggregateOrderBy>;
  chapter_section_students_aggregate?: Maybe<StudentOrParentChapterSectionSubmitsAggregateOrderBy>;
  class?: Maybe<StudentOrParentClassesOrderBy>;
  class_id?: Maybe<StudentOrParentOrderBy>;
  course_students_aggregate?: Maybe<StudentOrParentCourseStudentAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  grades_aggregate?: Maybe<StudentOrParentGradesAggregateOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "students" */
export const enum StudentOrParentStudentsSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** columns and relationships of "subjects" */
export interface StudentOrParentSubjects {
  /** An array relationship */
  books: EntireFieldWrapper<Array<StudentOrParentBooks>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<StudentOrParentClassrooms>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<StudentOrParentCourses>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrParentViewGradeTypeSubject>>;
  icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  name: EntireFieldWrapper<Scalars['String']>;
  /** An array relationship */
  statistics: EntireFieldWrapper<Array<StudentOrParentViewStatisticsSemesterSubjectMark>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentOrParentViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentOrParentViewGradesAggregate>;
}


/** columns and relationships of "subjects" */
export interface StudentOrParentSubjectsBooksArgs {
  distinct_on?: Maybe<Array<StudentOrParentBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBooksOrderBy>>;
  where?: Maybe<StudentOrParentBooksBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrParentSubjectsClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassroomsOrderBy>>;
  where?: Maybe<StudentOrParentClassroomsBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrParentSubjectsCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrParentCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCoursesOrderBy>>;
  where?: Maybe<StudentOrParentCoursesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrParentSubjectsGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<StudentOrParentViewGradeTypeSubjectBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrParentSubjectsStatisticsArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrParentSubjectsViewGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradesOrderBy>>;
  where?: Maybe<StudentOrParentViewGradesBoolExp>;
}


/** columns and relationships of "subjects" */
export interface StudentOrParentSubjectsViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradesOrderBy>>;
  where?: Maybe<StudentOrParentViewGradesBoolExp>;
}

/** Boolean expression to filter rows from the table "subjects". All fields are combined with a logical 'AND'. */
export interface StudentOrParentSubjectsBoolExp {
  _and?: Maybe<Array<StudentOrParentSubjectsBoolExp>>;
  _not?: Maybe<StudentOrParentSubjectsBoolExp>;
  _or?: Maybe<Array<StudentOrParentSubjectsBoolExp>>;
  books?: Maybe<StudentOrParentBooksBoolExp>;
  classrooms?: Maybe<StudentOrParentClassroomsBoolExp>;
  courses?: Maybe<StudentOrParentCoursesBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  grade_types?: Maybe<StudentOrParentViewGradeTypeSubjectBoolExp>;
  icon?: Maybe<StudentOrParentStringComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  statistics?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkBoolExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  view_grades?: Maybe<StudentOrParentViewGradesBoolExp>;
}

/** Ordering options when selecting data from "subjects". */
export interface StudentOrParentSubjectsOrderBy {
  books_aggregate?: Maybe<StudentOrParentBooksAggregateOrderBy>;
  classrooms_aggregate?: Maybe<StudentOrParentClassroomsAggregateOrderBy>;
  courses_aggregate?: Maybe<StudentOrParentCoursesAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  grade_types_aggregate?: Maybe<StudentOrParentViewGradeTypeSubjectAggregateOrderBy>;
  icon?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  statistics_aggregate?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkAggregateOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  view_grades_aggregate?: Maybe<StudentOrParentViewGradesAggregateOrderBy>;
}

/** select columns of table "subjects" */
export const enum StudentOrParentSubjectsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ICON = 'icon',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface StudentOrParentSubscriptionRoot {
  /** fetch data from the table: "assignment_attendee_type" */
  assignment_attendee_type: EntireFieldWrapper<Array<StudentOrParentAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_attendee_type" using primary key columns */
  assignment_attendee_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentAttendeeType>>;
  /** fetch data from the table: "assignment_book_chapter" */
  assignment_book_chapter: EntireFieldWrapper<Array<StudentOrParentAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_book_chapter" using primary key columns */
  assignment_book_chapter_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentBookChapter>>;
  /** fetch data from the table: "assignment_grade_weights" */
  assignment_grade_weights: EntireFieldWrapper<Array<StudentOrParentAssignmentGradeWeights>>;
  /** fetch aggregated fields from the table: "assignment_grade_weights" */
  assignment_grade_weights_aggregate: EntireFieldWrapper<StudentOrParentAssignmentGradeWeightsAggregate>;
  /** fetch data from the table: "assignment_grade_weights" using primary key columns */
  assignment_grade_weights_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentGradeWeights>>;
  /** An array relationship */
  assignment_submits: EntireFieldWrapper<Array<StudentOrParentAssignmentSubmits>>;
  /** fetch data from the table: "assignment_submits" using primary key columns */
  assignment_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentSubmits>>;
  /** fetch data from the table: "assignment_type" */
  assignment_type: EntireFieldWrapper<Array<StudentOrParentAssignmentType>>;
  /** fetch data from the table: "assignment_type" using primary key columns */
  assignment_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentType>>;
  /** fetch data from the table: "assignment_user" */
  assignment_user: EntireFieldWrapper<Array<StudentOrParentAssignmentUser>>;
  /** fetch data from the table: "assignment_user" using primary key columns */
  assignment_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignmentUser>>;
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrParentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrParentAssignmentsAggregate>;
  /** fetch data from the table: "assignments" using primary key columns */
  assignments_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentAssignments>>;
  /** fetch data from the table: "book_chapter_type" */
  book_chapter_type: EntireFieldWrapper<Array<StudentOrParentBookChapterType>>;
  /** fetch data from the table: "book_chapter_type" using primary key columns */
  book_chapter_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBookChapterType>>;
  /** An array relationship */
  book_chapters: EntireFieldWrapper<Array<StudentOrParentBookChapters>>;
  /** fetch data from the table: "book_chapters" using primary key columns */
  book_chapters_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBookChapters>>;
  /** fetch data from the table: "book_course" */
  book_course: EntireFieldWrapper<Array<StudentOrParentBookCourse>>;
  /** fetch data from the table: "book_course" using primary key columns */
  book_course_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBookCourse>>;
  /** fetch data from the table: "book_user" */
  book_user: EntireFieldWrapper<Array<StudentOrParentBookUser>>;
  /** fetch data from the table: "book_user" using primary key columns */
  book_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBookUser>>;
  /** An array relationship */
  books: EntireFieldWrapper<Array<StudentOrParentBooks>>;
  /** fetch data from the table: "books" using primary key columns */
  books_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentBooks>>;
  /** An array relationship */
  chapter_section_notes: EntireFieldWrapper<Array<StudentOrParentChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_notes" using primary key columns */
  chapter_section_notes_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChapterSectionNotes>>;
  /** fetch data from the table: "chapter_section_submits" */
  chapter_section_submits: EntireFieldWrapper<Array<StudentOrParentChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_submits" using primary key columns */
  chapter_section_submits_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChapterSectionSubmits>>;
  /** fetch data from the table: "chapter_section_type" */
  chapter_section_type: EntireFieldWrapper<Array<StudentOrParentChapterSectionType>>;
  /** fetch data from the table: "chapter_section_type" using primary key columns */
  chapter_section_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChapterSectionType>>;
  /** An array relationship */
  chapter_sections: EntireFieldWrapper<Array<StudentOrParentChapterSections>>;
  /** fetch data from the table: "chapter_sections" using primary key columns */
  chapter_sections_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChapterSections>>;
  /** fetch data from the table: "chat_message_likes" */
  chat_message_likes: EntireFieldWrapper<Array<StudentOrParentChatMessageLikes>>;
  /** An aggregate relationship */
  chat_message_likes_aggregate: EntireFieldWrapper<StudentOrParentChatMessageLikesAggregate>;
  /** fetch data from the table: "chat_message_likes" using primary key columns */
  chat_message_likes_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageLikes>>;
  /** An array relationship */
  chat_message_reads: EntireFieldWrapper<Array<StudentOrParentChatMessageReads>>;
  /** fetch data from the table: "chat_message_reads" using primary key columns */
  chat_message_reads_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatMessageReads>>;
  /** An array relationship */
  chat_messages: EntireFieldWrapper<Array<StudentOrParentChatMessages>>;
  /** An aggregate relationship */
  chat_messages_aggregate: EntireFieldWrapper<StudentOrParentChatMessagesAggregate>;
  /** fetch data from the table: "chat_messages" using primary key columns */
  chat_messages_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatMessages>>;
  /** fetch data from the table: "chat_type" */
  chat_type: EntireFieldWrapper<Array<StudentOrParentChatType>>;
  /** fetch data from the table: "chat_type" using primary key columns */
  chat_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatType>>;
  /** fetch data from the table: "chat_user" */
  chat_user: EntireFieldWrapper<Array<StudentOrParentChatUser>>;
  /** fetch data from the table: "chat_user" using primary key columns */
  chat_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChatUser>>;
  /** An array relationship */
  chats: EntireFieldWrapper<Array<StudentOrParentChats>>;
  /** fetch data from the table: "chats" using primary key columns */
  chats_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentChats>>;
  /** fetch data from the table: "class_levels" */
  class_levels: EntireFieldWrapper<Array<StudentOrParentClassLevels>>;
  /** fetch data from the table: "class_levels" using primary key columns */
  class_levels_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentClassLevels>>;
  /** fetch data from the table: "class_type" */
  class_type: EntireFieldWrapper<Array<StudentOrParentClassType>>;
  /** fetch data from the table: "class_type" using primary key columns */
  class_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentClassType>>;
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrParentClasses>>;
  /** fetch data from the table: "classes" using primary key columns */
  classes_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentClasses>>;
  /** An array relationship */
  classrooms: EntireFieldWrapper<Array<StudentOrParentClassrooms>>;
  /** fetch data from the table: "classrooms" using primary key columns */
  classrooms_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentClassrooms>>;
  /** fetch data from the table: "course_class" */
  course_class: EntireFieldWrapper<Array<StudentOrParentCourseClass>>;
  /** fetch data from the table: "course_class" using primary key columns */
  course_class_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourseClass>>;
  /** fetch data from the table: "course_classroom" */
  course_classroom: EntireFieldWrapper<Array<StudentOrParentCourseClassroom>>;
  /** fetch data from the table: "course_classroom" using primary key columns */
  course_classroom_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourseClassroom>>;
  /** fetch data from the table: "course_student" */
  course_student: EntireFieldWrapper<Array<StudentOrParentCourseStudent>>;
  /** fetch data from the table: "course_student" using primary key columns */
  course_student_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourseStudent>>;
  /** fetch data from the table: "course_teacher" */
  course_teacher: EntireFieldWrapper<Array<StudentOrParentCourseTeacher>>;
  /** fetch data from the table: "course_teacher" using primary key columns */
  course_teacher_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourseTeacher>>;
  /** An array relationship */
  courses: EntireFieldWrapper<Array<StudentOrParentCourses>>;
  /** fetch data from the table: "courses" using primary key columns */
  courses_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentCourses>>;
  /** fetch data from the table: "event_users" */
  event_users: EntireFieldWrapper<Array<StudentOrParentEventUsers>>;
  /** fetch data from the table: "event_users" using primary key columns */
  event_users_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentEventUsers>>;
  /** fetch data from the table: "events" */
  events: EntireFieldWrapper<Array<StudentOrParentEvents>>;
  /** fetch data from the table: "events" using primary key columns */
  events_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentEvents>>;
  /** An array relationship */
  files: EntireFieldWrapper<Array<StudentOrParentFiles>>;
  /** fetch data from the table: "files" using primary key columns */
  files_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentFiles>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrParentGradeTypes>>;
  /** fetch data from the table: "grade_types" using primary key columns */
  grade_types_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentGradeTypes>>;
  /** An array relationship */
  grades: EntireFieldWrapper<Array<StudentOrParentGrades>>;
  /** An aggregate relationship */
  grades_aggregate: EntireFieldWrapper<StudentOrParentGradesAggregate>;
  /** fetch data from the table: "grades" using primary key columns */
  grades_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentGrades>>;
  /** fetch data from the table: "lesson_attendace_type" */
  lesson_attendace_type: EntireFieldWrapper<Array<StudentOrParentLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendace_type" using primary key columns */
  lesson_attendace_type_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentLessonAttendaceType>>;
  /** fetch data from the table: "lesson_attendances" */
  lesson_attendances: EntireFieldWrapper<Array<StudentOrParentLessonAttendances>>;
  /** fetch data from the table: "lesson_attendances" using primary key columns */
  lesson_attendances_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentLessonAttendances>>;
  /** An array relationship */
  lessons: EntireFieldWrapper<Array<StudentOrParentLessons>>;
  /** fetch data from the table: "lessons" using primary key columns */
  lessons_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentLessons>>;
  /** fetch data from the table: "live_classes" */
  live_classes: EntireFieldWrapper<Array<StudentOrParentLiveClasses>>;
  /** fetch data from the table: "live_classes" using primary key columns */
  live_classes_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentLiveClasses>>;
  /** fetch data from the table: "marks" */
  marks: EntireFieldWrapper<Array<StudentOrParentMarks>>;
  /** fetch data from the table: "marks" using primary key columns */
  marks_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentMarks>>;
  /** fetch data from the table: "meeting_user" */
  meeting_user: EntireFieldWrapper<Array<StudentOrParentMeetingUser>>;
  /** fetch aggregated fields from the table: "meeting_user" */
  meeting_user_aggregate: EntireFieldWrapper<StudentOrParentMeetingUserAggregate>;
  /** fetch data from the table: "meeting_user" using primary key columns */
  meeting_user_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentMeetingUser>>;
  /** fetch data from the table: "parent_student" */
  parent_student: EntireFieldWrapper<Array<StudentOrParentParentStudent>>;
  /** fetch data from the table: "parent_student" using primary key columns */
  parent_student_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentParentStudent>>;
  /** fetch data from the table: "parents" */
  parents: EntireFieldWrapper<Array<StudentOrParentParents>>;
  /** fetch data from the table: "parents" using primary key columns */
  parents_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentParents>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<StudentOrParentPromotions>>;
  /** fetch data from the table: "promotions" using primary key columns */
  promotions_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentPromotions>>;
  /** fetch data from the table: "semesters" */
  semesters: EntireFieldWrapper<Array<StudentOrParentSemesters>>;
  /** fetch data from the table: "semesters" using primary key columns */
  semesters_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSemesters>>;
  /** An array relationship */
  students: EntireFieldWrapper<Array<StudentOrParentStudents>>;
  /** fetch data from the table: "students" using primary key columns */
  students_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentStudents>>;
  /** fetch data from the table: "subjects" */
  subjects: EntireFieldWrapper<Array<StudentOrParentSubjects>>;
  /** fetch data from the table: "subjects" using primary key columns */
  subjects_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentSubjects>>;
  /** fetch data from the table: "tasks" */
  tasks: EntireFieldWrapper<Array<StudentOrParentTasks>>;
  /** fetch aggregated fields from the table: "tasks" */
  tasks_aggregate: EntireFieldWrapper<StudentOrParentTasksAggregate>;
  /** fetch data from the table: "tasks" using primary key columns */
  tasks_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentTasks>>;
  /** An array relationship */
  teachers: EntireFieldWrapper<Array<StudentOrParentTeachers>>;
  /** fetch data from the table: "teachers" using primary key columns */
  teachers_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentTeachers>>;
  /** execute function "teaching_structure_leafs" which returns "teaching_structures" */
  teaching_structure_leafs: EntireFieldWrapper<Array<StudentOrParentTeachingStructures>>;
  /** execute function "teaching_structure_leafs" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_leafs_aggregate: EntireFieldWrapper<StudentOrParentTeachingStructuresAggregate>;
  /** execute function "teaching_structure_parents" which returns "teaching_structures" */
  teaching_structure_parents: EntireFieldWrapper<Array<StudentOrParentTeachingStructures>>;
  /** execute function "teaching_structure_parents" and query aggregates on result of table type "teaching_structures" */
  teaching_structure_parents_aggregate: EntireFieldWrapper<StudentOrParentTeachingStructuresAggregate>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<StudentOrParentTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<StudentOrParentTeachingStructuresAggregate>;
  /** fetch data from the table: "teaching_structures" using primary key columns */
  teaching_structures_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructures>>;
  /** fetch data from the table: "view.assignment_class" */
  view_assignment_class: EntireFieldWrapper<Array<StudentOrParentViewAssignmentClass>>;
  /** fetch data from the table: "view.assignment_student_grade" */
  view_assignment_student_grade: EntireFieldWrapper<Array<StudentOrParentViewAssignmentStudentGrade>>;
  /** fetch data from the table: "view.class_student" */
  view_class_student: EntireFieldWrapper<Array<StudentOrParentViewClassStudent>>;
  /** fetch data from the table: "view.grade_type_subject" */
  view_grade_type_subject: EntireFieldWrapper<Array<StudentOrParentViewGradeTypeSubject>>;
  /** An array relationship */
  view_grades: EntireFieldWrapper<Array<StudentOrParentViewGrades>>;
  /** An aggregate relationship */
  view_grades_aggregate: EntireFieldWrapper<StudentOrParentViewGradesAggregate>;
  /** fetch data from the table: "view.latest_chat_messages" */
  view_latest_chat_messages: EntireFieldWrapper<Array<StudentOrParentViewLatestChatMessages>>;
  /** fetch aggregated fields from the table: "view.latest_chat_messages" */
  view_latest_chat_messages_aggregate: EntireFieldWrapper<StudentOrParentViewLatestChatMessagesAggregate>;
  /** fetch data from the table: "view.statistics_semester_subject_mark" */
  view_statistics_semester_subject_mark: EntireFieldWrapper<Array<StudentOrParentViewStatisticsSemesterSubjectMark>>;
  /** fetch data from the table: "view.subject_semester" */
  view_subject_semester: EntireFieldWrapper<Array<StudentOrParentViewSubjectSemester>>;
  /** fetch data from the table: "view.teacher_class_subject" */
  view_teacher_class_subject: EntireFieldWrapper<Array<StudentOrParentViewTeacherClassSubject>>;
  /** fetch data from the table: "years" */
  years: EntireFieldWrapper<Array<StudentOrParentYears>>;
  /** fetch aggregated fields from the table: "years" */
  years_aggregate: EntireFieldWrapper<StudentOrParentYearsAggregate>;
  /** fetch data from the table: "years" using primary key columns */
  years_by_pk?: EntireFieldWrapper<Maybe<StudentOrParentYears>>;
}


export interface StudentOrParentSubscriptionRootAssignmentAttendeeTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentAttendeeTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentAttendeeTypeOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentAttendeeTypeBoolExp>;
}


export interface StudentOrParentSubscriptionRootAssignmentAttendeeTypeByPkArgs {
  value: Scalars['String'];
}


export interface StudentOrParentSubscriptionRootAssignmentBookChapterArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentBookChapterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentBookChapterOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentBookChapterBoolExp>;
}


export interface StudentOrParentSubscriptionRootAssignmentBookChapterByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootAssignmentGradeWeightsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentGradeWeightsBoolExp>;
}


export interface StudentOrParentSubscriptionRootAssignmentGradeWeightsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentGradeWeightsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentGradeWeightsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentGradeWeightsBoolExp>;
}


export interface StudentOrParentSubscriptionRootAssignmentGradeWeightsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootAssignmentSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentSubmitsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentSubmitsBoolExp>;
}


export interface StudentOrParentSubscriptionRootAssignmentSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootAssignmentTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentTypeOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentTypeBoolExp>;
}


export interface StudentOrParentSubscriptionRootAssignmentTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentSubscriptionRootAssignmentUserArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentUserOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentUserBoolExp>;
}


export interface StudentOrParentSubscriptionRootAssignmentUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


export interface StudentOrParentSubscriptionRootAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


export interface StudentOrParentSubscriptionRootAssignmentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootBookChapterTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookChapterTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookChapterTypeOrderBy>>;
  where?: Maybe<StudentOrParentBookChapterTypeBoolExp>;
}


export interface StudentOrParentSubscriptionRootBookChapterTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentSubscriptionRootBookChaptersArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookChaptersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookChaptersOrderBy>>;
  where?: Maybe<StudentOrParentBookChaptersBoolExp>;
}


export interface StudentOrParentSubscriptionRootBookChaptersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootBookCourseArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookCourseSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookCourseOrderBy>>;
  where?: Maybe<StudentOrParentBookCourseBoolExp>;
}


export interface StudentOrParentSubscriptionRootBookCourseByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootBookUserArgs {
  distinct_on?: Maybe<Array<StudentOrParentBookUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBookUserOrderBy>>;
  where?: Maybe<StudentOrParentBookUserBoolExp>;
}


export interface StudentOrParentSubscriptionRootBookUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootBooksArgs {
  distinct_on?: Maybe<Array<StudentOrParentBooksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentBooksOrderBy>>;
  where?: Maybe<StudentOrParentBooksBoolExp>;
}


export interface StudentOrParentSubscriptionRootBooksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootChapterSectionNotesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionNotesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionNotesOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionNotesBoolExp>;
}


export interface StudentOrParentSubscriptionRootChapterSectionNotesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootChapterSectionSubmitsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionSubmitsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionSubmitsOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionSubmitsBoolExp>;
}


export interface StudentOrParentSubscriptionRootChapterSectionSubmitsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootChapterSectionTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionTypeOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionTypeBoolExp>;
}


export interface StudentOrParentSubscriptionRootChapterSectionTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentSubscriptionRootChapterSectionsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChapterSectionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChapterSectionsOrderBy>>;
  where?: Maybe<StudentOrParentChapterSectionsBoolExp>;
}


export interface StudentOrParentSubscriptionRootChapterSectionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootChatMessageLikesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessageLikesBoolExp>;
}


export interface StudentOrParentSubscriptionRootChatMessageLikesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessageLikesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessageLikesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessageLikesBoolExp>;
}


export interface StudentOrParentSubscriptionRootChatMessageLikesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootChatMessageReadsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessageReadsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessageReadsOrderBy>>;
  where?: Maybe<StudentOrParentChatMessageReadsBoolExp>;
}


export interface StudentOrParentSubscriptionRootChatMessageReadsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}


export interface StudentOrParentSubscriptionRootChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentChatMessagesBoolExp>;
}


export interface StudentOrParentSubscriptionRootChatMessagesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootChatTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatTypeOrderBy>>;
  where?: Maybe<StudentOrParentChatTypeBoolExp>;
}


export interface StudentOrParentSubscriptionRootChatTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentSubscriptionRootChatUserArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatUserOrderBy>>;
  where?: Maybe<StudentOrParentChatUserBoolExp>;
}


export interface StudentOrParentSubscriptionRootChatUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootChatsArgs {
  distinct_on?: Maybe<Array<StudentOrParentChatsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentChatsOrderBy>>;
  where?: Maybe<StudentOrParentChatsBoolExp>;
}


export interface StudentOrParentSubscriptionRootChatsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootClassLevelsArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassLevelsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassLevelsOrderBy>>;
  where?: Maybe<StudentOrParentClassLevelsBoolExp>;
}


export interface StudentOrParentSubscriptionRootClassLevelsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootClassTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassTypeOrderBy>>;
  where?: Maybe<StudentOrParentClassTypeBoolExp>;
}


export interface StudentOrParentSubscriptionRootClassTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentSubscriptionRootClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassesOrderBy>>;
  where?: Maybe<StudentOrParentClassesBoolExp>;
}


export interface StudentOrParentSubscriptionRootClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootClassroomsArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassroomsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassroomsOrderBy>>;
  where?: Maybe<StudentOrParentClassroomsBoolExp>;
}


export interface StudentOrParentSubscriptionRootClassroomsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootCourseClassArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseClassOrderBy>>;
  where?: Maybe<StudentOrParentCourseClassBoolExp>;
}


export interface StudentOrParentSubscriptionRootCourseClassByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootCourseClassroomArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseClassroomSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseClassroomOrderBy>>;
  where?: Maybe<StudentOrParentCourseClassroomBoolExp>;
}


export interface StudentOrParentSubscriptionRootCourseClassroomByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootCourseStudentArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseStudentOrderBy>>;
  where?: Maybe<StudentOrParentCourseStudentBoolExp>;
}


export interface StudentOrParentSubscriptionRootCourseStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootCourseTeacherArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseTeacherOrderBy>>;
  where?: Maybe<StudentOrParentCourseTeacherBoolExp>;
}


export interface StudentOrParentSubscriptionRootCourseTeacherByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootCoursesArgs {
  distinct_on?: Maybe<Array<StudentOrParentCoursesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCoursesOrderBy>>;
  where?: Maybe<StudentOrParentCoursesBoolExp>;
}


export interface StudentOrParentSubscriptionRootCoursesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootEventUsersArgs {
  distinct_on?: Maybe<Array<StudentOrParentEventUsersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentEventUsersOrderBy>>;
  where?: Maybe<StudentOrParentEventUsersBoolExp>;
}


export interface StudentOrParentSubscriptionRootEventUsersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootEventsArgs {
  distinct_on?: Maybe<Array<StudentOrParentEventsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentEventsOrderBy>>;
  where?: Maybe<StudentOrParentEventsBoolExp>;
}


export interface StudentOrParentSubscriptionRootEventsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootFilesArgs {
  distinct_on?: Maybe<Array<StudentOrParentFilesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentFilesOrderBy>>;
  where?: Maybe<StudentOrParentFilesBoolExp>;
}


export interface StudentOrParentSubscriptionRootFilesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradeTypesOrderBy>>;
  where?: Maybe<StudentOrParentGradeTypesBoolExp>;
}


export interface StudentOrParentSubscriptionRootGradeTypesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}


export interface StudentOrParentSubscriptionRootGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradesOrderBy>>;
  where?: Maybe<StudentOrParentGradesBoolExp>;
}


export interface StudentOrParentSubscriptionRootGradesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootLessonAttendaceTypeArgs {
  distinct_on?: Maybe<Array<StudentOrParentLessonAttendaceTypeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLessonAttendaceTypeOrderBy>>;
  where?: Maybe<StudentOrParentLessonAttendaceTypeBoolExp>;
}


export interface StudentOrParentSubscriptionRootLessonAttendaceTypeByPkArgs {
  name: Scalars['String'];
}


export interface StudentOrParentSubscriptionRootLessonAttendancesArgs {
  distinct_on?: Maybe<Array<StudentOrParentLessonAttendancesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLessonAttendancesOrderBy>>;
  where?: Maybe<StudentOrParentLessonAttendancesBoolExp>;
}


export interface StudentOrParentSubscriptionRootLessonAttendancesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootLessonsArgs {
  distinct_on?: Maybe<Array<StudentOrParentLessonsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLessonsOrderBy>>;
  where?: Maybe<StudentOrParentLessonsBoolExp>;
}


export interface StudentOrParentSubscriptionRootLessonsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootLiveClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentLiveClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentLiveClassesOrderBy>>;
  where?: Maybe<StudentOrParentLiveClassesBoolExp>;
}


export interface StudentOrParentSubscriptionRootLiveClassesByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootMarksArgs {
  distinct_on?: Maybe<Array<StudentOrParentMarksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentMarksOrderBy>>;
  where?: Maybe<StudentOrParentMarksBoolExp>;
}


export interface StudentOrParentSubscriptionRootMarksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootMeetingUserArgs {
  distinct_on?: Maybe<Array<StudentOrParentMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentMeetingUserOrderBy>>;
  where?: Maybe<StudentOrParentMeetingUserBoolExp>;
}


export interface StudentOrParentSubscriptionRootMeetingUserAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentMeetingUserSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentMeetingUserOrderBy>>;
  where?: Maybe<StudentOrParentMeetingUserBoolExp>;
}


export interface StudentOrParentSubscriptionRootMeetingUserByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootParentStudentArgs {
  distinct_on?: Maybe<Array<StudentOrParentParentStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentParentStudentOrderBy>>;
  where?: Maybe<StudentOrParentParentStudentBoolExp>;
}


export interface StudentOrParentSubscriptionRootParentStudentByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootParentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentParentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentParentsOrderBy>>;
  where?: Maybe<StudentOrParentParentsBoolExp>;
}


export interface StudentOrParentSubscriptionRootParentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootPromotionsArgs {
  distinct_on?: Maybe<Array<StudentOrParentPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPromotionsOrderBy>>;
  where?: Maybe<StudentOrParentPromotionsBoolExp>;
}


export interface StudentOrParentSubscriptionRootPromotionsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootSemestersArgs {
  distinct_on?: Maybe<Array<StudentOrParentSemestersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSemestersOrderBy>>;
  where?: Maybe<StudentOrParentSemestersBoolExp>;
}


export interface StudentOrParentSubscriptionRootSemestersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootStudentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentStudentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentStudentsOrderBy>>;
  where?: Maybe<StudentOrParentStudentsBoolExp>;
}


export interface StudentOrParentSubscriptionRootStudentsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootSubjectsArgs {
  distinct_on?: Maybe<Array<StudentOrParentSubjectsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentSubjectsOrderBy>>;
  where?: Maybe<StudentOrParentSubjectsBoolExp>;
}


export interface StudentOrParentSubscriptionRootSubjectsByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootTasksArgs {
  distinct_on?: Maybe<Array<StudentOrParentTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTasksOrderBy>>;
  where?: Maybe<StudentOrParentTasksBoolExp>;
}


export interface StudentOrParentSubscriptionRootTasksAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentTasksSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTasksOrderBy>>;
  where?: Maybe<StudentOrParentTasksBoolExp>;
}


export interface StudentOrParentSubscriptionRootTasksByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrParentTeachersSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachersOrderBy>>;
  where?: Maybe<StudentOrParentTeachersBoolExp>;
}


export interface StudentOrParentSubscriptionRootTeachersByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootTeachingStructureLeafsArgs {
  args: StudentOrParentTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentSubscriptionRootTeachingStructureLeafsAggregateArgs {
  args: StudentOrParentTeachingStructureLeafsArgs;
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentSubscriptionRootTeachingStructureParentsArgs {
  args: StudentOrParentTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentSubscriptionRootTeachingStructureParentsAggregateArgs {
  args: StudentOrParentTeachingStructureParentsArgs;
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentSubscriptionRootTeachingStructuresArgs {
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentSubscriptionRootTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


export interface StudentOrParentSubscriptionRootTeachingStructuresByPkArgs {
  id: Scalars['uuid'];
}


export interface StudentOrParentSubscriptionRootViewAssignmentClassArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewAssignmentClassSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewAssignmentClassOrderBy>>;
  where?: Maybe<StudentOrParentViewAssignmentClassBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewAssignmentStudentGradeArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewAssignmentStudentGradeSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewAssignmentStudentGradeOrderBy>>;
  where?: Maybe<StudentOrParentViewAssignmentStudentGradeBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewClassStudentArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewClassStudentSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewClassStudentOrderBy>>;
  where?: Maybe<StudentOrParentViewClassStudentBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewGradeTypeSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradeTypeSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradeTypeSubjectOrderBy>>;
  where?: Maybe<StudentOrParentViewGradeTypeSubjectBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewGradesArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradesOrderBy>>;
  where?: Maybe<StudentOrParentViewGradesBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewGradesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewGradesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewGradesOrderBy>>;
  where?: Maybe<StudentOrParentViewGradesBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewLatestChatMessagesArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentViewLatestChatMessagesBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewLatestChatMessagesAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewLatestChatMessagesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewLatestChatMessagesOrderBy>>;
  where?: Maybe<StudentOrParentViewLatestChatMessagesBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewStatisticsSemesterSubjectMarkArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewStatisticsSemesterSubjectMarkSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewStatisticsSemesterSubjectMarkOrderBy>>;
  where?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewSubjectSemesterArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewSubjectSemesterSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewSubjectSemesterOrderBy>>;
  where?: Maybe<StudentOrParentViewSubjectSemesterBoolExp>;
}


export interface StudentOrParentSubscriptionRootViewTeacherClassSubjectArgs {
  distinct_on?: Maybe<Array<StudentOrParentViewTeacherClassSubjectSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentViewTeacherClassSubjectOrderBy>>;
  where?: Maybe<StudentOrParentViewTeacherClassSubjectBoolExp>;
}


export interface StudentOrParentSubscriptionRootYearsArgs {
  distinct_on?: Maybe<Array<StudentOrParentYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentYearsOrderBy>>;
  where?: Maybe<StudentOrParentYearsBoolExp>;
}


export interface StudentOrParentSubscriptionRootYearsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentYearsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentYearsOrderBy>>;
  where?: Maybe<StudentOrParentYearsBoolExp>;
}


export interface StudentOrParentSubscriptionRootYearsByPkArgs {
  id: Scalars['uuid'];
}

/** columns and relationships of "tasks" */
export interface StudentOrParentTasks {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  is_completed: EntireFieldWrapper<Scalars['Boolean']>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  /** The user this tasks belongs. */
  user_id: EntireFieldWrapper<Scalars['uuid']>;
}

/** aggregated selection of "tasks" */
export interface StudentOrParentTasksAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentTasksAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentTasks>>;
}

/** aggregate fields of "tasks" */
export interface StudentOrParentTasksAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentTasksMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentTasksMinFields>>;
}


/** aggregate fields of "tasks" */
export interface StudentOrParentTasksAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentTasksSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "tasks". All fields are combined with a logical 'AND'. */
export interface StudentOrParentTasksBoolExp {
  _and?: Maybe<Array<StudentOrParentTasksBoolExp>>;
  _not?: Maybe<StudentOrParentTasksBoolExp>;
  _or?: Maybe<Array<StudentOrParentTasksBoolExp>>;
  body?: Maybe<StudentOrParentStringComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  is_completed?: Maybe<StudentOrParentBooleanComparisonExp>;
  title?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrParentTasksMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentOrParentTasksMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  /** The user this tasks belongs. */
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** response of any mutation on the table "tasks" */
export interface StudentOrParentTasksMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentTasks>>;
}

/** Ordering options when selecting data from "tasks". */
export interface StudentOrParentTasksOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  is_completed?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "tasks" */
export const enum StudentOrParentTasksSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  IS_COMPLETED = 'is_completed',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "teachers" */
export interface StudentOrParentTeachers {
  /** An array relationship */
  classes: EntireFieldWrapper<Array<StudentOrParentClasses>>;
  /** An object relationship */
  classroom?: EntireFieldWrapper<Maybe<StudentOrParentClassrooms>>;
  classroom_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  course_teachers: EntireFieldWrapper<Array<StudentOrParentCourseTeacher>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  type: EntireFieldWrapper<Scalars['String']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
}


/** columns and relationships of "teachers" */
export interface StudentOrParentTeachersClassesArgs {
  distinct_on?: Maybe<Array<StudentOrParentClassesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentClassesOrderBy>>;
  where?: Maybe<StudentOrParentClassesBoolExp>;
}


/** columns and relationships of "teachers" */
export interface StudentOrParentTeachersCourseTeachersArgs {
  distinct_on?: Maybe<Array<StudentOrParentCourseTeacherSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentCourseTeacherOrderBy>>;
  where?: Maybe<StudentOrParentCourseTeacherBoolExp>;
}

/** order by aggregate values of table "teachers" */
export interface StudentOrParentTeachersAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentTeachersMaxOrderBy>;
  min?: Maybe<StudentOrParentTeachersMinOrderBy>;
}

/** Boolean expression to filter rows from the table "teachers". All fields are combined with a logical 'AND'. */
export interface StudentOrParentTeachersBoolExp {
  _and?: Maybe<Array<StudentOrParentTeachersBoolExp>>;
  _not?: Maybe<StudentOrParentTeachersBoolExp>;
  _or?: Maybe<Array<StudentOrParentTeachersBoolExp>>;
  classes?: Maybe<StudentOrParentClassesBoolExp>;
  classroom?: Maybe<StudentOrParentClassroomsBoolExp>;
  classroom_id?: Maybe<StudentOrParentUuidComparisonExp>;
  course_teachers?: Maybe<StudentOrParentCourseTeacherBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  type?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** order by max() on columns of table "teachers" */
export interface StudentOrParentTeachersMaxOrderBy {
  classroom_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "teachers" */
export interface StudentOrParentTeachersMinOrderBy {
  classroom_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "teachers". */
export interface StudentOrParentTeachersOrderBy {
  classes_aggregate?: Maybe<StudentOrParentClassesAggregateOrderBy>;
  classroom?: Maybe<StudentOrParentClassroomsOrderBy>;
  classroom_id?: Maybe<StudentOrParentOrderBy>;
  course_teachers_aggregate?: Maybe<StudentOrParentCourseTeacherAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  type?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "teachers" */
export const enum StudentOrParentTeachersSelectColumn {
  /** column name */
  CLASSROOM_ID = 'classroom_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  TYPE = 'type',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export interface StudentOrParentTeachingStructureLeafsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

export interface StudentOrParentTeachingStructureParentsArgs {
  leaf_id?: Maybe<Scalars['uuid']>;
}

/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrParentTeachingStructures {
  /** An array relationship */
  assignments: EntireFieldWrapper<Array<StudentOrParentAssignments>>;
  /** An aggregate relationship */
  assignments_aggregate: EntireFieldWrapper<StudentOrParentAssignmentsAggregate>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  depth: EntireFieldWrapper<Scalars['Int']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  ltr: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  parent?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructures>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl: EntireFieldWrapper<Scalars['Int']>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<StudentOrParentSemesters>>;
  /** A computed field, executes function "subject_icon" */
  subject_icon?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An array relationship */
  teaching_structures: EntireFieldWrapper<Array<StudentOrParentTeachingStructures>>;
  /** An aggregate relationship */
  teaching_structures_aggregate: EntireFieldWrapper<StudentOrParentTeachingStructuresAggregate>;
  title: EntireFieldWrapper<Scalars['String']>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrParentTeachingStructuresAssignmentsArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrParentTeachingStructuresAssignmentsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentAssignmentsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentAssignmentsOrderBy>>;
  where?: Maybe<StudentOrParentAssignmentsBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrParentTeachingStructuresTeachingStructuresArgs {
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}


/**
 * Nested set table that makes it possible for school to arrange teaching structure as they like
 *
 *
 * columns and relationships of "teaching_structures"
 */
export interface StudentOrParentTeachingStructuresTeachingStructuresAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentTeachingStructuresOrderBy>>;
  where?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
}

/** aggregated selection of "teaching_structures" */
export interface StudentOrParentTeachingStructuresAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentTeachingStructures>>;
}

/** aggregate fields of "teaching_structures" */
export interface StudentOrParentTeachingStructuresAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrParentTeachingStructuresVarianceFields>>;
}


/** aggregate fields of "teaching_structures" */
export interface StudentOrParentTeachingStructuresAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentTeachingStructuresSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresAggregateOrderBy {
  avg?: Maybe<StudentOrParentTeachingStructuresAvgOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentTeachingStructuresMaxOrderBy>;
  min?: Maybe<StudentOrParentTeachingStructuresMinOrderBy>;
  stddev?: Maybe<StudentOrParentTeachingStructuresStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrParentTeachingStructuresStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrParentTeachingStructuresStddevSampOrderBy>;
  sum?: Maybe<StudentOrParentTeachingStructuresSumOrderBy>;
  var_pop?: Maybe<StudentOrParentTeachingStructuresVarPopOrderBy>;
  var_samp?: Maybe<StudentOrParentTeachingStructuresVarSampOrderBy>;
  variance?: Maybe<StudentOrParentTeachingStructuresVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentOrParentTeachingStructuresAvgFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresAvgOrderBy {
  depth?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
}

/** Boolean expression to filter rows from the table "teaching_structures". All fields are combined with a logical 'AND'. */
export interface StudentOrParentTeachingStructuresBoolExp {
  _and?: Maybe<Array<StudentOrParentTeachingStructuresBoolExp>>;
  _not?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
  _or?: Maybe<Array<StudentOrParentTeachingStructuresBoolExp>>;
  assignments?: Maybe<StudentOrParentAssignmentsBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  depth?: Maybe<StudentOrParentIntComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  ltr?: Maybe<StudentOrParentIntComparisonExp>;
  parent?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
  parent_id?: Maybe<StudentOrParentUuidComparisonExp>;
  rtl?: Maybe<StudentOrParentIntComparisonExp>;
  semester?: Maybe<StudentOrParentSemestersBoolExp>;
  subject_icon?: Maybe<StudentOrParentStringComparisonExp>;
  teaching_structures?: Maybe<StudentOrParentTeachingStructuresBoolExp>;
  title?: Maybe<StudentOrParentStringComparisonExp>;
  type_id?: Maybe<StudentOrParentUuidComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrParentTeachingStructuresMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by max() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  depth?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  parent_id?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  type_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentTeachingStructuresMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  parent_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** order by min() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  depth?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  parent_id?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  type_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "teaching_structures". */
export interface StudentOrParentTeachingStructuresOrderBy {
  assignments_aggregate?: Maybe<StudentOrParentAssignmentsAggregateOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  depth?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  parent?: Maybe<StudentOrParentTeachingStructuresOrderBy>;
  parent_id?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
  semester?: Maybe<StudentOrParentSemestersOrderBy>;
  subject_icon?: Maybe<StudentOrParentOrderBy>;
  teaching_structures_aggregate?: Maybe<StudentOrParentTeachingStructuresAggregateOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  type_id?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "teaching_structures" */
export const enum StudentOrParentTeachingStructuresSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  DEPTH = 'depth',
  /** column name */
  ID = 'id',
  /** column name */
  LTR = 'ltr',
  /** column name */
  PARENT_ID = 'parent_id',
  /** column name */
  RTL = 'rtl',
  /** column name */
  TITLE = 'title',
  /** column name */
  TYPE_ID = 'type_id',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** aggregate stddev on columns */
export interface StudentOrParentTeachingStructuresStddevFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresStddevOrderBy {
  depth?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrParentTeachingStructuresStddevPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresStddevPopOrderBy {
  depth?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrParentTeachingStructuresStddevSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresStddevSampOrderBy {
  depth?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate sum on columns */
export interface StudentOrParentTeachingStructuresSumFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresSumOrderBy {
  depth?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentOrParentTeachingStructuresVarPopFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresVarPopOrderBy {
  depth?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentOrParentTeachingStructuresVarSampFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresVarSampOrderBy {
  depth?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate variance on columns */
export interface StudentOrParentTeachingStructuresVarianceFields {
  depth?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  ltr?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  rtl?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "teaching_structures" */
export interface StudentOrParentTeachingStructuresVarianceOrderBy {
  depth?: Maybe<StudentOrParentOrderBy>;
  ltr?: Maybe<StudentOrParentOrderBy>;
  rtl?: Maybe<StudentOrParentOrderBy>;
}


/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export interface StudentOrParentTimestampComparisonExp {
  _eq?: Maybe<Scalars['timestamp']>;
  _gt?: Maybe<Scalars['timestamp']>;
  _gte?: Maybe<Scalars['timestamp']>;
  _in?: Maybe<Array<Scalars['timestamp']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamp']>;
  _lte?: Maybe<Scalars['timestamp']>;
  _neq?: Maybe<Scalars['timestamp']>;
  _nin?: Maybe<Array<Scalars['timestamp']>>;
}


/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export interface StudentOrParentTimestamptzComparisonExp {
  _eq?: Maybe<Scalars['timestamptz']>;
  _gt?: Maybe<Scalars['timestamptz']>;
  _gte?: Maybe<Scalars['timestamptz']>;
  _in?: Maybe<Array<Scalars['timestamptz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timestamptz']>;
  _lte?: Maybe<Scalars['timestamptz']>;
  _neq?: Maybe<Scalars['timestamptz']>;
  _nin?: Maybe<Array<Scalars['timestamptz']>>;
}


/** Boolean expression to compare columns of type "timetz". All fields are combined with logical 'AND'. */
export interface StudentOrParentTimetzComparisonExp {
  _eq?: Maybe<Scalars['timetz']>;
  _gt?: Maybe<Scalars['timetz']>;
  _gte?: Maybe<Scalars['timetz']>;
  _in?: Maybe<Array<Scalars['timetz']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['timetz']>;
  _lte?: Maybe<Scalars['timetz']>;
  _neq?: Maybe<Scalars['timetz']>;
  _nin?: Maybe<Array<Scalars['timetz']>>;
}

/** columns and relationships of "users" */
export interface StudentOrParentUsers {
  /** An object relationship */
  account?: EntireFieldWrapper<Maybe<StudentOrParentAuthAccounts>>;
  /** An object relationship */
  address?: EntireFieldWrapper<Maybe<StudentOrParentPrivateAdresses>>;
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  birthday?: EntireFieldWrapper<Maybe<StudentOrParentPrivateBirthdays>>;
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** A computed field, executes function "user_full_name" */
  full_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** An object relationship */
  insurance_number?: EntireFieldWrapper<Maybe<StudentOrParentPrivateInsuranceNumbers>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  phone_number?: EntireFieldWrapper<Maybe<StudentOrParentPrivatePhoneNumbers>>;
  /** An array relationship */
  relationships: EntireFieldWrapper<Array<StudentOrParentRelationships>>;
  /** An array relationship */
  relationshipsByUserId: EntireFieldWrapper<Array<StudentOrParentRelationships>>;
  /** An aggregate relationship */
  relationshipsByUserId_aggregate: EntireFieldWrapper<StudentOrParentRelationshipsAggregate>;
  /** An aggregate relationship */
  relationships_aggregate: EntireFieldWrapper<StudentOrParentRelationshipsAggregate>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "users" */
export interface StudentOrParentUsersRelationshipsArgs {
  distinct_on?: Maybe<Array<StudentOrParentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentRelationshipsOrderBy>>;
  where?: Maybe<StudentOrParentRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface StudentOrParentUsersRelationshipsByUserIdArgs {
  distinct_on?: Maybe<Array<StudentOrParentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentRelationshipsOrderBy>>;
  where?: Maybe<StudentOrParentRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface StudentOrParentUsersRelationshipsByUserIdAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentRelationshipsOrderBy>>;
  where?: Maybe<StudentOrParentRelationshipsBoolExp>;
}


/** columns and relationships of "users" */
export interface StudentOrParentUsersRelationshipsAggregateArgs {
  distinct_on?: Maybe<Array<StudentOrParentRelationshipsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentRelationshipsOrderBy>>;
  where?: Maybe<StudentOrParentRelationshipsBoolExp>;
}

/** aggregated selection of "users" */
export interface StudentOrParentUsersAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentUsersAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentUsers>>;
}

/** aggregate fields of "users" */
export interface StudentOrParentUsersAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentUsersMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentUsersMinFields>>;
}


/** aggregate fields of "users" */
export interface StudentOrParentUsersAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentUsersSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export interface StudentOrParentUsersBoolExp {
  _and?: Maybe<Array<StudentOrParentUsersBoolExp>>;
  _not?: Maybe<StudentOrParentUsersBoolExp>;
  _or?: Maybe<Array<StudentOrParentUsersBoolExp>>;
  account?: Maybe<StudentOrParentAuthAccountsBoolExp>;
  address?: Maybe<StudentOrParentPrivateAdressesBoolExp>;
  avatar_url?: Maybe<StudentOrParentStringComparisonExp>;
  birthday?: Maybe<StudentOrParentPrivateBirthdaysBoolExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  first_name?: Maybe<StudentOrParentStringComparisonExp>;
  full_name?: Maybe<StudentOrParentStringComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  insurance_number?: Maybe<StudentOrParentPrivateInsuranceNumbersBoolExp>;
  last_name?: Maybe<StudentOrParentStringComparisonExp>;
  phone_number?: Maybe<StudentOrParentPrivatePhoneNumbersBoolExp>;
  relationships?: Maybe<StudentOrParentRelationshipsBoolExp>;
  relationshipsByUserId?: Maybe<StudentOrParentRelationshipsBoolExp>;
  title?: Maybe<StudentOrParentStringComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** unique or primary key constraints on table "users" */
export const enum StudentOrParentUsersConstraint {
  /** unique or primary key constraint */
  USERS_PKEY = 'users_pkey'
};

/** input type for inserting data into table "users" */
export interface StudentOrParentUsersInsertInput {
  account?: Maybe<StudentOrParentAuthAccountsObjRelInsertInput>;
  address?: Maybe<StudentOrParentPrivateAdressesObjRelInsertInput>;
  avatar_url?: Maybe<Scalars['String']>;
  birthday?: Maybe<StudentOrParentPrivateBirthdaysObjRelInsertInput>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  insurance_number?: Maybe<StudentOrParentPrivateInsuranceNumbersObjRelInsertInput>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<StudentOrParentPrivatePhoneNumbersObjRelInsertInput>;
  relationships?: Maybe<StudentOrParentRelationshipsArrRelInsertInput>;
  relationshipsByUserId?: Maybe<StudentOrParentRelationshipsArrRelInsertInput>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** aggregate max on columns */
export interface StudentOrParentUsersMaxFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrParentUsersMinFields {
  avatar_url?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  first_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  last_name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  title?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** response of any mutation on the table "users" */
export interface StudentOrParentUsersMutationResponse {
  /** number of rows affected by the mutation */
  affected_rows: EntireFieldWrapper<Scalars['Int']>;
  /** data from the rows affected by the mutation */
  returning: EntireFieldWrapper<Array<StudentOrParentUsers>>;
}

/** input type for inserting object relation for remote table "users" */
export interface StudentOrParentUsersObjRelInsertInput {
  data: StudentOrParentUsersInsertInput;
  /** on conflict condition */
  on_conflict?: Maybe<StudentOrParentUsersOnConflict>;
}

/** on conflict condition type for table "users" */
export interface StudentOrParentUsersOnConflict {
  constraint: StudentOrParentUsersConstraint;
  update_columns?: Array<StudentOrParentUsersUpdateColumn>;
  where?: Maybe<StudentOrParentUsersBoolExp>;
}

/** Ordering options when selecting data from "users". */
export interface StudentOrParentUsersOrderBy {
  account?: Maybe<StudentOrParentAuthAccountsOrderBy>;
  address?: Maybe<StudentOrParentPrivateAdressesOrderBy>;
  avatar_url?: Maybe<StudentOrParentOrderBy>;
  birthday?: Maybe<StudentOrParentPrivateBirthdaysOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  first_name?: Maybe<StudentOrParentOrderBy>;
  full_name?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  insurance_number?: Maybe<StudentOrParentPrivateInsuranceNumbersOrderBy>;
  last_name?: Maybe<StudentOrParentOrderBy>;
  phone_number?: Maybe<StudentOrParentPrivatePhoneNumbersOrderBy>;
  relationshipsByUserId_aggregate?: Maybe<StudentOrParentRelationshipsAggregateOrderBy>;
  relationships_aggregate?: Maybe<StudentOrParentRelationshipsAggregateOrderBy>;
  title?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** primary key columns input for table: users */
export interface StudentOrParentUsersPkColumnsInput {
  id: Scalars['uuid'];
}

/** select columns of table "users" */
export const enum StudentOrParentUsersSelectColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};

/** input type for updating data in table "users" */
export interface StudentOrParentUsersSetInput {
  avatar_url?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  first_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
}

/** update columns of table "users" */
export const enum StudentOrParentUsersUpdateColumn {
  /** column name */
  AVATAR_URL = 'avatar_url',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  FIRST_NAME = 'first_name',
  /** column name */
  ID = 'id',
  /** column name */
  LAST_NAME = 'last_name',
  /** column name */
  TITLE = 'title',
  /** column name */
  UPDATED_AT = 'updated_at'
};


/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export interface StudentOrParentUuidComparisonExp {
  _eq?: Maybe<Scalars['uuid']>;
  _gt?: Maybe<Scalars['uuid']>;
  _gte?: Maybe<Scalars['uuid']>;
  _in?: Maybe<Array<Scalars['uuid']>>;
  _is_null?: Maybe<Scalars['Boolean']>;
  _lt?: Maybe<Scalars['uuid']>;
  _lte?: Maybe<Scalars['uuid']>;
  _neq?: Maybe<Scalars['uuid']>;
  _nin?: Maybe<Array<Scalars['uuid']>>;
}

/** columns and relationships of "view.assignment_class" */
export interface StudentOrParentViewAssignmentClass {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentOrParentAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<StudentOrParentClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.assignment_class" */
export interface StudentOrParentViewAssignmentClassAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentViewAssignmentClassMaxOrderBy>;
  min?: Maybe<StudentOrParentViewAssignmentClassMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.assignment_class". All fields are combined with a logical 'AND'. */
export interface StudentOrParentViewAssignmentClassBoolExp {
  _and?: Maybe<Array<StudentOrParentViewAssignmentClassBoolExp>>;
  _not?: Maybe<StudentOrParentViewAssignmentClassBoolExp>;
  _or?: Maybe<Array<StudentOrParentViewAssignmentClassBoolExp>>;
  assignment?: Maybe<StudentOrParentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrParentUuidComparisonExp>;
  class?: Maybe<StudentOrParentClassesBoolExp>;
  class_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** order by max() on columns of table "view.assignment_class" */
export interface StudentOrParentViewAssignmentClassMaxOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  class_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "view.assignment_class" */
export interface StudentOrParentViewAssignmentClassMinOrderBy {
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  class_id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "view.assignment_class". */
export interface StudentOrParentViewAssignmentClassOrderBy {
  assignment?: Maybe<StudentOrParentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  class?: Maybe<StudentOrParentClassesOrderBy>;
  class_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "view.assignment_class" */
export const enum StudentOrParentViewAssignmentClassSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  CLASS_ID = 'class_id'
};

/** columns and relationships of "view.assignment_student_grade" */
export interface StudentOrParentViewAssignmentStudentGrade {
  /** An object relationship */
  assignment?: EntireFieldWrapper<Maybe<StudentOrParentAssignments>>;
  assignment_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  grade?: EntireFieldWrapper<Maybe<StudentOrParentGrades>>;
  grade_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentOrParentStudents>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.assignment_student_grade". All fields are combined with a logical 'AND'. */
export interface StudentOrParentViewAssignmentStudentGradeBoolExp {
  _and?: Maybe<Array<StudentOrParentViewAssignmentStudentGradeBoolExp>>;
  _not?: Maybe<StudentOrParentViewAssignmentStudentGradeBoolExp>;
  _or?: Maybe<Array<StudentOrParentViewAssignmentStudentGradeBoolExp>>;
  assignment?: Maybe<StudentOrParentAssignmentsBoolExp>;
  assignment_id?: Maybe<StudentOrParentUuidComparisonExp>;
  grade?: Maybe<StudentOrParentGradesBoolExp>;
  grade_id?: Maybe<StudentOrParentUuidComparisonExp>;
  student?: Maybe<StudentOrParentStudentsBoolExp>;
  student_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.assignment_student_grade". */
export interface StudentOrParentViewAssignmentStudentGradeOrderBy {
  assignment?: Maybe<StudentOrParentAssignmentsOrderBy>;
  assignment_id?: Maybe<StudentOrParentOrderBy>;
  grade?: Maybe<StudentOrParentGradesOrderBy>;
  grade_id?: Maybe<StudentOrParentOrderBy>;
  student?: Maybe<StudentOrParentStudentsOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "view.assignment_student_grade" */
export const enum StudentOrParentViewAssignmentStudentGradeSelectColumn {
  /** column name */
  ASSIGNMENT_ID = 'assignment_id',
  /** column name */
  GRADE_ID = 'grade_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.class_student" */
export interface StudentOrParentViewClassStudent {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<StudentOrParentClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  student?: EntireFieldWrapper<Maybe<StudentOrParentStudents>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.class_student". All fields are combined with a logical 'AND'. */
export interface StudentOrParentViewClassStudentBoolExp {
  _and?: Maybe<Array<StudentOrParentViewClassStudentBoolExp>>;
  _not?: Maybe<StudentOrParentViewClassStudentBoolExp>;
  _or?: Maybe<Array<StudentOrParentViewClassStudentBoolExp>>;
  class?: Maybe<StudentOrParentClassesBoolExp>;
  class_id?: Maybe<StudentOrParentUuidComparisonExp>;
  student?: Maybe<StudentOrParentStudentsBoolExp>;
  student_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.class_student". */
export interface StudentOrParentViewClassStudentOrderBy {
  class?: Maybe<StudentOrParentClassesOrderBy>;
  class_id?: Maybe<StudentOrParentOrderBy>;
  student?: Maybe<StudentOrParentStudentsOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "view.class_student" */
export const enum StudentOrParentViewClassStudentSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  STUDENT_ID = 'student_id'
};

/** columns and relationships of "view.grade_type_subject" */
export interface StudentOrParentViewGradeTypeSubject {
  /** An object relationship */
  grade_type?: EntireFieldWrapper<Maybe<StudentOrParentGradeTypes>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An array relationship */
  grade_types: EntireFieldWrapper<Array<StudentOrParentGradeTypes>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}


/** columns and relationships of "view.grade_type_subject" */
export interface StudentOrParentViewGradeTypeSubjectGradeTypesArgs {
  distinct_on?: Maybe<Array<StudentOrParentGradeTypesSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentGradeTypesOrderBy>>;
  where?: Maybe<StudentOrParentGradeTypesBoolExp>;
}

/** order by aggregate values of table "view.grade_type_subject" */
export interface StudentOrParentViewGradeTypeSubjectAggregateOrderBy {
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentViewGradeTypeSubjectMaxOrderBy>;
  min?: Maybe<StudentOrParentViewGradeTypeSubjectMinOrderBy>;
}

/** Boolean expression to filter rows from the table "view.grade_type_subject". All fields are combined with a logical 'AND'. */
export interface StudentOrParentViewGradeTypeSubjectBoolExp {
  _and?: Maybe<Array<StudentOrParentViewGradeTypeSubjectBoolExp>>;
  _not?: Maybe<StudentOrParentViewGradeTypeSubjectBoolExp>;
  _or?: Maybe<Array<StudentOrParentViewGradeTypeSubjectBoolExp>>;
  grade_type?: Maybe<StudentOrParentGradeTypesBoolExp>;
  grade_type_id?: Maybe<StudentOrParentUuidComparisonExp>;
  grade_types?: Maybe<StudentOrParentGradeTypesBoolExp>;
  subject_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** order by max() on columns of table "view.grade_type_subject" */
export interface StudentOrParentViewGradeTypeSubjectMaxOrderBy {
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "view.grade_type_subject" */
export interface StudentOrParentViewGradeTypeSubjectMinOrderBy {
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "view.grade_type_subject". */
export interface StudentOrParentViewGradeTypeSubjectOrderBy {
  grade_type?: Maybe<StudentOrParentGradeTypesOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  grade_types_aggregate?: Maybe<StudentOrParentGradeTypesAggregateOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "view.grade_type_subject" */
export const enum StudentOrParentViewGradeTypeSubjectSelectColumn {
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.grades" */
export interface StudentOrParentViewGrades {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  semester?: EntireFieldWrapper<Maybe<StudentOrParentSemesters>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** aggregated selection of "view.grades" */
export interface StudentOrParentViewGradesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentViewGrades>>;
}

/** aggregate fields of "view.grades" */
export interface StudentOrParentViewGradesAggregateFields {
  avg?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesAvgFields>>;
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesMinFields>>;
  stddev?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesStddevFields>>;
  stddev_pop?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesStddevPopFields>>;
  stddev_samp?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesStddevSampFields>>;
  sum?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesSumFields>>;
  var_pop?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesVarPopFields>>;
  var_samp?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesVarSampFields>>;
  variance?: EntireFieldWrapper<Maybe<StudentOrParentViewGradesVarianceFields>>;
}


/** aggregate fields of "view.grades" */
export interface StudentOrParentViewGradesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentViewGradesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** order by aggregate values of table "view.grades" */
export interface StudentOrParentViewGradesAggregateOrderBy {
  avg?: Maybe<StudentOrParentViewGradesAvgOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentViewGradesMaxOrderBy>;
  min?: Maybe<StudentOrParentViewGradesMinOrderBy>;
  stddev?: Maybe<StudentOrParentViewGradesStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrParentViewGradesStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrParentViewGradesStddevSampOrderBy>;
  sum?: Maybe<StudentOrParentViewGradesSumOrderBy>;
  var_pop?: Maybe<StudentOrParentViewGradesVarPopOrderBy>;
  var_samp?: Maybe<StudentOrParentViewGradesVarSampOrderBy>;
  variance?: Maybe<StudentOrParentViewGradesVarianceOrderBy>;
}

/** aggregate avg on columns */
export interface StudentOrParentViewGradesAvgFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by avg() on columns of table "view.grades" */
export interface StudentOrParentViewGradesAvgOrderBy {
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** Boolean expression to filter rows from the table "view.grades". All fields are combined with a logical 'AND'. */
export interface StudentOrParentViewGradesBoolExp {
  _and?: Maybe<Array<StudentOrParentViewGradesBoolExp>>;
  _not?: Maybe<StudentOrParentViewGradesBoolExp>;
  _or?: Maybe<Array<StudentOrParentViewGradesBoolExp>>;
  created_at?: Maybe<StudentOrParentTimetzComparisonExp>;
  created_date?: Maybe<StudentOrParentDateComparisonExp>;
  grade_type?: Maybe<StudentOrParentStringComparisonExp>;
  grade_type_id?: Maybe<StudentOrParentUuidComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  semester?: Maybe<StudentOrParentSemestersBoolExp>;
  semester_id?: Maybe<StudentOrParentUuidComparisonExp>;
  student_id?: Maybe<StudentOrParentUuidComparisonExp>;
  subject_id?: Maybe<StudentOrParentUuidComparisonExp>;
  value?: Maybe<StudentOrParentIntComparisonExp>;
  weight?: Maybe<StudentOrParentIntComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrParentViewGradesMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by max() on columns of table "view.grades" */
export interface StudentOrParentViewGradesMaxOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  created_date?: Maybe<StudentOrParentOrderBy>;
  grade_type?: Maybe<StudentOrParentOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  semester_id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate min on columns */
export interface StudentOrParentViewGradesMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timetz']>>;
  created_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  grade_type?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  grade_type_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  student_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by min() on columns of table "view.grades" */
export interface StudentOrParentViewGradesMinOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  created_date?: Maybe<StudentOrParentOrderBy>;
  grade_type?: Maybe<StudentOrParentOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  semester_id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "view.grades". */
export interface StudentOrParentViewGradesOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  created_date?: Maybe<StudentOrParentOrderBy>;
  grade_type?: Maybe<StudentOrParentOrderBy>;
  grade_type_id?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  semester?: Maybe<StudentOrParentSemestersOrderBy>;
  semester_id?: Maybe<StudentOrParentOrderBy>;
  student_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "view.grades" */
export const enum StudentOrParentViewGradesSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  CREATED_DATE = 'created_date',
  /** column name */
  GRADE_TYPE = 'grade_type',
  /** column name */
  GRADE_TYPE_ID = 'grade_type_id',
  /** column name */
  ID = 'id',
  /** column name */
  NAME = 'name',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  STUDENT_ID = 'student_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  VALUE = 'value',
  /** column name */
  WEIGHT = 'weight'
};

/** aggregate stddev on columns */
export interface StudentOrParentViewGradesStddevFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev() on columns of table "view.grades" */
export interface StudentOrParentViewGradesStddevOrderBy {
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate stddev_pop on columns */
export interface StudentOrParentViewGradesStddevPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_pop() on columns of table "view.grades" */
export interface StudentOrParentViewGradesStddevPopOrderBy {
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate stddev_samp on columns */
export interface StudentOrParentViewGradesStddevSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by stddev_samp() on columns of table "view.grades" */
export interface StudentOrParentViewGradesStddevSampOrderBy {
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate sum on columns */
export interface StudentOrParentViewGradesSumFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
}

/** order by sum() on columns of table "view.grades" */
export interface StudentOrParentViewGradesSumOrderBy {
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate var_pop on columns */
export interface StudentOrParentViewGradesVarPopFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_pop() on columns of table "view.grades" */
export interface StudentOrParentViewGradesVarPopOrderBy {
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate var_samp on columns */
export interface StudentOrParentViewGradesVarSampFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by var_samp() on columns of table "view.grades" */
export interface StudentOrParentViewGradesVarSampOrderBy {
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** aggregate variance on columns */
export interface StudentOrParentViewGradesVarianceFields {
  value?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
  weight?: EntireFieldWrapper<Maybe<Scalars['Float']>>;
}

/** order by variance() on columns of table "view.grades" */
export interface StudentOrParentViewGradesVarianceOrderBy {
  value?: Maybe<StudentOrParentOrderBy>;
  weight?: Maybe<StudentOrParentOrderBy>;
}

/** columns and relationships of "view.latest_chat_messages" */
export interface StudentOrParentViewLatestChatMessages {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** An object relationship */
  chat?: EntireFieldWrapper<Maybe<StudentOrParentChats>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user?: EntireFieldWrapper<Maybe<StudentOrParentUsers>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregated selection of "view.latest_chat_messages" */
export interface StudentOrParentViewLatestChatMessagesAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentViewLatestChatMessagesAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentViewLatestChatMessages>>;
}

/** aggregate fields of "view.latest_chat_messages" */
export interface StudentOrParentViewLatestChatMessagesAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentViewLatestChatMessagesMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentViewLatestChatMessagesMinFields>>;
}


/** aggregate fields of "view.latest_chat_messages" */
export interface StudentOrParentViewLatestChatMessagesAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentViewLatestChatMessagesSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "view.latest_chat_messages". All fields are combined with a logical 'AND'. */
export interface StudentOrParentViewLatestChatMessagesBoolExp {
  _and?: Maybe<Array<StudentOrParentViewLatestChatMessagesBoolExp>>;
  _not?: Maybe<StudentOrParentViewLatestChatMessagesBoolExp>;
  _or?: Maybe<Array<StudentOrParentViewLatestChatMessagesBoolExp>>;
  body?: Maybe<StudentOrParentStringComparisonExp>;
  chat?: Maybe<StudentOrParentChatsBoolExp>;
  chat_id?: Maybe<StudentOrParentUuidComparisonExp>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  user_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrParentViewLatestChatMessagesMaxFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** aggregate min on columns */
export interface StudentOrParentViewLatestChatMessagesMinFields {
  body?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  chat_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  user_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Ordering options when selecting data from "view.latest_chat_messages". */
export interface StudentOrParentViewLatestChatMessagesOrderBy {
  body?: Maybe<StudentOrParentOrderBy>;
  chat?: Maybe<StudentOrParentChatsOrderBy>;
  chat_id?: Maybe<StudentOrParentOrderBy>;
  created_at?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  user_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "view.latest_chat_messages" */
export const enum StudentOrParentViewLatestChatMessagesSelectColumn {
  /** column name */
  BODY = 'body',
  /** column name */
  CHAT_ID = 'chat_id',
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  ID = 'id',
  /** column name */
  USER_ID = 'user_id'
};

/** columns and relationships of "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMark {
  avg?: EntireFieldWrapper<Maybe<Scalars['numeric']>>;
  count?: EntireFieldWrapper<Maybe<Scalars['bigint']>>;
  max?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  min?: EntireFieldWrapper<Maybe<Scalars['Int']>>;
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** order by aggregate values of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkAggregateOrderBy {
  avg?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkAvgOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkMaxOrderBy>;
  min?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkMinOrderBy>;
  stddev?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkStddevOrderBy>;
  stddev_pop?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkStddevPopOrderBy>;
  stddev_samp?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkStddevSampOrderBy>;
  sum?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkSumOrderBy>;
  var_pop?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkVarPopOrderBy>;
  var_samp?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkVarSampOrderBy>;
  variance?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkVarianceOrderBy>;
}

/** order by avg() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkAvgOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
}

/** Boolean expression to filter rows from the table "view.statistics_semester_subject_mark". All fields are combined with a logical 'AND'. */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkBoolExp {
  _and?: Maybe<Array<StudentOrParentViewStatisticsSemesterSubjectMarkBoolExp>>;
  _not?: Maybe<StudentOrParentViewStatisticsSemesterSubjectMarkBoolExp>;
  _or?: Maybe<Array<StudentOrParentViewStatisticsSemesterSubjectMarkBoolExp>>;
  avg?: Maybe<StudentOrParentNumericComparisonExp>;
  count?: Maybe<StudentOrParentBigintComparisonExp>;
  max?: Maybe<StudentOrParentIntComparisonExp>;
  min?: Maybe<StudentOrParentIntComparisonExp>;
  semester_id?: Maybe<StudentOrParentUuidComparisonExp>;
  subject_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** order by max() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkMaxOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
  semester_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
}

/** order by min() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkMinOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
  semester_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
}

/** Ordering options when selecting data from "view.statistics_semester_subject_mark". */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
  semester_id?: Maybe<StudentOrParentOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "view.statistics_semester_subject_mark" */
export const enum StudentOrParentViewStatisticsSemesterSubjectMarkSelectColumn {
  /** column name */
  AVG = 'avg',
  /** column name */
  COUNT = 'count',
  /** column name */
  MAX = 'max',
  /** column name */
  MIN = 'min',
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** order by stddev() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkStddevOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkStddevPopOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
}

/** order by stddev_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkStddevSampOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
}

/** order by sum() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkSumOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_pop() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkVarPopOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
}

/** order by var_samp() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkVarSampOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
}

/** order by variance() on columns of table "view.statistics_semester_subject_mark" */
export interface StudentOrParentViewStatisticsSemesterSubjectMarkVarianceOrderBy {
  avg?: Maybe<StudentOrParentOrderBy>;
  count?: Maybe<StudentOrParentOrderBy>;
  max?: Maybe<StudentOrParentOrderBy>;
  min?: Maybe<StudentOrParentOrderBy>;
}

/** columns and relationships of "view.subject_semester" */
export interface StudentOrParentViewSubjectSemester {
  semester_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentOrParentSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.subject_semester". All fields are combined with a logical 'AND'. */
export interface StudentOrParentViewSubjectSemesterBoolExp {
  _and?: Maybe<Array<StudentOrParentViewSubjectSemesterBoolExp>>;
  _not?: Maybe<StudentOrParentViewSubjectSemesterBoolExp>;
  _or?: Maybe<Array<StudentOrParentViewSubjectSemesterBoolExp>>;
  semester_id?: Maybe<StudentOrParentUuidComparisonExp>;
  subject?: Maybe<StudentOrParentSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.subject_semester". */
export interface StudentOrParentViewSubjectSemesterOrderBy {
  semester_id?: Maybe<StudentOrParentOrderBy>;
  subject?: Maybe<StudentOrParentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "view.subject_semester" */
export const enum StudentOrParentViewSubjectSemesterSelectColumn {
  /** column name */
  SEMESTER_ID = 'semester_id',
  /** column name */
  SUBJECT_ID = 'subject_id'
};

/** columns and relationships of "view.teacher_class_subject" */
export interface StudentOrParentViewTeacherClassSubject {
  /** An object relationship */
  class?: EntireFieldWrapper<Maybe<StudentOrParentClasses>>;
  class_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  /** An object relationship */
  subject?: EntireFieldWrapper<Maybe<StudentOrParentSubjects>>;
  subject_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  teacher_id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
}

/** Boolean expression to filter rows from the table "view.teacher_class_subject". All fields are combined with a logical 'AND'. */
export interface StudentOrParentViewTeacherClassSubjectBoolExp {
  _and?: Maybe<Array<StudentOrParentViewTeacherClassSubjectBoolExp>>;
  _not?: Maybe<StudentOrParentViewTeacherClassSubjectBoolExp>;
  _or?: Maybe<Array<StudentOrParentViewTeacherClassSubjectBoolExp>>;
  class?: Maybe<StudentOrParentClassesBoolExp>;
  class_id?: Maybe<StudentOrParentUuidComparisonExp>;
  subject?: Maybe<StudentOrParentSubjectsBoolExp>;
  subject_id?: Maybe<StudentOrParentUuidComparisonExp>;
  teacher_id?: Maybe<StudentOrParentUuidComparisonExp>;
}

/** Ordering options when selecting data from "view.teacher_class_subject". */
export interface StudentOrParentViewTeacherClassSubjectOrderBy {
  class?: Maybe<StudentOrParentClassesOrderBy>;
  class_id?: Maybe<StudentOrParentOrderBy>;
  subject?: Maybe<StudentOrParentSubjectsOrderBy>;
  subject_id?: Maybe<StudentOrParentOrderBy>;
  teacher_id?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "view.teacher_class_subject" */
export const enum StudentOrParentViewTeacherClassSubjectSelectColumn {
  /** column name */
  CLASS_ID = 'class_id',
  /** column name */
  SUBJECT_ID = 'subject_id',
  /** column name */
  TEACHER_ID = 'teacher_id'
};

/** columns and relationships of "years" */
export interface StudentOrParentYears {
  created_at: EntireFieldWrapper<Scalars['timestamptz']>;
  end_date: EntireFieldWrapper<Scalars['date']>;
  id: EntireFieldWrapper<Scalars['uuid']>;
  /** A computed field, executes function "year_name" */
  name?: EntireFieldWrapper<Maybe<Scalars['String']>>;
  /** fetch data from the table: "promotions" */
  promotions: EntireFieldWrapper<Array<StudentOrParentPromotions>>;
  start_date: EntireFieldWrapper<Scalars['date']>;
  updated_at: EntireFieldWrapper<Scalars['timestamptz']>;
}


/** columns and relationships of "years" */
export interface StudentOrParentYearsPromotionsArgs {
  distinct_on?: Maybe<Array<StudentOrParentPromotionsSelectColumn>>;
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  order_by?: Maybe<Array<StudentOrParentPromotionsOrderBy>>;
  where?: Maybe<StudentOrParentPromotionsBoolExp>;
}

/** aggregated selection of "years" */
export interface StudentOrParentYearsAggregate {
  aggregate?: EntireFieldWrapper<Maybe<StudentOrParentYearsAggregateFields>>;
  nodes: EntireFieldWrapper<Array<StudentOrParentYears>>;
}

/** aggregate fields of "years" */
export interface StudentOrParentYearsAggregateFields {
  count: EntireFieldWrapper<Scalars['Int']>;
  max?: EntireFieldWrapper<Maybe<StudentOrParentYearsMaxFields>>;
  min?: EntireFieldWrapper<Maybe<StudentOrParentYearsMinFields>>;
}


/** aggregate fields of "years" */
export interface StudentOrParentYearsAggregateFieldsCountArgs {
  columns?: Maybe<Array<StudentOrParentYearsSelectColumn>>;
  distinct?: Maybe<Scalars['Boolean']>;
}

/** Boolean expression to filter rows from the table "years". All fields are combined with a logical 'AND'. */
export interface StudentOrParentYearsBoolExp {
  _and?: Maybe<Array<StudentOrParentYearsBoolExp>>;
  _not?: Maybe<StudentOrParentYearsBoolExp>;
  _or?: Maybe<Array<StudentOrParentYearsBoolExp>>;
  created_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
  end_date?: Maybe<StudentOrParentDateComparisonExp>;
  id?: Maybe<StudentOrParentUuidComparisonExp>;
  name?: Maybe<StudentOrParentStringComparisonExp>;
  promotions?: Maybe<StudentOrParentPromotionsBoolExp>;
  start_date?: Maybe<StudentOrParentDateComparisonExp>;
  updated_at?: Maybe<StudentOrParentTimestamptzComparisonExp>;
}

/** aggregate max on columns */
export interface StudentOrParentYearsMaxFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** aggregate min on columns */
export interface StudentOrParentYearsMinFields {
  created_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
  end_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  id?: EntireFieldWrapper<Maybe<Scalars['uuid']>>;
  start_date?: EntireFieldWrapper<Maybe<Scalars['date']>>;
  updated_at?: EntireFieldWrapper<Maybe<Scalars['timestamptz']>>;
}

/** Ordering options when selecting data from "years". */
export interface StudentOrParentYearsOrderBy {
  created_at?: Maybe<StudentOrParentOrderBy>;
  end_date?: Maybe<StudentOrParentOrderBy>;
  id?: Maybe<StudentOrParentOrderBy>;
  name?: Maybe<StudentOrParentOrderBy>;
  promotions_aggregate?: Maybe<StudentOrParentPromotionsAggregateOrderBy>;
  start_date?: Maybe<StudentOrParentOrderBy>;
  updated_at?: Maybe<StudentOrParentOrderBy>;
}

/** select columns of table "years" */
export const enum StudentOrParentYearsSelectColumn {
  /** column name */
  CREATED_AT = 'created_at',
  /** column name */
  END_DATE = 'end_date',
  /** column name */
  ID = 'id',
  /** column name */
  START_DATE = 'start_date',
  /** column name */
  UPDATED_AT = 'updated_at'
};

export type StudentOrParentAdressFragment = { street?: Maybe<string>, area?: Maybe<string>, city?: Maybe<string>, postal_code?: Maybe<string>, country?: Maybe<string>, created_at: string, updated_at: string };

export type StudentOrParentAssignmentFragment = { id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> };

export type StudentOrParentAggregateAssignmentFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentOrParentAssignmentClassFragment = { class?: Maybe<{ name?: Maybe<string>, id: string }> };

export type StudentOrParentAssignmentGradeFragment = { id: string, student: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> }, mark?: Maybe<{ id: string, value: number }> };

export type StudentOrParentAssignmentStudentFragment = { user?: Maybe<{ id: string, full_name?: Maybe<string> }>, assignment: { id: string } };

export type StudentOrParentAssignmentStudentGradeFragment = { student?: Maybe<{ id: string, user?: Maybe<{ full_name?: Maybe<string> }> }>, grade?: Maybe<{ id: string, mark?: Maybe<{ id: string, value: number }> }> };

export type StudentOrParentAssignmentTotalCountFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentOrParentAssignmentTypeFragment = { name: string, icon?: Maybe<string> };

export type StudentOrParentBookFragment = { id: string, title: string, book_chapters: Array<{ id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> }> };

export type StudentOrParentChapterFragment = { id: string, title: string, duration_left?: Maybe<any>, due_at: any, type: { name: string, description?: Maybe<string> }, sections: Array<{ id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> }> };

export type StudentOrParentChatFragment = { id: string, title?: Maybe<string>, avatar_url?: Maybe<string>, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type StudentOrParentChatMessageFragment = { id: string, body: string, user_id: string, chat_id: string, created_at: string };

export type StudentOrParentKClassFragment = { name?: Maybe<string>, id: string };

export type StudentOrParentClassStudentFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type StudentOrParentChatTypeFragment = { name: string, description: string };

export type StudentOrParentFileFragment = { id: string, file_name: string, foreign_id: string, path: string };

export type StudentOrParentGradeFragment = { id: string, weight: number, comment?: Maybe<string>, mark?: Maybe<{ id: string, name: string, value: number }>, assignment: { title: string, type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { id: string, name: string } } }> } };

export type StudentOrParentLessonFragment = { id: string, start_at?: Maybe<any>, start_date?: Maybe<any>, description?: Maybe<string>, course: { id: string, subject: { id: string, name: string }, course_teachers: Array<{ teacher: { id: string, user?: Maybe<{ full_name?: Maybe<string> }> } }> } };

export type StudentOrParentMarkFragment = { name: string, value: number };

export type StudentOrParentMessageFragment = { id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, replys?: Maybe<Array<{ id: string, body: string, user_id: string, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>>, likes: Array<{ id: string, chat_message_id: string, chat_like_user?: Maybe<{ id: string, first_name?: Maybe<string>, full_name?: Maybe<string> }> }>, responding?: Maybe<{ id: string, body: string, user_id: string, chat_id: string, is_pinned: boolean, created_at: string, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>, user?: Maybe<{ first_name?: Maybe<string>, last_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type StudentOrParentMessageAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentOrParentNoteFragment = { id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> };

export type StudentOrParentPhoneNumberFragment = { country_code: string, number: string, created_at: string, updated_at: string };

export type StudentOrParentPrivateChatFragment = { id: string, unread_messages?: Maybe<any>, participants: Array<{ user?: Maybe<{ id: string, full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }> };

export type StudentOrParentSectionFragment = { id: string, title: string, body?: Maybe<string>, duration_left?: Maybe<number>, is_completed?: Maybe<boolean>, duration_total: number, type: { name: string, icon?: Maybe<string> }, notes: Maybe<Array<{ id: string, body: string, created_at: string, user?: Maybe<{ full_name?: Maybe<string>, avatar_url?: Maybe<string> }> }>> };

export type StudentOrParentSectionTypeFragment = { name: string, icon?: Maybe<string> };

export type StudentOrParentSemesterFragment = { id: string, start_at: any, end_at: any };

export type StudentOrParentStudentFragment = { id: string, user?: Maybe<{ avatar_url?: Maybe<string>, full_name?: Maybe<string> }> };

export type StudentOrParentSubjectFragment = { id: string, name: string, icon?: Maybe<string> };

export type StudentOrParentTaskFragment = { id: string, body?: Maybe<string>, title?: Maybe<string>, is_completed: boolean };

export type StudentOrParentTasksAggregateFragment = { aggregate?: Maybe<{ count: number }> };

export type StudentOrParentTeacherFragment = { id: string, user?: Maybe<{ full_name?: Maybe<string> }> };

export type StudentOrParentUserFragment = { id?: Maybe<string>, last_name?: Maybe<string>, first_name: string, email: string, birthday_at?: Maybe<string>, avatar_url?: Maybe<string>, mobile?: Maybe<string>, street_address?: Maybe<string>, title?: Maybe<string>, role?: Maybe<string>, is_verified?: Maybe<boolean>, assignments?: Maybe<boolean>, live_class?: Maybe<boolean>, grading?: Maybe<boolean>, chat?: Maybe<boolean> };

export type StudentOrParentYearFragment = { id: string, name?: Maybe<string>, start_date: any, end_date: any };

export type StudentOrParentActivityLatestQueryVariables = Exact<{
  limit?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
}>;


export type StudentOrParentActivityLatestQuery = { assignmentsTotalCount: { aggregate?: Maybe<{ count: number }> }, assignments: Array<{ id: string, title: string, description?: Maybe<string>, duration: number, due_at: string, due_at_filter?: Maybe<string>, created_at: string, is_gradeable: boolean, is_completed?: Maybe<boolean>, assignment_users: Array<{ user_id: string, id: string }>, chat?: Maybe<{ title?: Maybe<string>, id: string }>, teaching_structure?: Maybe<{ subject_icon?: Maybe<string>, id: string, ltr: number, rtl: number }>, assignment_type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { name: string } } }>, user?: Maybe<{ full_name?: Maybe<string> }>, grade_weight?: Maybe<{ id: string, value: any, comment?: Maybe<string> }>, files: Array<{ id: string, file_name: string, foreign_id: string, path: string }> }>, grades_aggregate: { aggregate?: Maybe<{ count: number }> }, grades: Array<{ id: string, weight: number, comment?: Maybe<string>, mark?: Maybe<{ id: string, name: string, value: number }>, assignment: { title: string, type: { name: string, icon?: Maybe<string> }, lesson?: Maybe<{ course: { subject: { id: string, name: string } } }> } }> };

export type StudentOrParentGradesBySemesterQueryVariables = Exact<{
  semester_id: Scalars['uuid'];
}>;


export type StudentOrParentGradesBySemesterQuery = { subjects: Array<{ id: string, name: string, icon?: Maybe<string>, statistics: Array<{ max?: Maybe<number>, min?: Maybe<number>, avg?: Maybe<any> }>, grades: { aggregate?: Maybe<{ max?: Maybe<{ value?: Maybe<number> }> }> }, parent_types: Array<{ parent_type?: Maybe<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> }, child_types: Array<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> } }> }> }> }> };

export type StudentOrParentGradesCurrentSemesterQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentOrParentGradesCurrentSemesterQuery = { subjects: Array<{ id: string, name: string, icon?: Maybe<string>, aggregation: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> } }> };

export type StudentOrParentExpandedSemesterGradeFragment = { id: string, name: string, icon?: Maybe<string>, statistics: Array<{ max?: Maybe<number>, min?: Maybe<number>, avg?: Maybe<any> }>, grades: { aggregate?: Maybe<{ max?: Maybe<{ value?: Maybe<number> }> }> }, parent_types: Array<{ parent_type?: Maybe<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> }, child_types: Array<{ id: string, name: string, grades: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> } }> }> }> };

export type StudentOrParentSemesterGradeFragment = { id: string, name: string, icon?: Maybe<string>, aggregation: { aggregate?: Maybe<{ avg?: Maybe<{ value?: Maybe<number> }> }> } };

export const StudentOrParentAdressFragmentDoc = gql`
    fragment Adress on private_adresses {
  street
  area
  city
  postal_code
  country
  created_at
  updated_at
}
    `;
export const StudentOrParentAssignmentTypeFragmentDoc = gql`
    fragment AssignmentType on assignment_type {
  name
  icon
}
    `;
export const StudentOrParentFileFragmentDoc = gql`
    fragment File on files {
  id
  file_name
  foreign_id
  path
}
    `;
export const StudentOrParentAssignmentFragmentDoc = gql`
    fragment Assignment on assignments {
  id
  title
  description
  duration
  due_at
  due_at_filter
  created_at
  assignment_users {
    user_id
    id
  }
  chat {
    title
    id
  }
  teaching_structure {
    subject_icon
    subject_icon
    id
    ltr
    rtl
  }
  assignment_type {
    ...AssignmentType
  }
  lesson {
    course {
      subject {
        name
      }
    }
  }
  is_gradeable
  is_completed
  lesson {
    course {
      subject {
        name
      }
    }
  }
  user {
    full_name
  }
  grade_weight: assignment_grade_weight {
    id
    value
    comment
  }
  files {
    ...File
  }
}
    ${StudentOrParentAssignmentTypeFragmentDoc}
${StudentOrParentFileFragmentDoc}`;
export const StudentOrParentAggregateAssignmentFragmentDoc = gql`
    fragment AggregateAssignment on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentOrParentKClassFragmentDoc = gql`
    fragment KClass on classes {
  name
  id
}
    `;
export const StudentOrParentAssignmentClassFragmentDoc = gql`
    fragment AssignmentClass on view_assignment_class {
  class {
    ...KClass
  }
}
    ${StudentOrParentKClassFragmentDoc}`;
export const StudentOrParentAssignmentGradeFragmentDoc = gql`
    fragment AssignmentGrade on grades {
  id
  student {
    id
    user {
      full_name
    }
  }
  mark {
    id
    value
  }
}
    `;
export const StudentOrParentAssignmentStudentFragmentDoc = gql`
    fragment AssignmentStudent on assignment_user {
  user {
    id
    full_name
  }
  assignment {
    id
  }
}
    `;
export const StudentOrParentAssignmentStudentGradeFragmentDoc = gql`
    fragment AssignmentStudentGrade on view_assignment_student_grade {
  student {
    id
    user {
      full_name
    }
  }
  grade {
    id
    mark {
      id
      value
    }
  }
}
    `;
export const StudentOrParentAssignmentTotalCountFragmentDoc = gql`
    fragment AssignmentTotalCount on assignments_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentOrParentSectionTypeFragmentDoc = gql`
    fragment SectionType on chapter_section_type {
  name
  icon
}
    `;
export const StudentOrParentNoteFragmentDoc = gql`
    fragment Note on chapter_section_notes {
  id
  body
  created_at
  user {
    full_name
    avatar_url
  }
}
    `;
export const StudentOrParentSectionFragmentDoc = gql`
    fragment Section on chapter_sections {
  id
  title
  body @include(if: $with_body)
  duration_left
  duration_total: duration
  is_completed
  type: chapter_section_type {
    ...SectionType
  }
  notes: chapter_section_notes @include(if: $with_notes) {
    ...Note
  }
}
    ${StudentOrParentSectionTypeFragmentDoc}
${StudentOrParentNoteFragmentDoc}`;
export const StudentOrParentChapterFragmentDoc = gql`
    fragment Chapter on book_chapters {
  id
  title
  duration_left
  due_at
  type: book_chapter_type {
    name
    description
  }
  sections: chapter_sections(order_by: {sort: asc}) {
    ...Section
  }
}
    ${StudentOrParentSectionFragmentDoc}`;
export const StudentOrParentBookFragmentDoc = gql`
    fragment Book on books {
  id
  title
  book_chapters {
    ...Chapter
  }
}
    ${StudentOrParentChapterFragmentDoc}`;
export const StudentOrParentChatFragmentDoc = gql`
    fragment Chat on chats {
  id
  title
  avatar_url
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const StudentOrParentChatMessageFragmentDoc = gql`
    fragment ChatMessage on chat_messages {
  id
  body
  user_id
  chat_id
  created_at
}
    `;
export const StudentOrParentClassStudentFragmentDoc = gql`
    fragment ClassStudent on students {
  id
  user {
    full_name
  }
}
    `;
export const StudentOrParentChatTypeFragmentDoc = gql`
    fragment ChatType on chat_type {
  name
  description
}
    `;
export const StudentOrParentGradeFragmentDoc = gql`
    fragment Grade on grades {
  id
  weight
  comment
  mark {
    id
    name
    value
  }
  assignment {
    title
    type: assignment_type {
      name
      icon
    }
    lesson {
      course {
        subject {
          id
          name
        }
      }
    }
  }
}
    `;
export const StudentOrParentTeacherFragmentDoc = gql`
    fragment Teacher on teachers {
  id
  user {
    full_name
  }
}
    `;
export const StudentOrParentLessonFragmentDoc = gql`
    fragment Lesson on lessons {
  id
  start_at
  start_date
  course {
    id
    subject {
      id
      name
    }
    course_teachers {
      teacher {
        ...Teacher
      }
    }
  }
  description
}
    ${StudentOrParentTeacherFragmentDoc}`;
export const StudentOrParentMarkFragmentDoc = gql`
    fragment Mark on marks {
  name
  value
}
    `;
export const StudentOrParentMessageFragmentDoc = gql`
    fragment Message on chat_messages {
  id
  body
  user_id
  chat_id
  is_pinned
  created_at
  replys {
    id
    body
    user_id
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  likes: chat_message_likes {
    id
    chat_message_id
    chat_like_user {
      id
      first_name
      full_name
    }
  }
  responding: chat_message {
    id
    body
    user_id
    chat_id
    is_pinned
    created_at
    user {
      first_name
      last_name
      avatar_url
    }
  }
  user {
    first_name
    last_name
    avatar_url
  }
}
    `;
export const StudentOrParentMessageAggregateFragmentDoc = gql`
    fragment MessageAggregate on chat_messages_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentOrParentPhoneNumberFragmentDoc = gql`
    fragment PhoneNumber on private_phone_numbers {
  country_code
  number
  created_at
  updated_at
}
    `;
export const StudentOrParentPrivateChatFragmentDoc = gql`
    fragment PrivateChat on chats {
  id
  unread_messages
  participants: chat_users {
    user {
      id
      full_name
      avatar_url
    }
  }
}
    `;
export const StudentOrParentSemesterFragmentDoc = gql`
    fragment Semester on semesters {
  id
  start_at
  end_at
}
    `;
export const StudentOrParentStudentFragmentDoc = gql`
    fragment Student on students {
  id
  user {
    avatar_url
    full_name
  }
}
    `;
export const StudentOrParentSubjectFragmentDoc = gql`
    fragment Subject on subjects {
  id
  name
  icon
}
    `;
export const StudentOrParentTaskFragmentDoc = gql`
    fragment Task on tasks {
  id
  body
  title
  is_completed
}
    `;
export const StudentOrParentTasksAggregateFragmentDoc = gql`
    fragment TasksAggregate on tasks_aggregate {
  aggregate {
    count
  }
}
    `;
export const StudentOrParentUserFragmentDoc = gql`
    fragment User on UserData {
  id
  last_name
  first_name
  email
  birthday_at
  avatar_url
  mobile
  street_address
  title
  role
  is_verified
  assignments
  live_class
  grading
  chat
}
    `;
export const StudentOrParentYearFragmentDoc = gql`
    fragment Year on years {
  id
  name
  start_date
  end_date
}
    `;
export const StudentOrParentExpandedSemesterGradeFragmentDoc = gql`
    fragment ExpandedSemesterGrade on subjects {
  id
  name
  icon
  statistics(where: {semester_id: {_eq: $semester_id}}) {
    max
    min
    avg
  }
  grades: view_grades_aggregate(where: {semester_id: {_eq: $semester_id}}) {
    aggregate {
      max {
        value
      }
    }
  }
  parent_types: grade_types(
    where: {grade_type: {grade_type_id: {_is_null: true}}}
  ) {
    parent_type: grade_type {
      id
      name
      grades: view_grades_aggregate(where: {semester_id: {_eq: $semester_id}}) {
        aggregate {
          avg {
            value
          }
        }
      }
      child_types: grade_types {
        id
        name
        grades: view_grades_aggregate(
          where: {semester_id: {_eq: $semester_id}, grade_type: {}}
        ) {
          aggregate {
            avg {
              value
            }
          }
        }
      }
    }
  }
}
    `;
export const StudentOrParentSemesterGradeFragmentDoc = gql`
    fragment SemesterGrade on subjects {
  id
  name
  icon
  aggregation: view_grades_aggregate(
    where: {semester: {start_at: {_lte: "now()"}, end_at: {_gte: "now()"}}}
  ) {
    aggregate {
      avg {
        value
      }
    }
  }
}
    `;
export const StudentOrParentActivityLatestDocument = gql`
    query ActivityLatest($limit: Int = 9, $offset: Int = 0) {
  assignmentsTotalCount: assignments_aggregate {
    aggregate {
      count
    }
  }
  assignments: assignments(limit: $limit, offset: $offset) {
    ...Assignment
  }
  grades_aggregate {
    aggregate {
      count
    }
  }
  grades: grades(limit: $limit, offset: $offset) {
    ...Grade
  }
}
    ${StudentOrParentAssignmentFragmentDoc}
${StudentOrParentGradeFragmentDoc}`;

/**
 * __useActivityLatestQuery__
 *
 * To run a query within a React component, call `useActivityLatestQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityLatestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityLatestQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useActivityLatestQuery(baseOptions?: Apollo.QueryHookOptions<StudentOrParentActivityLatestQuery, StudentOrParentActivityLatestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentOrParentActivityLatestQuery, StudentOrParentActivityLatestQueryVariables>(StudentOrParentActivityLatestDocument, options);
      }
export function useActivityLatestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentOrParentActivityLatestQuery, StudentOrParentActivityLatestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentOrParentActivityLatestQuery, StudentOrParentActivityLatestQueryVariables>(StudentOrParentActivityLatestDocument, options);
        }
export type ActivityLatestQueryHookResult = ReturnType<typeof useActivityLatestQuery>;
export type ActivityLatestLazyQueryHookResult = ReturnType<typeof useActivityLatestLazyQuery>;
export type ActivityLatestQueryResult = Apollo.QueryResult<StudentOrParentActivityLatestQuery, StudentOrParentActivityLatestQueryVariables>;
export const StudentOrParentGradesBySemesterDocument = gql`
    query GradesBySemester($semester_id: uuid!) {
  subjects {
    ...ExpandedSemesterGrade
  }
}
    ${StudentOrParentExpandedSemesterGradeFragmentDoc}`;

/**
 * __useGradesBySemesterQuery__
 *
 * To run a query within a React component, call `useGradesBySemesterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradesBySemesterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradesBySemesterQuery({
 *   variables: {
 *      semester_id: // value for 'semester_id'
 *   },
 * });
 */
export function useGradesBySemesterQuery(baseOptions: Apollo.QueryHookOptions<StudentOrParentGradesBySemesterQuery, StudentOrParentGradesBySemesterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentOrParentGradesBySemesterQuery, StudentOrParentGradesBySemesterQueryVariables>(StudentOrParentGradesBySemesterDocument, options);
      }
export function useGradesBySemesterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentOrParentGradesBySemesterQuery, StudentOrParentGradesBySemesterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentOrParentGradesBySemesterQuery, StudentOrParentGradesBySemesterQueryVariables>(StudentOrParentGradesBySemesterDocument, options);
        }
export type GradesBySemesterQueryHookResult = ReturnType<typeof useGradesBySemesterQuery>;
export type GradesBySemesterLazyQueryHookResult = ReturnType<typeof useGradesBySemesterLazyQuery>;
export type GradesBySemesterQueryResult = Apollo.QueryResult<StudentOrParentGradesBySemesterQuery, StudentOrParentGradesBySemesterQueryVariables>;
export const StudentOrParentGradesCurrentSemesterDocument = gql`
    query GradesCurrentSemester {
  subjects {
    ...SemesterGrade
  }
}
    ${StudentOrParentSemesterGradeFragmentDoc}`;

/**
 * __useGradesCurrentSemesterQuery__
 *
 * To run a query within a React component, call `useGradesCurrentSemesterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradesCurrentSemesterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradesCurrentSemesterQuery({
 *   variables: {
 *   },
 * });
 */
export function useGradesCurrentSemesterQuery(baseOptions?: Apollo.QueryHookOptions<StudentOrParentGradesCurrentSemesterQuery, StudentOrParentGradesCurrentSemesterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentOrParentGradesCurrentSemesterQuery, StudentOrParentGradesCurrentSemesterQueryVariables>(StudentOrParentGradesCurrentSemesterDocument, options);
      }
export function useGradesCurrentSemesterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentOrParentGradesCurrentSemesterQuery, StudentOrParentGradesCurrentSemesterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentOrParentGradesCurrentSemesterQuery, StudentOrParentGradesCurrentSemesterQueryVariables>(StudentOrParentGradesCurrentSemesterDocument, options);
        }
export type GradesCurrentSemesterQueryHookResult = ReturnType<typeof useGradesCurrentSemesterQuery>;
export type GradesCurrentSemesterLazyQueryHookResult = ReturnType<typeof useGradesCurrentSemesterLazyQuery>;
export type GradesCurrentSemesterQueryResult = Apollo.QueryResult<StudentOrParentGradesCurrentSemesterQuery, StudentOrParentGradesCurrentSemesterQueryVariables>;